import React from 'react';
type IconProps = {
  className?: string;
};
const BriefcaseBusinessIcon = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path d='M12 12h.01' />
      <path d='M16 6V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2' />
      <path d='M22 13a18.15 18.15 0 0 1-20 0' />
      <rect width='20' height='14' x='2' y='6' rx='2' />
    </svg>
  );
};

const UsersIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path d='M18 21a8 8 0 0 0-16 0' />
      <circle cx='10' cy='8' r='5' />
      <path d='M22 20c0-3.37-2-6.5-4-8a5 5 0 0 0-.45-8.3' />
    </svg>
  );
};
const MagicIcons = (props: IconProps) => {
  return (
    <svg
        className={props.className}
        fill='none'
        stroke='currentColor'
        viewBox='0 0 24 24'
    >
      <path
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
          d='M19.428 15.428a2 2 0 00-1.022-.547l-2.384-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z'
      ></path>
    </svg>
  );
};
const LightningIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth={2}
          d='M13 10V3L4 14h7v7l9-11h-7z'
      />
    </svg>
  );
};
const TestNoteIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth={2}
          d='M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z'
      />
    </svg>
  );
};

const CircleCheckIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path d='M21.801 10A10 10 0 1 1 17 3.335' />
      <path d='m9 11 3 3L22 4' />
    </svg>
  );
};
const CircleXIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <circle cx='12' cy='12' r='10' />
      <path d='m15 9-6 6' />
      <path d='m9 9 6 6' />
    </svg>
  );
};

const StarIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path d='M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z' />
    </svg>
  );
};
const ClipBoardIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <rect width='8' height='4' x='8' y='2' rx='1' ry='1' />
      <path d='M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2' />
      <path d='M12 11h4' />
      <path d='M12 16h4' />
      <path d='M8 11h.01' />
      <path d='M8 16h.01' />
    </svg>
  );
};
const CalendarClockIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path d='M21 7.5V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h3.5' />
      <path d='M16 2v4' />
      <path d='M8 2v4' />
      <path d='M3 10h5' />
      <path d='M17.5 17.5 16 16.3V14' />
      <circle cx='16' cy='16' r='6' />
    </svg>
  );
};
const AddCircleIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <circle cx='12' cy='12' r='10' />
      <path d='M8 12h8' />
      <path d='M12 8v8' />
    </svg>
  );
};
const SubtractCircleIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path d='M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z' />
      <path d='M8 12H16' />
    </svg>
  );
};

const FilterIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path d='M10 20a1 1 0 0 0 .553.895l2 1A1 1 0 0 0 14 21v-7a2 2 0 0 1 .517-1.341L21.74 4.67A1 1 0 0 0 21 3H3a1 1 0 0 0-.742 1.67l7.225 7.989A2 2 0 0 1 10 14z' />
    </svg>
  );
};
const SearchIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <circle cx='11' cy='11' r='8' />
      <path d='m21 21-4.3-4.3' />{ ' ' }
    </svg>
  );
};
const BarMenuIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth={2}
          d='M6 18L18 6M6 6l12 12'
      />
    </svg>
  );
};
const ArrowUpIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path d='m5 12 7-7 7 7' />
      <path d='M12 19V5' />
    </svg>
  );
};
const ChevronDownIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path d='m6 9 6 6 6-6' />
    </svg>
  );
};
const PaperClipIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path d='M13.234 20.252 21 12.3' />
      <path d='m16 6-8.414 8.586a2 2 0 0 0 0 2.828 2 2 0 0 0 2.828 0l8.414-8.586a4 4 0 0 0 0-5.656 4 4 0 0 0-5.656 0l-8.415 8.585a6 6 0 1 0 8.486 8.486' />{ ' ' }
    </svg>
  );
};
const LinkIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path d='M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71' />
      <path d='M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71' />
    </svg>
  );
};
const ImageIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <rect width='18' height='18' x='3' y='3' rx='2' ry='2' />
      <circle cx='9' cy='9' r='2' />
      <path d='m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21' />
    </svg>
  );
};
const BoldIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path d='M6 12h9a4 4 0 0 1 0 8H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h7a4 4 0 0 1 0 8' />
    </svg>
  );
};
const ItalicIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <line x1='19' x2='10' y1='4' y2='4' />
      <line x1='14' x2='5' y1='20' y2='20' />
      <line x1='15' x2='9' y1='4' y2='20' />{ ' ' }
    </svg>
  );
};
const UnderlineIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path d='M6 4v6a6 6 0 0 0 12 0V4' />
      <line x1='4' x2='20' y1='20' y2='20' />
    </svg>
  );
};
const StrikethroughIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path d='M16 4H9a3 3 0 0 0-2.83 4' />
      <path d='M14 12a4 4 0 0 1 0 8H6' />
      <line x1='4' x2='20' y1='12' y2='12' />
    </svg>
  );
};
const NumberListIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path d='M10 12h11' />
      <path d='M10 18h11' />
      <path d='M10 6h11' />
      <path d='M4 10h2' />
      <path d='M4 6h1v4' />
      <path d='M6 18H4c0-1 2-2 2-3s-1-1.5-2-1' />
    </svg>
  );
};
const ListIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path d='M3 12h.01' />
      <path d='M3 18h.01' />
      <path d='M3 6h.01' />
      <path d='M8 12h13' />
      <path d='M8 18h13' />
      <path d='M8 6h13' />
    </svg>
  );
};
const BellIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path d='M10.268 21a2 2 0 0 0 3.464 0' />
      <path d='M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326' />
    </svg>
  );
};

const SettingsIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path d='M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z' />
      <circle cx='12' cy='12' r='4' />
    </svg>
  );
};
const RefreshListIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path d='M21 6H3' />
      <path d='M7 12H3' />
      <path d='M7 18H3' />
      <path d='M12 18a5 5 0 0 0 9-3 4.5 4.5 0 0 0-4.5-4.5c-1.33 0-2.54.54-3.41 1.41L11 14' />
      <path d='M11 10v4h4' />
    </svg>
  );
};
const MorevertIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <circle cx='12' cy='12' r='1' />
      <circle cx='12' cy='5' r='1' />
      <circle cx='12' cy='19' r='1' />
    </svg>
  );
};
const FileQuestionIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path d='M12 17h.01' />
      <path d='M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7z' />
      <path d='M9.1 9a3 3 0 0 1 5.82 1c0 2-3 3-3 3' />
    </svg>
  );
};
const DashboardIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <rect width='7' height='9' x='3' y='3' rx='1' />
      <rect width='7' height='5' x='14' y='3' rx='1' />
      <rect width='7' height='9' x='14' y='12' rx='1' />
      <rect width='7' height='5' x='3' y='16' rx='1' />
    </svg>
  );
};
const ChartIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path d='M12 16v5' />
      <path d='M16 14v7' />
      <path d='M20 10v11' />
      <path d='m22 3-8.646 8.646a.5.5 0 0 1-.708 0L9.354 8.354a.5.5 0 0 0-.707 0L2 15' />
      <path d='M4 18v3' />
      <path d='M8 14v7' />
    </svg>
  );
};
const FilePlusIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path d='M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4' />
      <path d='M14 2v4a2 2 0 0 0 2 2h4' />
      <path d='M3 15h6' />
      <path d='M6 12v6' />
    </svg>
  );
};
const AlignLeftIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path d='M15 12H3' />
      <path d='M17 18H3' />
      <path d='M21 6H3' />
    </svg>
  );
};
const MegaPhoneIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path d='m3 11 18-5v12L3 14v-3z' />
      <path d='M11.6 16.8a3 3 0 1 1-5.8-1.6' />
    </svg>
  );
};
const SparklesIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path d='M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z' />
      <path d='M20 3v4' />
      <path d='M22 5h-4' />
      <path d='M4 17v2' />
      <path d='M5 18H3' />
    </svg>
  );
};
const BadgeCheckIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path d='M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z' />
      <path d='m9 12 2 2 4-4' />
    </svg>
  );
};
const SlidersHorizontalIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <line x1='21' x2='14' y1='4' y2='4' />
      <line x1='10' x2='3' y1='4' y2='4' />
      <line x1='21' x2='12' y1='12' y2='12' />
      <line x1='8' x2='3' y1='12' y2='12' />
      <line x1='21' x2='16' y1='20' y2='20' />
      <line x1='12' x2='3' y1='20' y2='20' />
      <line x1='14' x2='14' y1='2' y2='6' />
      <line x1='8' x2='8' y1='10' y2='14' />
      <line x1='16' x2='16' y1='18' y2='22' />
    </svg>
  );
};
const FileDownIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path d='M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z' />
      <path d='M14 2v4a2 2 0 0 0 2 2h4' />
      <path d='M12 18v-6' />
      <path d='m9 15 3 3 3-3' />
    </svg>
  );
};
const ShieldAlertIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path d='M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z' />
      <path d='M12 8v4' />
      <path d='M12 16h.01' />
    </svg>
  );
};
const ListCheckIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path d='m3 17 2 2 4-4' />
      <path d='m3 7 2 2 4-4' />
      <path d='M13 6h8' />
      <path d='M13 12h8' />
      <path d='M13 18h8' />
    </svg>
  );
};

const BrainIcon = (props: IconProps) => {
  return (
      <svg
          xmlns="http://www.w3.org/2000/svg"
          className={props.className}
          width="200"
          height="200"
          viewBox="0 0 512 512"
          aria-hidden="true"
          role="img"
          fill="currentColor"   // ✅ was "#adadad"
          stroke="currentColor" // ✅ was "#adadad"
          strokeWidth="10"
      >
        <g>
          <path d="M410.34,153.043c-1.278-1.293-2.712-2.477-4.288-3.527l-1.615-0.337c-0.846-0.368-1.52-0.972-1.96-1.702 c-2.524-1.191-5.166-1.959-7.854-2.343c-2.321-0.322-3.951-2.477-3.614-4.814c0.313-2.336,2.484-3.966,4.805-3.645 c2.658,0.392,5.322,1.067,7.878,2.07c0.415-1.866,0.65-3.771,0.65-5.691c-0.008-4.202-0.995-8.443-3.096-12.433 c-2.399-4.562-5.918-8.121-10.034-10.55c-3.606-2.132-7.682-3.402-11.868-3.7c-0.305,3.817-1.214,7.619-2.798,11.303 c-0.941,2.163-3.441,3.159-5.612,2.226c-2.164-0.925-3.167-3.433-2.234-5.597c1.52-3.55,2.234-7.203,2.25-10.825l-0.055-1.544 c-0.29-5.017-1.952-9.861-4.782-13.992c-2.83-4.124-6.796-7.502-11.734-9.642c-3.543-1.513-7.212-2.226-10.826-2.226 c-6.922,0-13.624,2.666-18.687,7.368c0.948,3.222,1.489,6.616,1.489,10.144c0,2.352-1.928,4.264-4.28,4.264 s-4.272-1.912-4.272-4.264c0-3.457-0.635-6.734-1.795-9.783h0.008c-1.968-5.134-5.448-9.555-9.908-12.675 c-4.445-3.119-9.83-4.946-15.693-4.946c-5.087,0-9.83,1.388-13.906,3.786c-3.261,1.928-6.075,4.531-8.285,7.588 c4.319,5.918,6.874,13.232,6.874,21.118c0,2.351-1.92,4.256-4.28,4.256c-2.352,0-4.272-1.905-4.272-4.256 c0-6.929-2.548-13.232-6.788-18.053c-5.032-5.746-12.377-9.343-20.608-9.343c-5.714,0-10.974,1.732-15.372,4.711 c-4.382,2.979-7.87,7.196-9.932,12.15c-1.332,3.237-2.093,6.804-2.093,10.535c0,2.351-1.905,4.256-4.264,4.256 c-2.36,0-4.264-1.905-4.264-4.256c0-3.465,0.502-6.804,1.411-9.987c-3.214-1.301-6.694-2.022-10.268-2.022 c-2.03,0-4.068,0.235-6.138,0.698c-6.083,1.403-11.17,4.68-14.894,9.116c-2.681,3.199-4.594,7-5.589,11.084 c8.819,0.156,17.629,3.566,24.434,10.229c1.678,1.654,1.709,4.351,0.063,6.028c-1.654,1.693-4.351,1.709-6.036,0.07 c-5.346-5.212-12.236-7.823-19.166-7.831c-1.238,0-2.477,0.086-3.716,0.243h-0.015h-0.008c-5.808,0.807-11.405,3.456-15.85,7.988 c-5.221,5.33-7.808,12.213-7.815,19.158c0,3.959,0.862,7.948,2.586,11.617c1.34,2.892,3.222,5.589,5.652,7.956v0.007 c2.744,2.697,5.911,4.688,9.29,5.989c2.186,0.855,3.292,3.324,2.43,5.518c-0.854,2.211-3.316,3.309-5.518,2.446 c-4.413-1.709-8.583-4.326-12.19-7.862c-1.575-1.552-2.979-3.206-4.224-4.961c-3.222,4.617-4.97,10.142-4.97,15.771 c0,4.359,1.043,8.756,3.245,12.887c2.477,4.625,6.06,8.231,10.277,10.692c3.331,1.952,7.055,3.183,10.896,3.614l-0.008-0.259 c0-2.258,0.212-4.468,0.596-6.616c0.439-2.32,2.673-3.834,4.978-3.418c2.32,0.431,3.849,2.657,3.433,4.977 c-0.306,1.638-0.47,3.339-0.47,5.056l0.07,1.984l0.227,1.999v0.023l0.008,0.039c1.96,13.389,13.53,23.398,27.075,23.398 l1.968-0.078h0.008c6.004-0.431,11.397-2.752,15.677-6.365c3.002-2.532,5.463-5.706,7.149-9.282 c0.995-2.14,3.558-3.048,5.683-2.038c2.132,1.004,3.042,3.543,2.038,5.676c-1.826,3.849-4.319,7.321-7.313,10.276 c1.677,5.158,4.828,9.587,8.944,12.879c4.704,3.771,10.637,5.997,17.049,5.997l1.976-0.078h0.008 c4.06-0.29,7.815-1.458,11.147-3.277c-0.518-2.453-0.815-4.961-0.815-7.501c0-5.237,1.168-10.575,3.582-15.592 c1.027-2.124,3.574-3.01,5.691-1.983c2.124,1.011,3.026,3.567,1.999,5.691c-1.858,3.849-2.728,7.894-2.728,11.884 c0,2.79,0.431,5.573,1.262,8.214h0.008c2.187,6.969,7.126,13.06,14.235,16.477c3.841,1.858,7.886,2.728,11.868,2.728 c6.326,0,12.511-2.211,17.418-6.216l0.016-0.008c2.979-2.454,5.472-5.558,7.266-9.266l0.008-0.016 c1.67-3.464,2.548-7.093,2.696-10.715c0.11-2.352,2.093-4.186,4.46-4.076c2.352,0.102,4.17,2.092,4.068,4.444 c-0.204,4.75-1.356,9.547-3.543,14.07v-0.008c-1.756,3.661-4.068,6.883-6.78,9.634c5.032,7.227,13.404,11.782,22.458,11.774 c1.677,0,3.386-0.156,5.103-0.486c6.592-1.238,12.15-4.727,16.101-9.524c3.943-4.806,6.24-10.912,6.24-17.356l-0.008-0.579v-0.032 c-0.031-1.45-0.18-2.97-0.462-4.5c-0.682-3.629-2.07-6.922-3.974-9.83c-2.759-2.43-5.824-5.604-8.716-9.132 c-3.081-3.762-5.918-7.878-7.823-12.024c-1.254-2.775-2.148-5.581-2.164-8.536c0-1.309,0.18-2.665,0.674-3.966 c0.478-1.325,1.262-2.579,2.312-3.614c1.662-1.654,4.358-1.654,6.028,0c1.662,1.677,1.662,4.389,0,6.044l-0.322,0.51l-0.164,1.027 c-0.016,1.074,0.431,2.893,1.395,4.985c0.956,2.086,2.375,4.429,4.045,6.741c3.308,4.633,7.596,9.18,10.825,11.954l0.439,0.377 l0.322,0.478c2.642,3.935,4.578,8.466,5.51,13.412v0.008l0.306,2.116l1.278,0.055c5.409-0.008,10.856-1.607,15.646-4.97 c3.81-2.681,6.71-6.122,8.67-9.987c1.967-3.872,2.994-8.152,2.994-12.463c0-4.037-0.91-8.09-2.728-11.86 c-1.686,0.541-3.395,0.972-5.127,1.27c-2.32,0.415-4.523-1.161-4.938-3.48c-0.393-2.328,1.176-4.523,3.496-4.931 c7.556-1.301,14.478-5.706,18.758-12.777c2.712-4.444,3.99-9.336,3.99-14.172c0-7.126-2.752-14.094-7.878-19.26L410.34,153.043z M214.788,120.481c4.076-4.821,9.485-8.247,15.301-10.489c5.84-2.242,12.095-3.316,18.1-3.316 c5.84,0.008,11.452,0.996,16.218,3.207c2.132,0.971,3.065,3.519,2.077,5.659c-0.98,2.133-3.512,3.073-5.667,2.086 c-3.292-1.544-7.8-2.43-12.628-2.43c-4.97,0-10.268,0.916-15.027,2.767c-4.758,1.826-8.936,4.554-11.876,8.019 c-1.505,1.803-4.209,2.038-6.012,0.502C213.479,124.965,213.252,122.276,214.788,120.481z M311.925,221.396 c-4.962,0-9.462-0.564-13.569-1.512c0.11,1.175,0.188,2.484,0.188,3.872c0,2.783-0.306,5.964-1.176,9.304 c-0.878,3.331-2.359,6.835-4.695,10.198c-1.34,1.944-3.998,2.422-5.934,1.081c-1.944-1.341-2.414-3.99-1.09-5.942 c1.724-2.485,2.798-5.025,3.457-7.525c0.659-2.5,0.902-4.931,0.902-7.117c0.008-3.018-0.455-5.503-0.784-6.922 c-2.085-0.941-4.006-1.999-5.8-3.183c-7.149-4.625-11.93-10.731-14.933-16.54c-2.014-3.896-3.238-7.658-3.896-10.927 c-0.376-1.866-0.564-3.558-0.564-5.096c0-2.367,1.913-4.28,4.272-4.28c2.359,0,4.272,1.913,4.272,4.28 c-0.008,1.238,0.259,3.316,0.933,5.676c0.674,2.367,1.748,5.056,3.3,7.76c3.112,5.44,8.058,10.888,15.693,14.424 c5.103,2.367,11.452,3.903,19.424,3.903c2.359,0,4.272,1.913,4.272,4.272C316.197,219.484,314.285,221.396,311.925,221.396z M341.979,190.229c-0.878,2.18-3.363,3.246-5.558,2.375c-2.187-0.878-3.237-3.347-2.375-5.534v-0.008l0.024-0.063l0.126-0.376 l0.439-1.536c0.322-1.348,0.651-3.253,0.651-5.346l-0.008-0.298c-5.863,1.991-11.303,2.884-16.312,2.884 c-7.572,0.016-14.125-2.061-19.456-5.212c-5.338-3.15-9.492-7.321-12.597-11.562c-3.527-4.805-8.152-9.116-13.451-12.165 c-5.314-3.058-11.256-4.876-17.566-4.892c-5.526,0.016-11.405,1.395-17.543,4.766c-5.824,3.198-9.571,7.454-11.993,12.126 c-2.406,4.68-3.425,9.79-3.418,14.447c-0.016,4.311,0.894,8.214,2.077,10.676c1.011,2.132,0.094,4.672-2.03,5.683 c-2.124,1.012-4.672,0.094-5.683-2.03c-1.858-3.936-2.892-8.89-2.908-14.329c0.008-5.409,1.082-11.32,3.724-16.971 c-5.298,1.2-10.221,1.733-14.705,1.733c-2.422,0-4.704-0.157-6.875-0.439l-0.792,1.599l-0.008,0.015l-0.063,0.064l-0.227,0.29 l-0.91,1.238c-0.776,1.114-1.85,2.736-3.018,4.805c-2.328,4.1-4.993,9.885-6.287,16.382c-0.462,2.313-2.704,3.826-5.017,3.355 c-2.312-0.462-3.818-2.704-3.339-5.032c1.536-7.706,4.571-14.259,7.212-18.923c1.379-2.414,2.642-4.326,3.566-5.628 c-3.48-1.042-6.49-2.32-8.951-3.622c-5.62-2.987-8.545-5.981-8.795-6.224c-1.631-1.701-1.584-4.398,0.109-6.036 c1.701-1.63,4.39-1.583,6.028,0.094l0.048,0.047l0.25,0.243l1.223,1.026c1.112,0.878,2.83,2.086,5.126,3.308 c4.609,2.43,11.492,4.892,20.718,4.908c6.482,0,14.125-1.238,23.006-4.656c2.25-2.093,4.844-4.005,7.823-5.636 c7.306-4.005,14.666-5.808,21.65-5.808c7.98,0,15.403,2.321,21.831,6.02c6.428,3.716,11.876,8.803,16.069,14.525 c2.548,3.456,5.895,6.804,10.042,9.241c4.17,2.446,9.1,4.038,15.128,4.045c4.131,0,8.787-0.768,14.055-2.618 c-1.285-2.062-3.198-4.053-6.349-5.856c-2.054-1.168-2.783-3.77-1.623-5.816c1.168-2.062,3.763-2.768,5.816-1.623 c5.048,2.846,8.427,6.616,10.386,10.559c1.983,3.927,2.571,7.909,2.571,11.296C343.797,185.652,342.096,189.924,341.979,190.229z M340.38,137.938c-9.971,0-18.695-2.689-25.75-6.757c-0.995,1.38-2.328,3.112-4.045,4.993c-3.864,4.241-9.54,9.219-17.135,11.946 c-2.234,0.784-4.664-0.36-5.456-2.586c-0.792-2.227,0.376-4.664,2.579-5.448c5.605-1.999,10.292-5.926,13.538-9.477 c1.505-1.623,2.673-3.159,3.52-4.335c-4.21-3.558-7.533-7.611-9.814-11.781c-2.163-3.998-3.418-8.121-3.433-12.127 c0-2.351,1.913-4.264,4.272-4.264c2.352,0,4.264,1.913,4.264,4.264c-0.016,2.156,0.737,5.033,2.398,8.051 c1.638,3.025,4.131,6.176,7.392,8.999c6.522,5.652,15.936,9.978,27.671,9.978c2.359,0,4.264,1.921,4.264,4.28 C344.644,136.025,342.739,137.938,340.38,137.938z M374.023,198.037c-1.497,1.803-4.194,2.069-6.012,0.556 c-1.818-1.497-2.069-4.193-0.58-6.004c4.656-5.652,6.373-11.343,6.388-16.79c0.016-4.962-1.505-9.752-3.888-13.788 c-2.352-4.03-5.604-7.259-8.732-9.054c-2.101-1.207-4.076-1.748-5.644-1.748c-2.36,0-4.264-1.904-4.264-4.264 c0-2.359,1.905-4.272,4.264-4.272c2.594,0,5.134,0.635,7.549,1.701c2.406,1.051,4.68,2.548,6.796,4.375 c4.225,3.652,7.815,8.622,10.073,14.447c1.489,3.887,2.398,8.152,2.398,12.604C382.379,183.12,379.879,190.958,374.023,198.037z" />
          <path d="M172.459,411.86l0.291,0.259c-0.008-0.008-0.008-0.008-0.016-0.016L172.459,411.86z" />
          <path d="M428.699,66.574C396.943,29.442,349.183,4.155,287.986,0.462C283.008,0.156,278.054,0,273.147,0 c-51.469,0-98.815,16.712-133.524,47.393c-34.733,30.602-56.36,75.408-56.282,129.072c0,1.215,0.008,2.43,0.031,3.653l-0.054,6.474 l-44.179,78.018c-2.375,4.209-3.575,8.905-3.575,13.601c0,3.918,0.832,7.854,2.516,11.522c3.567,7.784,10.582,13.381,18.891,15.309 l-0.016,0.07l20.318,5.597l8.027,77.423l0.063-0.008c0.565,11.28,5.597,21.87,14.142,29.301 c7.596,6.616,17.292,10.206,27.263,10.206c1.01,0,2.006-0.094,3.01-0.164l23.022,1.826l1.153-0.125l0.368-0.016 c0.885,0,1.709,0.314,2.344,0.886l0.038,0.04c0.73,0.658,1.161,1.622,1.161,2.61V512h214.96v-12.04c0,0,0-32.616,0-45.628 c-0.024-5.237,1.019-15.591,3.073-25.578c1.019-5.008,2.28-10.002,3.708-14.32c1.411-4.311,3.042-7.98,4.405-10.12 c14.298-23.046,34.514-41.952,53.028-68.69c18.492-26.714,34.255-61.369,38.574-113.951c0.549-6.592,0.824-13.185,0.824-19.745 C476.436,152.079,460.508,103.674,428.699,66.574z M451.611,219.664c-4.178,48.875-17.849,78.12-34.405,102.303 c-16.531,24.159-36.974,43.152-53.616,69.577c-2.9,4.672-5.025,9.846-6.851,15.348c-2.712,8.239-4.648,17.222-5.973,25.586 c-1.317,8.387-2.014,15.991-2.022,21.854c0,8.356,0,20.992,0,33.588H181.944v-55.231c0-7.847-3.339-15.317-9.188-20.56 c-5.103-4.586-11.687-7.063-18.436-7.063c-0.494,0-0.972,0.054-1.458,0.086l-22.998-1.834l-1.129,0.125l-1.967,0.11 c-4.186,0-8.262-1.513-11.453-4.288c-3.684-3.206-5.864-7.815-6.005-12.714l-0.007-0.454l-9.767-94.221l-36.607-10.096 l-0.439-0.086c-1.113-0.22-2.045-0.957-2.524-1.992l-0.322-1.489l0.455-1.74l47.251-83.443l0.102-13.036v-0.173 c-0.023-1.128-0.031-2.242-0.031-3.354c0.079-47.251,18.444-84.658,48.153-111.035c29.74-26.315,71.27-41.35,117.573-41.35 c4.413,0,8.866,0.141,13.35,0.416l0.744-12.017l-0.737,12.017c55.443,3.488,96.252,25.609,123.914,57.755 c27.616,32.17,41.938,74.898,41.938,119.674C452.356,207.812,452.113,213.73,451.611,219.664z" />
        </g>
      </svg>
  );
};

const GanttChartIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path d='M10 6h8' />
      <path d='M12 16h6' />
      <path d='M3 3v16a2 2 0 0 0 2 2h16' />
      <path d='M8 11h7' />
    </svg>
  );
};
const BuildingIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <rect width='16' height='20' x='4' y='2' rx='2' ry='2' />
      <path d='M9 22v-4h6v4' />
      <path d='M8 6h.01' />
      <path d='M16 6h.01' />
      <path d='M12 6h.01' />
      <path d='M12 10h.01' />
      <path d='M12 14h.01' />
      <path d='M16 10h.01' />
      <path d='M16 14h.01' />
      <path d='M8 10h.01' />
      <path d='M8 14h.01' />
    </svg>
  );
};
const PiramidIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path d='M2.5 16.88a1 1 0 0 1-.32-1.43l9-13.02a1 1 0 0 1 1.64 0l9 13.01a1 1 0 0 1-.32 1.44l-8.51 4.86a2 2 0 0 1-1.98 0Z' />
      <path d='M12 2v20' />
    </svg>
  );
};
const TableIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path d='M16 12H3' />
      <path d='M16 18H3' />
      <path d='M16 6H3' />
      <path d='M21 12h.01' />
      <path d='M21 18h.01' />
      <path d='M21 6h.01' />
    </svg>
  );
};
const LayoutGridIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <rect width='7' height='7' x='3' y='3' rx='1' />
      <rect width='7' height='7' x='14' y='3' rx='1' />
      <rect width='7' height='7' x='14' y='14' rx='1' />
      <rect width='7' height='7' x='3' y='14' rx='1' />
    </svg>
  );
};
const ShieldIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path d='M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z' />
      <path d='M6.376 18.91a6 6 0 0 1 11.249.003' />
      <circle cx='12' cy='11' r='4' />
    </svg>
  );
};
const HandShakeIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path d='m11 17 2 2a1 1 0 1 0 3-3' />
      <path d='m14 14 2.5 2.5a1 1 0 1 0 3-3l-3.88-3.88a3 3 0 0 0-4.24 0l-.88.88a1 1 0 1 1-3-3l2.81-2.81a5.79 5.79 0 0 1 7.06-.87l.47.28a2 2 0 0 0 1.42.25L21 4' />
      <path d='m21 3 1 11h-2' />
      <path d='M3 3 2 14l6.5 6.5a1 1 0 1 0 3-3' />
      <path d='M3 4h8' />
    </svg>
  );
};
const UserCheckIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path d='M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2' />
      <circle cx='9' cy='7' r='4' />
      <polyline points='16 11 18 13 22 9' />
    </svg>
  );
};
const EyeIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path d='M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0' />
      <circle cx='12' cy='12' r='3' />
    </svg>
  );
};
const EyeOffIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path d='M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49' />
      <path d='M14.084 14.158a3 3 0 0 1-4.242-4.242' />
      <path d='M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143' />
      <path d='m2 2 20 20' />
    </svg>
  );
};
const ComponentsIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path d='M15.536 11.293a1 1 0 0 0 0 1.414l2.376 2.377a1 1 0 0 0 1.414 0l2.377-2.377a1 1 0 0 0 0-1.414l-2.377-2.377a1 1 0 0 0-1.414 0z' />
      <path d='M2.297 11.293a1 1 0 0 0 0 1.414l2.377 2.377a1 1 0 0 0 1.414 0l2.377-2.377a1 1 0 0 0 0-1.414L6.088 8.916a1 1 0 0 0-1.414 0z' />
      <path d='M8.916 17.912a1 1 0 0 0 0 1.415l2.377 2.376a1 1 0 0 0 1.414 0l2.377-2.376a1 1 0 0 0 0-1.415l-2.377-2.376a1 1 0 0 0-1.414 0z' />
      <path d='M8.916 4.674a1 1 0 0 0 0 1.414l2.377 2.376a1 1 0 0 0 1.414 0l2.377-2.376a1 1 0 0 0 0-1.414l-2.377-2.377a1 1 0 0 0-1.414 0z' />
    </svg>
  );
};
const CommandIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path d='M15 6v12a3 3 0 1 0 3-3H6a3 3 0 1 0 3 3V6a3 3 0 1 0-3 3h12a3 3 0 1 0-3-3' />
    </svg>
  );
};
const UserSquareIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <rect width='18' height='18' x='3' y='3' rx='2' />
      <circle cx='12' cy='10' r='3' />
      <path d='M7 21v-2a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2' />{ ' ' }
    </svg>
  );
};
const LayersIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path d='M12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83z' />
      <path d='M2 12a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 12' />
      <path d='M2 17a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 17' />
    </svg>
  );
};
const UserMinusIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path d='M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2' />
      <circle cx='9' cy='7' r='4' />
      <line x1='22' x2='16' y1='11' y2='11' />
    </svg>
  );
};
const ThreeDIcons = (props: IconProps) => {
  return (
    <svg
        width='16'
        height='16'
        viewBox='0 0 16 16'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        stroke='currentColor'
        strokeWidth='1'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path d='M14 5.33335C13.9998 5.09953 13.938 4.86989 13.821 4.66746C13.704 4.46503 13.5358 4.29692 13.3333 4.18002L8.66667 1.51335C8.46397 1.39633 8.23405 1.33472 8 1.33472C7.76595 1.33472 7.53603 1.39633 7.33333 1.51335L2.66667 4.18002C2.46418 4.29692 2.29599 4.46503 2.17897 4.66746C2.06196 4.86989 2.00024 5.09953 2 5.33335V10.6667C2.00024 10.9005 2.06196 11.1301 2.17897 11.3326C2.29599 11.535 2.46418 11.7031 2.66667 11.82L7.33333 14.4867C7.53603 14.6037 7.76595 14.6653 8 14.6653C8.23405 14.6653 8.46397 14.6037 8.66667 14.4867L13.3333 11.82C13.5358 11.7031 13.704 11.535 13.821 11.3326C13.938 11.1301 13.9998 10.9005 14 10.6667V5.33335Z' />
      <path d='M2.19995 4.66663L7.99995 7.99996L13.8 4.66663' />
      <path
          d='M8 14.6667V8'
          stroke='#093725'
          strokeLinecap='round'
          strokeLinejoin='round'
      />
    </svg>
  );
};
const SquigglyGridIcons = (props: IconProps) => {
  return (
    <svg
        width='16'
        height='16'
        viewBox='0 0 16 16'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        stroke='currentColor'
        strokeWidth='1'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path d='M2 2V12.6667C2 13.0203 2.14048 13.3594 2.39052 13.6095C2.64057 13.8595 2.97971 14 3.33333 14H14' />
      <path d='M4.66675 10.6667C5.00008 9.33337 5.66675 6.00004 7.33341 6.00004C8.66675 6.00004 8.66675 8.00004 10.0001 8.00004C11.6667 8.00004 13.0001 4.66671 13.3334 3.33337' />
    </svg>
  );
};
const EmailIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path d='m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7' />
      <rect x='2' y='4' width='20' height='16' rx='2' />
    </svg>
  );
};
const PhoneIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path d='M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384' />
    </svg>
  );
};

const MapPinIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path d='M19.43 12.935c.357-.967.57-1.955.57-2.935a8 8 0 0 0-16 0c0 4.993 5.539 10.193 7.399 11.799a1 1 0 0 0 1.202 0 32.197 32.197 0 0 0 .813-.728' />
      <circle cx='12' cy='10' r='3' />
      <path d='m16 18 2 2 4-4' />
    </svg>
  );
};
const VideoIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path d='m16 13 5.223 3.482a.5.5 0 0 0 .777-.416V7.87a.5.5 0 0 0-.752-.432L16 10.5' />
      <rect x='2' y='6' width='14' height='12' rx='2' />
    </svg>
  );
};
const UserPenIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path d='M2 21a8 8 0 0 1 10.821-7.487' />
      <path d='M21.378 16.626a1 1 0 0 0-3.004-3.004l-4.01 4.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z' />
      <circle cx='10' cy='8' r='5' />
    </svg>
  );
};
const MicIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path d='M12 19v3' />
      <path d='M19 10v2a7 7 0 0 1-14 0v-2' />
      <rect x='9' y='2' width='6' height='13' rx='3' />
    </svg>
  );
};
const NotebookIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path d='M13.4 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-7.4' />
      <path d='M2 6h4' />
      <path d='M2 10h4' />
      <path d='M2 14h4' />
      <path d='M2 18h4' />
      <path d='M21.378 5.626a1 1 0 1 0-3.004-3.004l-5.01 5.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z' />
    </svg>
  );
};

const SunIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <circle cx='12' cy='12' r='4' />
      <path d='M12 2v2' />
      <path d='M12 20v2' />
      <path d='m4.93 4.93 1.41 1.41' />
      <path d='m17.66 17.66 1.41 1.41' />
      <path d='M2 12h2' />
      <path d='M20 12h2' />
      <path d='m6.34 17.66-1.41 1.41' />
      <path d='m19.07 4.93-1.41 1.41' />
    </svg>
  );
};

const MoonIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path d='M18 5h4' />
      <path d='M20 3v4' />
      <path d='M20.985 12.486a9 9 0 1 1-9.473-9.472c.405-.022.617.46.402.803a6 6 0 0 0 8.268 8.268c.344-.215.825-.004.803.401' />
    </svg>
  );
};

const TrendingUpIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path d='M16 7h6v6' />
      <path d='m22 7-8.5 8.5-5-5L2 17' />
    </svg>
  );
};

const TargetIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <circle cx='12' cy='12' r='10' />
      <circle cx='12' cy='12' r='6' />
      <circle cx='12' cy='12' r='2' />
    </svg>
  );
};
const TagIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth={2}
          d='M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z'
      />
    </svg>
  );
};
const ClockIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth={2}
          d='M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z'
      />
    </svg>
  );
};
const InfoIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth={2}
          d='M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z'
      />
    </svg>
  );
};
const HomeIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth={2}
          d='M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6'
      />
    </svg>
  );
};
const OfficeIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth={2}
          d='M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4'
      />
    </svg>
  );
};
const UploadIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth={2}
          d='M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12'
      />
    </svg>
  );
};

const LinkedinIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path d='M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z' />
    </svg>
  );
};
const FacebookIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path d='M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z' />{ ' ' }
    </svg>
  );
};
const HireTalentIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke=''
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <rect
          x='6.12793'
          y='9.80396'
          width='6.53606'
          height='6.53606'
          rx='3.26803'
          fill='url(#pattern0_788_14)'
      />
      <rect width='4.59567' height='20.0167' fill='url(#pattern1_788_14)' />
      <rect
          x='14.2979'
          y='5.61694'
          width='4.39142'
          height='14.3998'
          fill='url(#pattern2_788_14)'
      />
      <rect
          x='9.08984'
          width='14.9104'
          height='4.59567'
          fill='url(#pattern3_788_14)'
      />
      <defs>
        <pattern
            id='pattern0_788_14'
            patternContentUnits='objectBoundingBox'
            width='1'
            height='1'
        >
          <use
              xlinkHref='#image0_788_14'
              transform='translate(-1.80991 -2.95313) scale(0.014456)'
          />
        </pattern>
        <pattern
            id='pattern1_788_14'
            patternContentUnits='objectBoundingBox'
            width='1'
            height='1'
        >
          <use
              xlinkHref='#image0_788_14'
              transform='matrix(0.0205597 0 0 0.00472034 -1.24076 -0.47449)'
          />
        </pattern>
        <pattern
            id='pattern2_788_14'
            patternContentUnits='objectBoundingBox'
            width='1'
            height='1'
        >
          <use
              xlinkHref='#image0_788_14'
              transform='matrix(0.021516 0 0 0.00656161 -4.55428 -1.04965)'
          />
        </pattern>
        <pattern
            id='pattern3_788_14'
            patternContentUnits='objectBoundingBox'
            width='1'
            height='1'
        >
          <use
              xlinkHref='#image0_788_14'
              transform='matrix(0.0063369 0 0 0.0205597 -0.992015 -2.06667)'
          />
        </pattern>
        <image
            id='image0_788_14'
            width='900'
            height='401'
            preserveAspectRatio='none'
            xlinkHref='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAA4QAAAGRCAIAAACyqOptAAAQAElEQVR4Aey9CbisV1XnvfZbdYY7JARpH7oVBVE+W5sWbZkaZEZth9YEp1ZkksHncYAo6KPdkiCjn7ZKAp8DMs+aSBJkCAkEQsgAZiBEpjAkBIJAkntv7nzOqdr7+6293vett8Z7zr1nqLpnFf9atfbaa6+99n+/Ve+qXeeGIvnDGXAGnAFnwBlwBpwBZ8AZ2CIGCvGHM+AMOAPOwCYx4NM4A86AM+AMDDLgxeggI952BpwBZ8AZcAacAWfAGdg0BjasGN20FfhEzoAz4Aw4A86AM+AMOAMzy4AXozO7dZ64M+AMOAM1A644A86AMzCzDHgxOrNb54k7A86AM+AMOAPOgDMw+wzMXjE6+5z7CpwBZ8AZcAacAWfAGXAGSga8GC2J8BdnwBlwBpyBYQbc4gw4A87ARjPgxehGM+zxnQFnwBlwBpwBZ8AZcAbGMuDFaE2NK86AM+AMOAPOgDPgDDgDm82AF6ObzbjP5ww4A86AMyDiHDgDzoAzUDLgxWhJhL84A86AM+AMOAPOgDPgDGw+A16MbjznPoMz4Aw4A86AM+AMOAPOwBgGvBgdQ4ybnQFnwBlwBmaRAc/ZGXAGZo0BL0Znbcc8X2fAGXAGnAFnwBlwBk4iBrwYneHN9NSdAWfAGXAGnAFnwBmYdQa8GJ31HfT8nQFnwBlwBjaDAZ/DGXAGNogBL0Y3iFgP6ww4A86AM+AMOAPOgDNwbAa8GD02R9vPw1fsDDgDzoAz4Aw4A87AJjHgxegmEe3TOAPOgDPgDDgDoxhwmzOw3RnwYnS7XwG+fmfAGXAGnAFnwBlwBraQAS9Gt5D87Te1r9gZcAacAWfAGXAGnIF+BrwY7efDW86AM+AMOAPOwMnBgK/CGZgRBrwYnZGN8jSdAWfAGXAGnAFnwBk4GRnwYvRk3NXttyZfsTPgDDgDzoAz4AzMKANejM7oxnnazoAz4Aw4A87A1jDgszoD68uAF6Pry6dHcwacAWfAGXAGnAFnwBlYAwNejK6BLHfdfgz4ip0BZ8AZcAacAWdgYxnwYnRj+fXozoAz4Aw4A86AM7A6BtxrmzLgxeg23XhftjPgDDgDzoAz4Aw4A9PAgBej07ALnsP2Y8BX7Aw4A86AM+AMOAOZAS9GMw0unAFnwBlwBpwBZ+BkZcDXNd0MeDE63fvj2TkDzoAz4Aw4A86AM3BSM+DF6Em9vb647ceAr9gZcAacAWfAGZgtBrwYna398mydAWfAGXAGnAFnYFoY8DzWhQEvRteFRg/iDDgDzoAz4Aw4A86AM3A8DHgxejys+RhnYPsx4Ct2BpwBZ8AZcAY2hAEvRjeEVg/qDDgDzoAz4Aw4A87A8TKwvcZ5Mbq99ttX6ww4A86AM+AMOAPOwFQx4MXoVG2HJ+MMbD8GfMXOgDPgDDgD25sBL0a39/776p0BZ8AZcAacAWdg+zAwlSv1YnQqt8WTcgacAWfAGXAGnAFnYHsw4MXo9thnX6UzsP0Y8BU7A86AM+AMzAQDXozOxDZ5ks6AM+AMOAPOgDPgDEwvAyeSmRejJ8Kej3UGnAFnwBlwBpwBZ8AZOCEGvBg9Ifp8sDPgDGw/BnzFzoAz4Aw4A+vJgBej68mmx3IGnAFnwBlwBpwBZ8AZWBMDE4vRNUVyZ2fAGXAGnAFnwBlwBpwBZ2CNDHgxukbC3N0ZcAacgQ1iwMM6A86AM7AtGfBidFtuuy/aGXAGnAFnwBlwBpyB6WBga4rR6Vi7Z+EMOAPOgDPgDDgDzoAzsMUMeDG6xRvg0zsDzoAzsNEMeHxnwBlwBqaZAS9Gp3l3PDdnwBlwBpwBZ8AZcAZOcgZOsmL0JN8tX54z4Aw4A86AM+AMOAMnGQNejJ5kG+rLcQacAWdg0xjwiZwBZ8AZWAcGvBhdBxI9hDPgDDgDzoAz4Aw4A87A8THgxejqeHMvZ8AZcAacAWfAGXAGnIENYMCL0Q0g1UM6A86AM+AMnAgDPtYZcAa2EwNejG6n3fa1OgPOgDPgDDgDzoAzMGUMeDG6xRvi0zsDzoAz4Aw4A86AM7CdGfBidDvvvq/dGXAGnIHtxYCv1hlwBqaQAS9Gp3BTPCVnwBlwBpwBZ8AZcAa2CwNejJ6sO+3rcgacAWfAGXAGnAFnYAYY8GJ0BjbJU3QGnAFnwBmYbgY8O2fAGTh+BrwYPX7ufKQz4Aw4A86AM+AMOAPOwAky4MXoCRK4/Yb7ip0BZ8AZcAacAWfAGVg/BrwYXT8uPZIz4Aw4A86AM7C+DHg0Z2AbMODF6DbYZF+iM+AMOAPOgDPgDDgD08qAF6PTujPbLy9fsTPgDDgDzoAz4AxsQwa8GN2Gm+5LdgacAWfAGdjuDPj6nYHpYcCL0enZC8/EGXAGnAFnwBlwBpyBbceAF6Pbbsu334J9xc6AM+AMOAPOgDMwvQx4MTq9e+OZOQPOgDPgDDgDs8aA5+sMrJkBL0bXTJkPcAacAWfAGXAGnAFnwBlYLwa8GF0vJj3O9mPAV+wMOAPOgDPgDDgDJ8yAF6MnTKEHcAacAWfAGXAGnIGNZsDjn7wMeDF68u6tr8wZcAacAWfAGXAGnIGpZ8CL0anfIk9w+zHgK3YGnAFnwBlwBrYPA16Mbp+99pU6A86AM+AMOAPOwCAD3t5yBrwY3fIt8AScAWfAGXAGnAFnwBnYvgx4Mbp9995Xvv0Y8BU7A86AM+AMOANTx4AXo1O3JZ6QM+AMOAPOgDPgDMw+A76C1TLgxehqmXI/Z8AZcAacAWfAGXAGnIF1Z8CL0XWn1AM6A9uPAV+xM+AMOAPOgDNwvAx4MXq8zPk4Z8AZcAacAWfAGXAGNp+Bk25GL0ZPui31BTkDzoAz4Aw4A86AMzA7DHgxOjt75Zk6A9uPAV+xM+AMOAPOwEnPgBejJ/0W+wKdAWfAGXAGnAFnwBk4NgNb5eHF6FYx7/M6A86AM+AMOAPOgDPgDIgXo34ROAPOwDZkwJfsDDgDzoAzMC0MeDE6LTvheTgDzoAz4Aw4A86AM3AyMnCMNXkxegyCvNsZcAacAWfAGXAGnAFnYOMY8GJ047j1yM6AM7D9GPAVOwPOgDPgDKyRAS9G10iYuzsDzoAz4Aw4A86AM+AMrB8Dx1+Mrl8OHskZcAacAWfAGXAGnAFnYJsyMK3FaBIBuilRlawjkkQp0REBNNVpM5+kUU+HDqyJAkzfOFlOwYthYCYzDsgBn2YTT/jsyWbf6nXbhdXI1cd0zwYDbBBoGFzdhgz4kp0BZ8AZOFkZmL5ilJtuDeokkLTKidLtSowSu7IiIC2LLKkisXZvKuM2rOnTrxOnRFXvMm8FcxUtjMkhaVaSkpbDXWbKvSuaGxFobxSYh+mQzC9ozEMDkBjZ0IQeoN1R4A2Yvl6SuQaw1sjN4asZ2/Qf1kdEgIXxsAjNUWZZvWzGXv2oVXqyjxnlJPWo3E5drkZS151md/O1iEfuc+EMOAPOgDPgDMwsA9NXjAaRIPowqVrBfTdIK5eAsSU0g4Q5kflu5MZcyPo8xsXRCkBn4L4PVKMgEE0yaEGoNWF2aamZVm7IRj2IDjS6JRNEMxGRgIZsiYAiSZBQKKBLeBQ8xfSUdZMBc4Gv0BXQK1jvoCy029xqqT7ZTgTtnqyrR55OVNrYyVJEPUVGSx0r0pM6e5LxD9IGA/1mWb2shzME1M0TUUK5q8QDOVK2VHYsKaVO7HZT6koK0MG1H4JMWi2DHM6AM+AMOAPOwLQzoDfv6cmRG2tXzxer6qKRWYhpLrVbqS28hvnl7lxKc0VYzC75ti0xCLfoUopgHAmpH9mfITWKIAoRaDHIwCM02kQnYbXgG1dastSWpaDzNpzWVbUZKXg1QWrOoNUwOQDmoViRTgelE8gjLAfh9LgbKFcKHJKUUlfL+DJvUh8EnviMkpLt/VI0viSCF2OlTq2zVDGFBymNiKbZyhrtRfY3STK6AQSfABnO5xjzcuAdhUuwdwyvFr4dAezrALLWujMKCufZBrMgA8fdndRKoeB/LJciVPTBrwX64k9n4EQY8LHOgDPgDGwxA8UWzz84fXmPx8zhT1k0BFoi3H85CuqG5WU5KHKwJfuD7AuyX0AxSmIcgQPqzxCplTxWLaMUIrT3S3EoyKFCDvSmw65pHBIBFH9JWlQRgpTNelj9pMVLNSMUtdupJUsiR/Iy7y4THlzd3dY7Ro7iYTCC+RwgQpBjS8k+TWmjmpb107k86vTIbRj0Yjw+eUBihq6IIIA4AKUCDvQeU+LQRCLsIekeBqF7NHQPh0TzkGDvHlCjHA62s50ViRyR6juixTeSavf91RlwBpwBZ8AZmE0Gpq0YFUqskMu6is9Cq1LSDCKcWrbDyoJcf2f6xN3yiX3y8bvk6r1y9b4SV+2TAWgvDoa92nv13XKNYZ9cMwCzZ2kxr7pbPnYwY79ceXeeZb98/ECJaw/JtXfLJ/elz++NR1pFp9iVZIdIu8p8/V8L0ehzBM7nfgFFoX9Ku5JWupK6hZahX1vpXHvHHTccOPiJu/d//OChqwdwIFtKefDqgwevPjBGHtx/dROH9mmzKQ9iAXuuVmWk3HPVgbsUB+80efWhOybim1cd/EYT1xz8xjUHvz4Gt2d7n7z60O01rjp0e41rDt5+zaGvjsJXrjk0Erdcc6hGv8PhW64ZRs/51jywlB8/fOvHD3/l40PymkM4NEDAQ7dehTx86zWHb72a3sMMVPzr4VuvPXTrtQdu/eS+W26880vLUnQkxSLo+4IrAOg14E9nwBlwBpwBZ2BWGSimKnFurCTUkhSSKHJyUfTHaH5+Xo6JM0jO/F594b/81bs+fM5Fnzj3omtfeeEnXnnhNeNwzoXXnHPhVTXOveCqv77gY+Ccd33slRd87JUXXlHjnIs+es6FildecDk458LLz7now6+86EN/deEHMz78ygs/fM4Fl59zwYdfecEHwZ+/8z2vPP/SV73r/a+58P3vv/r6u6P+Y6aO/ruSnPTGCPjhKAxmJImiMUsraA8sHRb5xM2fe8N7/+Xc887723/5l3MvvPCcCy9E1jjnIm1OlrVzqVz0rnMvBAysJUrGReefe9E/n3vReSPlORf+U+4679wLcTvvnAv/8Vz1/6dXq32EfJXaz3u1RlP5qgvfee5FDPnHV114HkqfxP7ud75qSL76onee++53vPqid5hEMdDMEf7x3Ive8aqL3tEn350tq5Jve9W732ZjCdLEue9mxre/+qK3o9Ty1Ux0wVvPvfAt5zblhW/G8qqL3vqqi97ckxfm5oVvfeWFb/mri970l+9+E/KVF74JnHPhm151wZtedf4b/v6Ct73tPe86KMsdvdakG/XvNRqXgKvOwJQx4Ok4A86AM7A6Bqj9Vue4WV7UWzoVxRZFaOSgtGypvQhR5KjIXe2Fu3bf846dp31z4ZQ7Fk+7Y+HbMlAG8a2F07612Ic7F067c+Ee39pximLx1G8tnnrnguKO+VMUco6ZyAAAEABJREFUC7vuXNx9x8IuhVpOvWt+F7hzfvedc7tR9szt3jN3yp65XYdPudf+nafsmV+8I8qeTgqFVszFJtAJM0BZ0ScTApGYcnEKSzSX5+fvDsW++fa+xcU98/N75xb3NEAzAztY2DtXg2YJxu5l+Nz83vn5fXPtvXNIutpqn8tyfg59n8rWPjxLMOlY7J0L++ZxVuzNSikXwr6FsNfkfLFvodg7L/sWZM9c2juPXnWZQy3nw975sG9IZqPsXZB98ypRGkj7FtJeIjCqlGYZkN29C92983HPfCzlQmfPfGevyqgRFpEj0d272N230JM0Fdmyt5YoC10CjsDCyp07OnftiIY7d3T2LjJv3LsQD+8Md7eW9hy+e07m2lK0RNocjXZt28UfzoAz4Aw4A87A7DJQTGPq3GWptwDJZRlEgqQ5Ee7ByyLF7tMOhoW7U/toe+fh1oKiPXe4vTCAo62FI+25I8ga7fkj7cUj7QUz4gAOt3XgkblFoKFwVp9FdHqXioXlsLBSzC21FpZa80vF3NGW4lBr7mBoHZ2bjzt3LLe0El2JwiPw3GgwRwbcxPwnDexiSLAmKCsiS91uXFzsLu48FIqlFiz15FK7OFrC7NpcaplsLbVDiVYLY4W2Ku2CsaXSkqVWWCpl7m0V2tVq6mpZbs8tz7WW8liU5TYODKTL4pvEiEXlcrsFyJloy4xtM9b8TQr2PC/+Ge1s6ZfLmoywKdkTB1kpDGGpLSst6ZOtgl48e3KETx7VMpnMkyGAWTLicgvoXDSzPSKX1Kh2682SpmKlnVaYqE/KMs1WXGp3jsx1kEvteHQOdJBH5rrLc9LaOdeVyOZ3V45KKCRxCWz01ebxnQFnwBlwBpyBjWWA6mVjJ1h79KB32SCUn5IfFKCtJEUMoRtb3XSKSOdwpyULrTQXEjfkWEinSLEH6RYZQfSfkgehSkPJSDEoJKQiA6VE6kagd3du8BmaQpL5GOajUAK0u9KOsSWhTX5FkVJaSbFbxBVmaUURWSyolVVB3yAkYTJFshWKYLEpW6GApXaSBZEizXVWIskJfgKRMWgFk2UyBrIUqFNjkXuRrEqhM8ChdXUC9EqWjC2JJS6sZiQIbJJpepYiymcMIWkTegoxPRRqqWU2sgw8o2aae6G4hjoUCckQkxKEZeawGko9Q5JCjdiBWoiToc5BstRsSbgf1qUyT599CkkNcJmFIggo42TGNFc4UYjEpM3aXilF88pE7wsL/8xSy9hKkWsMzEXVaXK5EjqGTqcVY8HF1pH8mJ+b1/VsxlF8ns+FMzBNDHguzoAzcJIxwO17qlZUUFEAvdHabZ/sEk+RFAUlUoZSSVAntIsU1AVj7i9F0DYClBaJldJ71YHaGlo+tYHay2eRmCs1Qkmi4iCXlLohULl0A4Vb7BZUrzaEuYDpGyKTCOhmmSfoX0JS5syeAl1AWyloVkjyB0ITiESIgFldYbL6VLtE8BShvLJROQIiJB1b2rU3u9FhKOeyBpJ6HdkP8+GbBeZKologpOZjWWlvTo/uIs9rktywaMa8JJ4ipcxjs2EtIvOwlgHqa9Ob1LYIZbL0HspbAaPRUqs6mgNEfaQnabJcRSulAqaBsG5eFN0Q88UmFtGkbvbxrbrKyF+dAWfAGXAGnIEtZ8CKgy1Po0yAW2xXCq20uMUG0VtxVsp7NnVDwFafe+k9WziuSu2Q9JBMZWwFkAKOFaqu2idRy+rCi2ShkEBPmbDaWVru0qwi+QTptkK3HVSicyoZtD+GolsUXfSgnhvwHBEySKytLeEsVsg5IFLPnnKStJOEJJpqTwaht2pKEoBPhaDRoyCLKBlYaohuQGm3Xik0WhDKyAwUENGjdJOIImgTR4wZUg1B0a6qqSWX+jMqDzHnnAz5ZATRYm2EjDHE0rOvN6o9iIbVSpopJE9n8yJFu3ozSu5tSoZUwA0ERoGmD804HIff02NIfRDRJEOZVV6L6UihyexFEjZDpaivjggRO+gWKEnDqlWatan4wxlwBpwBZ8AZmFkGqGSmK/fqDqw3e6pSbr165w0i1IogCEYaJB0Dt/AYqCwpxSrQDPSVTdWkPD7CDGhFsZpKeESRmLRs6qqxvv1LEkOIlET8Yp1v/HGlFTtFpMwC+FvRAIMoxELJo1A3CiyAWVpC3aJlKPNmYLMZWY7mbQlTvuBXochKEWGGGp76TFGkXEnjWUJCZaFLVKeKHECzzg/ClAqU0YAu4sC4eqZQKnlIjL0hFG1SNaP2iqhU/hluiEmkRKBAlBQMsVJoxtIBz2os1HCVaDQpY1YTSU+xrqYMjd6GTjTAjCZR+iBCAtrFsXCQvq66mX1wU9RGVfLCg17QIuTLVvELPrmLKG24Cw+7Bgo6aTicAWdgPRnwWM6AM7A1DNR1zNZMPzwrCRnoiqK353wT5gBS9AyyFToinSJ0Q7C/oqNYDFQySQIQvXkXyaqnWCrC3b0GRnw6hSyDJCsgEFix0lA6QTohLDNVDN1YgE6n1UFJRTcxOf4ptVLU4i5KC4hWh7mEIPENRBAtrlvIJDpdFEERUWvu6wrJRU7RukEohlh9Puvt/Q2lUMekIowG0YKoQ5BaojSR8rmySZ2VqUlC7EENZpAyOQkhSIg1CoH/jJT0x+gYA0jUz9lY95qSYhUHJc8QkoCsVl3WwAFkPUQBIjiGlESA6AMjKBOLUira0/fEB/SZcgMjyOqwCGKVrQSRpGlXkw67moVQwHSxZKyhVmLRyPmLXWaERWlHmReZE11aK+klh1384Qw4A86AM+AMzDIDxbQlz83VKi3uxFa4YKGc4N7eFelKgQyxjZFaUwKtKHr7FpOUNkIJmy2REEDv9IIxQ3CLZa/kR65WsiWpjFmKSQkphFBIQCmEFBgRQ6JNiaC2Qih8g0jgmWQTHnHMHJoIXYk8RHLy1DOkSs2oQ4KWRySMnu3KieqSlVDLQABdR5BaEgRPxhJegnoiTS+NNHQvRELUUaaTkIi0lBgoQlVpDqLB1TPBPZwD7efJRAAFoACUBoKOym26QFY1pUonFBDBEeSJRB8YgWrqWWaYg5W6dmnFzWtpafZWunXhY8hT1HOZjUo0e5etNb+wAd1A4AKFwUUZTNOmSUeQnGdpx+ZwBpwBZ8AZcAZmmwGrGaZlDUGsyBMtMFKkKgVZLwsgkfxfWIzFfLdoR/2nx5RH1F4NJKqnRPEVUgoxDkOLonygSbcUMQSFcNMvIjIUMRQpZMlNP4W5GOa7od0N1L0ZoZWKVmwVCTCYg6p2knmKYiBhTtLGUpqEilyRgigpWWI05JaaW0nm4CfFInWCLHPKW0maoBsEcBgMugV6WCkEnTNjevXYOIhJs6wUgd6VAk/BfyUEdIAOa5yzIiWkLCVLWKIWxUKayKS9OAQh8RikQmmPgX2rjargZtDlBB2VdLj645yjqRtxzAGlsif2wMAWAkjQlAplQ5Ugschjs8wWMrQ8TTKL5INbW4v5YxwJhoDcJbFOUjMsJIRk0GbIPgFnkCANNOxJeLArJAetKeiadVWiCp2xobAqHLpYGONwBpyBKWfA03MGnIGJDBQTe7eik3s1N15mToIKhBtvflKYFtyBVafs4DaNU4XAnRo96VN1igK1pICCTXURpAFL38I5orNwdEsqShnUrRCKCUEtklYtRdImmWjxpLMJ/vihAhR11ZcNeZJCbAYmLZomUSoUKZc4QhEWJbCyRA+1DbmaFKMiUPYoaFKo4ZMlFvUvJElIlYzqI7WECtUZknlAx5cWq8+6SOCh/mwelClpwiMk4vDaDx0iIcuyA7dSG3qp3Pr8K6PodMXQmGxQnyACREQTKSX85K48J8sRqXpFH01/becnwwFqyGtEAVxFyBpKgDaIC0QsYZNiD53XtGFJX4Rmm14kBYXlmrI3DqbklgtnwBlwBpwBZ2BWGRhz497a5ZCUgdICcD8Owr2fEtDy6hYr3dZKEqrGFjdpMyLxyeDAqQiiZUduimjFEHkBWjGkbgBC1UW5loqUWkFhcxbZrhYJRVEwTUcrlKgZCC7EiElWJHQVRA4cJQKdjr4NBYsig0IKZDkRpqwFYcmlOaS2iOoxRKGeJDWTKGIPegu6osBhBofB6EggIZpEKZF9cAChEUEkaZEUo3RBCpHqX6iF4VS/BkSaUehF4aA6JfzZgAoCe4ockAxBVkXzZBpFCglI+Yjla6gUHV7rZeeYF12yJiCWc1OSXg2djhkrT7U3A6bUFVFjqhZoShQGEhMJUMgsVcYR/jaKUBl5hpAkpKAiUygqc4cK7PoikjJMD/bi0hlwBpwBZ8AZmGUGuENPV/rca6uEytwod3JxQs3BwZDejCVXA9rIJVfl33jtFSsNY1YLoQBFM5lnC0SmlMg6JQSdFbRqothivozKLFrk5RyIlqsEflatOi1M1Vr3V+oPQFidl8xDB72HevZeYSdiukmlsnYvGda29ZosWW30NkeVPjooPyMsZUWEfKR+KKvMXbfXTemb5cSjWp4Wp6bPmiNkCEZ/7qoy6TGQzf0ixzdPk2V3tpd67wXSQxJDzzpKwxNzIxtaDmfAGdheDPhqnYGTgwG7o83oWridg6Hke7f8Ub3qnnKRhNRG8xmqRzYynIoXmVuzJ5JARROTl2CeI3xSpit3DPmUdVhlhz8RGAPZf6zAATS6qwgNk6q5LMPToJbhZz6KpYKmTCbVZn9zVFNv+pyoXjIwIQxLm9BLV14kr6vARq1iFVO7izPgDDgDzoAzsCEMTH8xuvoMhwuRPsooGpLwG+uAW59Ps6H+SZ05G+UEtNd1zNqi53rSa9RGvTXmSlSbtaKN5nPN1MG/TdGMMkU6F8nEbKJ+H5joMalzzXRNCuZ9zoAz4Aw4A87AdDKw+lJvmvLXmzRliqaU/6QwZanNoXt/5KAu93JsZj/NZzcTxAGm953n6ajSXL3kehR71daBNOPQjJXD1r5qesMZQBowe4QZ03QJPX+zmyz79QWHoARyDMnAlLoZORpdIkMFKF1A9BEiXwMUubhnuBrrJ8NB3VSFgQZt9J64gbKtGZIMkBEni9pbOkpDZzioOhqvQ9PhFmJ/4ME4/ZXoUASdtzFDT9U4/ZF7fa45A86AMzAFDHgKzsCmMjCbxeg4igK3eeszxWTTQsVgzUFJLQUGrcNtiohh4/RYyj8hbC78BJMbwVhfEZY5b1CnU/c5SP33uJaJOpg2RjZnPKbzmBirNR9//IE1rnbC1fhxjWVW+3yHLSIn17u3b7necAacAWfAGdg+DEz37YzTzElbQdUCsge3apBVaZxIsbyQ//lz2WMveBqsqf51URKTnvlRaaTqvC3lgDhEtfSGlJq+hBj1ZTqf5F/DMiRZkPWxPORe+9diqKF3JprZwNRDrkQJaDA7M2alL362NEVfL0MM5tGIZm5I6xHt4kAU6I5QujXsOT0czIQCss5wkNXKJ3ephXn1pXziFtZ2JhpCObR6ITKoWi8l2iQAABAASURBVL1XjP2RSR70HND6k2GxgVHYHc6AM+AMOAPOwMnJANXa7C+s725td24kYGkmUYCVmE0LxhIhUFAMdoWAsXRovPTcYtB6Tf+9f6N7ZtQ+3oazrqqiCW4hhlBSFPIjR6kG5sZxiR7DEhr6QKzBMm6ge5XNNWfLZdQMzbqbzfXQbclI0Is3sNyS916/a86AM+AMTD0DnqAzMIqBGS1GuUlHLVOoVEC5sJhPvMpG/jvRblU3UHAA/bvG/tKBWiphKYoixg7OQLjnG0S0ydFUGbLxggP23tSNrmlRo2h6uupGRlFI29raa5oZkdZkiCE3Q9+ZKIQAjRxiKBLUZScdiz0lFMaqTf9CVJT/pH8nir2G9lqErCEYAlCAuaFIv4/kR7N3YAhd2UVQamRLiBoqq3n5sVTz94hKz6/Zk70FHJBXzrW/+uTlqJKf5IBB0XDu889uWBSEBcKzRu7uH6uEl+bGCyN0oIjXoOIPZ8AZcAacgZOLgRktRoc3gZu9GVEAukkUKgZkRogUDlnrE0l/ys8WvednpRQ5SK5RSkNZ61St4dfNLBaO8WcMw8lVFlZUqnmBpT700nPTrlHUMRxo73o8Vx+q3tPVDyHBNThXdTajeqDC7jWOpWm/EriGSYtU15pRdKzG0KfqEQUHpMMZcAacAWfAGTiZGJjiYlRvwJOp5vZcwzxp6r/qyP/y3SzJXvTW3gtoB6J9B3vq1qtEiWNQc/nU4RjLVvUSpRpVzVT1bPZrHDMh9hrZRReSFS2sTSH3GtmCT9Ajulz96PCyEs12PHKthh0VjBiLNQMfkFVBiVJFMFNDxlI3B2TZxl5DTYXUNTh2tfSfLJolS4KArGYf00Zli1uo/5qTsMCcswyRtBuVaH8EW1d2LEX2ZwjNkKRGqWHtIdaJZap7HZXWc6gsdcFaG1xxBpwBZ2C7M+Drn2kGprUY5XZ+vLxyzFlWTvo7bI7SF427ezZWAmeghUJlab4WQk1GmVKPqpWm19bqdUrDyoTEaucJPqO7ciWqXVlJqh3/s394WH1Wq/dsJtc/XbNnoq5XSOlwnBHK0at5gQSgnse3Rh3pT2fAGXAGnAFnYFYYmNZidCx/VSlQ3q3x44ZdIv+daOUwohI1N4bUWI2ldA4pBgHWZCATgbqZlV5Wubl5gnyGJ8MIGnbSAw2DKEv1KrRDi2+h/rb/Y/SYev9tgSgh4kEBqlTARhLO/LD0EPJ/T5TCrfd3otbJQGB6U6aqMdBLs0blIpx5cyZaDzG7uZmeJUnWyAaRIR+zZzeWUMPMfTL76P/za9LF4tnXO9ww/2H7CEsvK85EQeWCvZwriB6C0tWbl/gi/nAGnAFnwBlwBk4mBmauGDXy9YZt2pDs7xq6eWstFbjLD41bvaFXGqx+zEx6UlUO5B1CH3UDDgPNgbHjm/1bNt5vS3qOd1Ebl2zauNAe2RlwBpwBZ6CfAW9tBgMzWowaNRQxwPSBf/k+cMPGDZSe+SWm3plf0pOobD2JROpbC0U5KE1QAcrG6l9CoBJlIJg8CAdgPijA9ImS9MCQC+eCCmmeiRIQDLqSHBi09toQAnKbiUBW+wVhQc82UImGMDADzqDnP1YLaeQ1pktL1SBSAlWreq27MaxuLhwdzoAz4Aw4A87A7DAwrcUotQck5ls/93FUQ8oW9KaRpqK8kXPzpoRAipQWaT5CIETjpp4DhYARr4Zdf9tVSwwRSHajXaPOBMtQJ7ZNw6gdDNDXXMuqk+ljrBEhxBCgSC0hP8qIzZUH7S3tq3rJe1TyvKoBq3AazmHYMi7MoGfjXyzpENYtYjlrU4YzH8FAjtlkyYaufqz+UM+YKL3gbATAuN7weM6AM+AMOAPOwFYwMKqU2Yo86jnL26y+DOZWFwJ0cqRkQ0LqGmoLdv1PYPbaUS2UEiEURZFiR1IEQagnE3UCkEiQGGQQVADZiQBSSGIwJQhpYDRXjPkPKNVhE5+6IoEFpqTsJDUFjZoxHBTapogBdCrUqK/61HXoqzA4FpKBTU0x5WNjVUNUMkNQPT9TijH/ESXcqXtKkrqKiEFCiiEhK4imyeAaOAGRJM1HIDFrowDTs7RwWR0rGB6YHpgLEWowkSF3ZU8LaZKViphzz0GIJt3cRiQSBqw6lmln/xwKzx6EtfdD8lhiKPIoMalt5o0hlqChNnr1pXyyuaBsdCV0stpO0pbS3u+fu104A86AM+AMzAADnmKDAS1XGs1pURvlQ19Kdu+1OnNU6owTLQ6EKiDreu+X+pErD7PXNpQcldoCtUS2SAzqi64vZU9+wZRfVVgaSIyDftq/uc+cQU5bTK59+phSjsLIEZxUXfSWYN2lJtLUa+MEJfv3zTLBeZVdOWbpO5xt2VG/hECdXLWqTHoMlNVn5aCvOX7lqYbyme2lnl/6NmCod5irXszamcsqhyKNXq9ZkLgBFIcz4Aw4A86AMzDDDNR3u1lbQ9+9mZrDMLiKUD1yx/CdGwvInasXTA20mFj72NXPsjbPNWXS4IqFgMZcZR2GEYjAXy4xjxkfByC9B8NBr11qVGicnk6OyZcNhXD6R6rlwPzCFCCrG8Z/yYBNMlKOWlefY0j1VwE7bu/rHWr0H0sPdc++wVfgDDgDzoAz4AxMYGBGi1EKBoVoWZAmLK/ZpQPqM79mx7F0js7yD/TmVxdD1pxyudZs+/xzJaoLrBVtNJ/Kf7N9TJ3N6pvimAM22YGLZOKMMV9yE13WpzPmMCazqmKgqSZ/OgPOgDPgDDgDTQZmUZ/RYtSobvygbAZqI2B638kZd3FQduQXmiCrDAFZ7T+xwwGUHXbENZqv3vDSecpeWIWhkRc5h4H/nmi3LMXoEjsTlcaDOhJkQ4hJuoqyuCd4tptgODC9lAw0lO3yBTdQNghS5dM4WSw7RXtH6AwHVUfjdWg63IL+3QWxK7dGzBCpMsvll91DETSHsq//JXLZEBb028e11N/6uJyA6ZWkt1L91RlwBpwBZ8AZ2AYMDN0Kp3rN5X26v2gYnTGHeWCwb9X1wuDAvjY1E5mAPut0NbS6opwiqYE8zYi9hz4+GSjNSlSH9zlI/fe4kh/qkJVxojnjMZ3HBVml/fjjD6xxlfNtuFveDgrlaiIWCKrWdn/19TsDzoAz4AycDAzMVjHaZLxxS+aGbSj76QLW4PRUD/y01OhVolXv+FHSOwZr1lIWs5SF+hAKlJatfwk5BdaVX4dEtZZAPV3+fyw1Vlq65yKeRRnM2BvYKIysqyGZF5QGhhis3YiGj8F6RLv0j0RxZ49Aw57Tw8FMKCDrQxGyZ+4SApmSZfYkKshtBEEAiuhyOOgtj3glP1IwGnMjC5xBVvsExv7TVuYAfT7NhvpbmzceyDljNJtLZ8AZcAacAWdgahnYwMTyDXED42906KTFxKhJQqCgGLzNhzDCODR6cJRWDBQ0pV/KzTRu3tJrWl6aa0llUr21lIbeS4ghQJEaQn6oNlDbZdMaRSON0NAHokwq4wZcJzSrZU5w6e/SLyoNC+tutE5QHb/YSYEZxSpSeY2VtGCcNMb7nAFnwBlwBpyBGWVgRorRNJJetfaXDtRSHGuFoihi7FBkAOFebpDq92XqIUMZlds8sEal2BCkmVXSpTOqWj5jkPLkFQNUlnUcjS0A6YGRE5M2yF2h70wUfoBkNhr/PVGNgz0llHKg/oWoVGfMgr1GGVaDZBWaM6xhblnPs2StFs3eciLpBTc38zGZLX1xGnYtmusgPU/2EKTUHYqsPqn/TFT0GsFGHItsUj0bTzNWZ6JEr1E6lQ5la2BFZf7mYy6mZ0mv2SbLLb3UJqd2MvT6GpwBZ8AZcAY2kQEqqE2cbb2m0hs25QLhIoUDLwNIWnlkG1VCfq1EbNRMla33Gkt1cFRpzi9RtDdSteSmUBXwE7Pp0yTJEJCREYUiorxJ/RhFHUNA7XKCyupD1Umufgi5rcG5/0sLYxVU2Pqy+qcSuIZJc+C1+otwgTEREB41M+gOZ8AZcAacAWfgpGNAZDaL0cGNiCFwIApC7qlu/6G+kWMx5P6eaBrRc0dvlDWxV8j1wUB/dtKS1JTpkCTcnwiZh8EzUfXIdpRcq9Wj4M1Aj0jlI/rAB6gmghL7e81uMtpL6UCQso29hpoKSdVViF0tZWSLbwaTBAGma69plioyN3GoEJKAKlruNZEdGpVokr5TVdIA5ppl9hekCAFrlA1pPhgI1MJXFKBa/SRCqHfBrDgD002SjCnDckLXsLNbnAFnwBlwBpyB2WCgKgNmI9v+LLm1q2HgXl7+zqqFgvau8UmhMXlEOan96x+Kg8HZJ49ep95V79oxl5MTypWoallhUaof77N/eEXXKqIdH5P9061iGnNpnAofZwSLs8HScoOZKGtgcoOT8vAnwIAPdQacAWfAGRhmYNVlzfDQjbVEEXCsOQbv0AwBzVE0QdOCjsWADpo6TWAWkzRrYKn1rVLWtmV4F1KfxsWUqr/7DNHqGwrQkGKGDNauIf/3RCnc9A8rY2NHmnqTByuesOCArEGzRm3kWJ4z0XqI2c3N9CwtT5PZkNPArWz0XrIPS6jR66q17CMxTfKpnVHMH+XYICWgfhyIAtX6nxhBZcMZVC1/dQacAWfAGXAGtisD1CobsfSNi1ndv6kS8iRaSwX7dT63jyGq4cdwm9xNkChVAqK/8E7235LeusiL9fRUlbVuSgh91A04DDRtyCpkb8ZVOG+2y/EuajPzNAKbcjNn97mcAWfAGXAGnIFNZWDmitFx7MTUO/NLwsHXOMc+O/d7kE0MAVltisq2+pjN0VOth0AlyvLB5DxxAOaDAkyfKCnWwZALR4MKaZ6JEhAMupIcGLT22qn3NYCJQK+r1ggL6qb+CUevIRLCwAw4Azn2I6SR15guLVWjSSlE3mAZKMeIHCSBavC41zr6OAe3b08GfNXOgDPgDMwwA9wopzN7EgNVbloz0ASiqvCzctkVAobGbZ4qQSQEjCLSsPf02lgr0l9YNOzCY6CM0F6LLlptJCoIocgRKY2ywQ+qkaSL6fbm0ZTqlnIkEnJaMv4RQplvyI/a0aylZC4hlPAIpqNJuVJ8gPQe2aPXHKFRqzWt5K0IEqtAvNZoeq6LPnAmyrqrsHo5WRYNGYX9VY+oQlSGpDI3RwsWAugziTIGQ3GCXUj6t8iBQr0cpm4xRDYziW5sDhslJ5PU0i4d/cUZcAacAWfAGZhZBvQON8XJR7vvVhkWhd6Apf638y0JKXaEEiFxm9ZbNjUTkNilIxcW2PuQQzXC4g2yNc9FlxYE+neWomVo0P9KFGUWTiGF3CsSIingnqKsxNBJBRWUbMaDRChCk9irVNOyUoGZGOiga07abQnd5ZVWKHLJRdox6UI0R/3viTaqQkq0KFoJQZ92i0YNkTkSXiHBRhFSwYXS01kwFu2iFzcDuiaBp6LszcZKFyE485Cj1lOqkXKGiBB/AMIjFQJQRiJEAWVXZEtOm+QCAAAQAElEQVRKNb+wqgyWqMg2FTYvq46aBazFQmIrxblYAh0Ll1AOSLZETtoMKUlkVEypB+lGBRcDUL2rzW436Vk9egbsg27WkeggdqUGRkYwS2hFtkjzFL20OilEIKEVWq0uXpKCpq1PTSs7unAGnAFnwBlwBmaXAcqGKU8+5mojlllyIxYKGp4xcOuXkY/sHLIs+01vytwRqDOyosJ6VcszZkViEfJ02jKuKEOCtqhh9EWfOSlVtHZphjTbusukhcjgPFRBIZAJy6BkoY5cXJjDoCkFbKKLCtHKHOwVQggS9KGSWlL0EdVAsBC0pc8cQRXROCIm2QNhguwVQ8QYaatFX2NtV0vuGCPC4GK04EpBSjORewM1cq81pFXrSj2lSKy6RGCZTQQeElpJtzkgU5F1yu8QpAj1A7UVAl9+iqJo9UFaoahQ6kWhloJHSxCgHRBFnyzU1FZz0S7Ujd7QQtN5U2gxtRQmpJDQ7XTIb8f8gkgnSDd2VwqRWBIk/nAGNooBj+sMOAPOwMYzwB1t4yfZvBmoVMCJzMdwMDKC2hNHY2WnNkt1M1/YsULKIoQXoLNjSpxvrsTUEekWsZMoTrsrnSMYOI3rpA4SmNJJ3QY6WVepzngm9E43yyicxWkoxlY6h3lYkJwRcrzHd4IhHw4Fpbabj/pzEJjygzIqpFREMu0WXQ7+EhZ6oqSupJVQgvorSZeuDBSgnhqbjQAxN0sZcIupExM0KJJkPXajYiVG0ImxQlpG7yYBnSTLIksVjoqshNARquDAJBIDGlKihE6UbqcHDuZ7iAIlvSZuOIOOnt9DOb3dmDITuj8xJkJF6McHPfJYSXFJyhA0E8l1E6ksSIuD21bszou0JBaSqOBbIkH84Qw4A86AM+AMzDYDlDYzsYDBPFN+cDa0xuzjOP+J9nIUc6pbKJt59lrXns14Un2A5kwpk9NuCQdpRaBAWWy3i+7y3MrKYkyLMe7syq6UdsWwKyINWOKuZDBd5Y4kO/GPsiPFnSppoiPDjhh2RpNY0s6+Xiz4FDtisTNJKVO2pGInoxJjix1JsYiMhfp0i10N7MRoXUhAMzJWPXHeQdhUWIQdiTQKNeLTMxbWu9gNi3EEdqS2OfRkzJZOsdhtL3aL+dgGc7E9l1oLcW6xC1qLXZCVTpbaLHZ0WxXCjk6rH8OWFs7Eacj2Dp20yBKdKUq5qGkwO5ZiUWdk0rkdnTnG7lhptY9I98AS21yw+0WIqRMGrgTsDmfAGXAGnAFnYNYY0PvarOVMvuV5YNJjK5qAohCgSD7PqnTOshSSH5WRMyVDtjZrSugApbk3sDJIOW8eUhursLVh45RcfJAEr0DTocF01KOpQAW02keWTu2me3bTvTrxtCMrI3GPQx3F4ZV79OO0IwxponPaEdA97cjqcJix3dOQNfoHnnK0e8qS4h5Hu/c4koYQTj0Svu1QulcGyqlHkvofTaf0IKccBdlyJJzSj3scad3jcLvGaUfmDLVlQLnnkfa3HS6Q9zzcPu1IcY+jhUYgyBE57XBx6mGa4dSjYfdS2KVonbLUPmUJaZg7ZanGsAXPjKPzpwxgaf6UHohAU+WpR+dPO9rOyczf88jcPQ4vWPKnHlk4dWXxHmnHvRbv0ZVOhz0O0ins0JiGwxmYPQY8Y2fAGXAGagYapVdtmy6FHyQHk0xagyYpTyjT2vKlDB07IA71ENyMzIkueVKziD1C0LLQ9M2QIQaJMALK6cgLU9KsOBbdIfLff+AHn/1zT/rt03/5t3/2F848438N4Hmn/0rDgj4Zv3rmGaDhc/qvngkI25O/dubpTz7zjF/LMOVXzzwDBfmr2kVvxvPU+OTfPePJKM/NEsXwu096soEmXQz//Z9/8u8xqt+N3gq/nhVkE0993hlPG4nnnv7U557+9Oee/rQGnn7m6U/7vTPAU39Plaf+3hlPf/7pJX6/VJ5KlwV87pOeVuKMZ5x5xjOeOyh/47lP+o0zz2jKZzz3SXg+87lPeuaZZyDRzcLYZ555+jM1gspn5mgqUX7v9GcqzniGytOf+bzTn/3cM579vCc98zd/9inP+Llf/7X/+Su7ZNectFPksmtpVVpeBP7iDDgDzoAz4AzMKgO9kmZqVqBFVZlMWmV61ZAQc7Foo6P0jjabuvWa7NkL0QovW82IzK0sKEVFzyFzQ0VsTKTt8c917aHuBKJ/KUjdKfYImlkoCi2Ku90FkfsUOx52r/s8ePe3PfTUb3/Y7ns9vIdvf/huxcN2/QdTHr7r3gN46O57g4ftvnc//tPDdvdj13eoZUDSLHGfh6mC7MfO+zxs530enuXDdt3nIbsVD959nx8Fu+7z4J2Kh+68z0N3fffDdn33w0/57v+++7v/+87vfviO+43BfYftD9t5/5F4+K7vzfi+h++qgeX7Hrbrfg/bdV+VO4mmeMSO+z5yx31/bMf3PGInuP/Dd97/v++430PB4v0evHj/h+54AHjICPn/PHTx/1H74gMq+f0PXfz+h+wwOxLdLENyMVtwRtnxgIeBxe9/2OL3P3zn9z905/c/eMf3/+jiDzxk1w8++B7/5UHf/l/muU7jXIjtQkJbCrsEXDoDzoAz4Aw4A7PLwIzfzPSYMx6L/YaD+o90r31qpeeWUrfXyFoIWvhpPTo2YPZbdxFyeilSieYMBidoFa12TDtFdoucGuWeSU5Nqp/SL3clGbDgX1qi7E6yO8qgT455yolJhoNTyU0EhRkBTZ1dZFc2lnqSxajYlQr1zF2VYhbkCOxOyVA554n6hvcsrHFnKkCeuoy2K7WxLEb9Q9LFbmtnCrukdaoUu1WGU6QNdo+Vc6fI3G5pytp/wI7PQvY0WfbukrmdMocEi0n13bKguswtSntOirTS0i8fhXQHr8rBi8HbzsC2ZMAX7Qw4A7PHwIwVo1YEisSkBWI+JIRzSjQDuoKKDaiGp70IVSMoG/QatG1novnsE6NaRO/2BMemMJNKZtHT1piEX0lTURQhELSLpJcByM1GVZOSek4gslJyavFKsQJEokgKfZImGLZj4ayNLpMoWEopOcJqpVIU2SaJTcloEgGSMEch467KohvbInOiJ75FlqqxNCA8sDVhllqi9MCGGJhrFHqeqgXpdjoSim4SXrpSANabmJ6pi4Iu4XgeSGhJATAHukdCGDaEYc8RbkUQRZICkANAkVCIAI3J1w/VRObmC20HkZbuiPjDGXAGnAFnwBmYcQaKGc8/ihaI4xYRyw7Kh1LjpTKiKsomFYy2Gk/q0Bw8OzALaPRmNclm1wNFLkQKnZ3J9aV8ZpNor+QHvSErksuZDZGROp45bOqGxI55xLxYuxzopSSKqNkGoSQNlH0xhZiKpF0wr8hOjTa22jROwYcQXX0RKswemDojim5ZT7bmChJohaIFY1FiJzJeQpAgFVhZBg5UpUgZ/7Dephz2bfb268xJZn0jknDxMj3FOkDRXvxE0IE2/ekMOAPOgDPgDMwyAzN9Oxu8cVd1hm1I1cvN3Ax9kl5qJmBWmqYkoTbhqSWJWQZk1OpAKFkiHRQ9yM1EmV//lKFqam8QLes4GuUwDYjmCwc9SAyTUNVgDCwxzn+c57C9tAiP1lwntDpFsQTJ1PctSRxKlufcKSQ9l+SLAajyDqKloUmRMBlBOMHkzNAkSgVlhhn7ITw4PF5ZkU43dPWPH+ZaRRGwCmZFEBLSSSlDtfzTrrFP5qBvWGIcwLCPWYQcuCaRunopjapTKwM2UY3Z3haOk9magdDedAacgY1hwKM6A87AhjEw08XoKljRu3fTTSvIZjvrg8bBEjPgUCJUDwYmLaF4nQIkrZdE+E28qqJEOkG6ua4azC9JWdCsUhkc399uBunvGW6RTux2OOwUCbEVVkSOSHdJYpcCkCsR4AFEtBDMMuqidF1ZkSFJF8BeoiupK6EhaSrK/ZPSzZqJllbtSSj0yIFmYnxMUXiwsm7OAWn8YiTxDYROQH3J9FFnIZ8SnTJxzSz26zrGn86AM+AMOAPOwOwywP1/CpPndjsxK6pD0HPB32Cmpt60YM9/lCccPg0fc1F7APUPogWBytKgRp4UosgSQaNlHadaz4aNFWwZEC2PqNuAjHhEKSihEj0jHBg+AcKgPnAoOAFN1wluVddcaM9Fzb2QFoejKzJ3tCgOi4Al0QKasmtZ9P+CCAm6EtOxQYFbQjQ2aza0RE9GA0aoaKCMuSxyUDqHWmkppE7RjaEjqcMuF9CTKz6GQCMgKzsixbKKfMr4x+Ep5SPq/FxjJZLWpuhFFAM6yyqd/cUZcAacAWfAGZhhBvJdd4ry5x68pmzwB2sZwl18onv/sWgvODVKrg+Syl6EnkPPtpEaFQioZ7AKSQsw0UwKsTK6sCoMN9LVXsasCYzEf90lAUkoU7xflm761q2fO/zvNx68/RP7b732wG3X3n3bv+677bq9t92w77br9912w37FdVj2feX6vbdep/KWIfmV6/bdcv0+7Ca/ct2eL12790v98svX7v3y9Xuzj8naf/8t/3rw1hsO33bjvlu/vnz3SggJ4rhCor6iAqOBxBvgXbMGRP3ioyWk5EJygqRrAEkEiG6h8EhS/gsnlMoTs8MZcAZmmAFP3RlwBrinziwJFA2DuUcRkK38QA+yOl7gDHr9uUzqNcdpFC3jujbcTr6GJFSiqBQrgHmDUInqSSC/OYN2lHbuQKwVFD8MWXdJkpIiWR4RuXnPv7/mvee/9LzXv/TCN73i4ne8+P1ve9HFb/vTi9/yIvD+t9F8yftU/unFbz37A2852yRKhbMufnMP78+6yjee/YEmXn/2B8Abzv7AG86+5PU9YKT5gde/+OI3vuQ9b3rFRW85573vuOwLN+yTFc5KJQSRJFF/um+L/hv/OREUvZqShMTP+WtDIeq/GhmkkApJz7a1hI25AK3tKBZKUpEh/nAGnAFnwBlwBmaaAW5+U5X/ieQTeysJqadTVvQaDZ8+u/qXlWijxg1UnUG0TyNQROkLRl4qI6qEXqiChpo26NmctZqiuSQqFQVuZk2ajqmrkVXIcskpt9dPimbTKrpB43fbxZ2ydGCnHDilvXdH3LsoyD07ZM/OVMu9i2nPzkjzrl3IeJfqE+XO7l27unt2mlzp6btW7ty5cteOUqJUWDq4I9290LkjHjo6T3FH2Sn5MiiEByuPVJ+aNa0esK8eUg4Poo/JUj3yk/D5FUEmTWDJwMOQWy6cAWfAGXAGnIHZZYD73BQmv9asotTlIGUoKNdU2vWnTYmFQropxRAz7GauMmGWroSokJhCiSg4SypaReAUEnRDiimlGJmgSAlLJGyMHdoZa808D1q9oJZpAJX5AIpUJ2qqBNFWEKuDzGE10kZsnBSRJKkIBQeNHNymubDUjivSiSEzqXyyHVECWlRfdoStYBMUmFkQXwkGwNgKKfuoc79P06692U2SziMdCZ0w3+I7xpykeZEQWgIF8AVQxB5RZpMh0gAAEABJREFUSEYh2ot9lZDjeVhs5jfQtCgohr4crM+lM+AMOAN9DHjDGZgZBrjZzUyuIxKlOGhaQ2q0Yk9vuAUqU+3oeSbKULXYszEqG4L+7i08gtW71KmJcgZDjWghGdkLWneuu2LFCDJH5hVkFVHtJqYaonWLyKqkbPwjBYGllpBP7BaxUwgloQg/RdPDKyxiUanFn0ho7mm1jykRQ/KjVnJLRW+stnpPtRMMYCtlqVHwxhj4XiGBKp56OSepoYNgEr6fyBY8bHLk6LnpAKP73OoMOAPOgDPgDMwMA1X5MjMJW6IUFsD0yRI3MOCjZYaZGmWNGUwypAI1Ss9dhvxxsyEu18TAEG8hhjRkHBVyaAtEBtzCseJQioKBUd50BpwBZ8AZcAacga1gYEaL0SZVx6o8mr6Cc6+0HCpr6C29+dHWkNvYdVRK3dwcEPQOWLw5iYGRx3mrLA6HtmxgomjnqQNWbzoDzoAz4AysGwMeyBlYbwZmuhiNJRsUMoayjR1og+UB1fSpRn5Sr6GFS+8UTXvVS2JBHSr551nxxxYw0LeZNn+IbFZ/JcrXA2DdJqO9DEnsHLsKYYe61mTgUgJrGuLOzoAz4Aw4A86AM3AMBmb95honlhhxwur7K5vaMeZCtG4Klas18rEoAQ1mUznynE87/HksBuDWCkSUMb6wXfaM2a+yd4NePKwz4Aw4A86AM+AMbDQDs1uMUqaAAX6wADUWEqu1YTGoXZ8h6j9aChi1JfrbfalTWQIRjtwUQUNE6t1ciQotK55sGDI78+pYLwailNthSg7LfvX+xRKWFAZ5bzjT34Pa2TJQ2tBA2bCXyP7mSa05UrLzYGSXG50BZ8AZcAbWhwGPsm0ZOFlvsbHa0VoxQ5LBykYdQrDqRnXzQ4ZgxuF/tCT5n3j3nPEDJyuVULHx6JE5ONfgfkE+ZA96rUc75ZJ0fCbrMYfHcAacAWfAGXAGnIEBBk6OCooCwqCrszPR/KsuRrVIddKJEZgpy9KBg88gUf9UVAtQihLtxDNGzlBLHzVVT7pUDYNdG1Ql6Vwny3PwXLJal1IaIgQCvjAAdgSovfKxfcQCZPgAtefGviiYCwjPGqWP9lYRStPmvvhszoAz4Aw4A86AM1AyMHPFKGUEqZf1omiVaRaMhrKZDy/NUspcwZR6/4sOCUGroByw7Gz4RwlRrPpRpfeHpKWrv6yRAbgu/06UMlGJ5byz3tNerMYW9IyTNN0ddmqSy7H7NMixvdzDGXAGnAFnYEYY8DSnnYHpLEZXUU9QxIAevQyJdiaabTTzq1arWuX0lzX0GtSHwghI5akmiUn/K049n2wcFH3zD3Z6+/gY6HFebRnbV8Ni9nysrV8VqCCBCJtSo2xI89EbSzUMmn2uOwPOgDPgDDgDzsDmMzBtxSi1wlpIyPXH0IDBIFVZI6L+fb0coIb8kMaj598w9lQN0mtlrS9mtrg4FgMVjfmbwKDzMbZg0N3bFQP+6gw4A86AM+AMzBoD01aMrom/sgS0A9GhldhxmgYMEktgU0P5LEKqKqG6g5igdMgv2gxJ/yl9bgq6KVnWA3PLxQkxEG100v8rJog1mG2MpKIFYzr7zQQHauNAFKjmT2fAGXAGnAFn4LgZ8IHrxMBQCbdOcTctDJXo5LlS338VqOfLeWjVoOipVH6tb/hXdSdFjAFPIBKobqV6ZEvV8NfjYSBAbzlu3H6V3f7iDDgDzoAz4Aw4AycXAzNfjPZvBzUN6NnGVDb4GErPujDt86dCAiLV6an4Y0MZ4LQylWei5Tz1vpRt6du1yjjqla8RYKiHKUBpZnNB2fCXYzDg3c6AM+AMOAPOwAYxMG3FaH8+lIGp3yL55/IQC61ahHqD8qSipqHqv0aq/vugjYIjMECabgxNdcWT/9ESlow8qu7KJkSQXmlKHCD54YejmYZVi5KvkEK1j0H/0Vht1kBD5Ndsa68+8x6p0ntmn1DG6ZkHN10kj83eCKDXVTksFWyz9D+GLf393nIGnAFnwBlwBtaNge0WaLDU2/r1J1ICVSL9VUDQmkH0kYsJlJRSDDGDWqJEki7QgkPdYgolYi5SQyFAQkoK6pTUTZ1eJcoQQGj9yb4r9GcdQZHTO1eTGIrEKFAUBb3MjXRMZiD1qnkco7A1aQUOoZJ2kdhvRdC9wZYy/1ElmzIAtoDNb4IvIOwpgRR5lJjUNkHydZKvFhrYLKBESmFaoleXbiV64FnCIiDz1VMa/cUZcAacAWfAGXAG1oeB8ta7PsHWL0ouBfT2X4Vs6lIkmvofcqKioCLMPlQt+VWoGKggS10Ez1pHiVqG8toAlVCvRXXSawyM7XWopp6JWqrS9dWfa2EgZedMcjBdDUVP1Wb5VLZLtXrJA6uGvjaCDO07/cP+aklEDpGhgJmT1qPCNcQALkIsKI6NZMBjOwPOgDPgDGx3Bqa0GF3jtvRqBg7TRo2NolUpcrATf6oQoGVlqB1QwKBzbjMXXSC3CNsbZRaXx8dAEt2GUWOPyTADQR7KGSfI6lhRiH6TGV31jh3kHc6AM+AMOAPOwKwzMKX5z3gxGuqiUPmlstSX3rPXG6pHr1P4TTc1m+P1KDZRVfGM9/Se9WUgrm+44WjVlq7yShgO4BZnwBlwBpwBZ8AZOCEGZrMYtdIwL5zzrRpaMva66jomFlSion+ryA+v0niExO+ztZt10ASmZ9kLmJsuNoMBSkMwbiY2iI2Tqo4c51bb1d8aXO7A9FGy5zmq120zxYAn6ww4A86AMzAjDEy8NU/1GihWKB1IEQU57pgz5kJUHfKzdEbvO0Y9RsXZNxFjHevJwOSi8hhbc4KJ2M6eYBAf7gw4A86AM+AMbG8GTmz1s1uMNtYdYpKu9KoWKgygDhyFAn6QN1CYUvlwICqxq1JdpH+g5AfDY/7TQ1WypRLMQgj9Fy7UtfSavVas6XKVDAzxBregHD3UK1j6z0RxBqX/8Iv6m5ULHUiOYJYhifOQzQ3OgDPgDDgDzoAzsMEM5Bv0Bs+xkeETpWTfGadWG0LRmSftKy9qY58/xaWYf5+zVA8tdfSpE+VSpurw1w1lIO8Lm7vGSUZv4sQgSbfVppvo553OgDHg0hlwBpwBZ2B9GZjZYlSrB8qIgV/ny1okpS7nmvqnooGDUXWDNWrQGCMSXascIgBtEKSbX4VRGShmENFKVBoPpoiSBxKK8IEj1hhxYCYta9Acq2MAAnEMAeZipjTSVGR6VSmf2BVsBRCeNfodypZ+IVH/skk0UBrNZr1Ia7p0BpwBZ8AZcAacgS1jYEIxumU55YlXWSiMdFNjCJQ4RCorUdUSunah92Oksd9FSxksq/HEzbF6BtiUAeeKZK0g6aqaqKvCmvyHZx8zh/5/MYzpcrMz4Aw4A86AM+AMnAADU1uMHntN+neipRf1h0HbFKFAyj/rVIvo/9UkZ5/45GZZ5aBjASgchdofiaou5dikh3BmUFl6qqrPKL042vbnejAQqyClUp+BoghPUHnkV9yAqvYfVVCtfrJBIfbbcQa1R0PBWegCDaOpXokaDy43lgGP7gw4A87ANmVgRovRZsXQ1IUfzUN+NPfTfg4uLVpzlOqqX6Icz6hVh3fHQQbioGHj2rqzSbQM3bg5PLIz4Aw4A86AM+AMjGVgK4rRsclM6OjLMxeXWq9kpTeqCCmfiWKhvEAC3ADKADACM6IA0xkITDdZd0kuSWkapPHA0mi5ejwMwCFojqQJmpamThdQS//Zp1rs2W/HGViPS2fAGXAGnAFnwBmYFgb6irxpSWoVeVCGglwdlt6ch5aa/sheqSLqVrf0GKxuuDIlDGxZjbiKq3/LcpuSvfE0TgYGfA3OgDPgDEw3A6u4HU/vAupCAcVQ5loXpmMqUZxLT144TAUoDeBQozZjqXXJdXAspfjjBBmI1XgUULXq15AE1M1K6Tv75JtGiFzQGSij4lQDeQ39X1qwOJwBZ8AZcAacAWdg8xngxr35kx57xjTGpS4uG5VJr+bIg1KjEu1mSxZUKiK5a8C/2Rw3bdOHKP1N2dwHOdbonxlzv0FbGCdAPexZO1lzqmRjs6u8hrYg7+/YXhn2Z8G4q73/q0jvHZE9aBZCcIC7wxlwBpwBZ8AZcAbWm4FivQOecLz+0qAKp0VDpdevBQdjNEIhQEJKCuqO1E2dlKpKlDIC4Kc/2XcpbHqQWM1G4QGyk4ycS7uIr///P3qihg9gCFK7qmdRKat9JUSNsWNqDxScTDYUDIBUkDWsH2MNGKlhRpxx0wXpS35iAlk1QQuYrp40mig71vaS/0sIUYL+X2fpTukGabOKEqXaBThntmw3o8lskBhDhTyAZn4te7Pe8O9tvIZMee+5hDAXOh2ebB+w4aVU17K3tPiLM+AMGAMunQFnwBlYFwYGb73rEnRzgoSg1UQIKpszanFTt7XKqRtUG7XeVHK9URrG+ZTd5Qv1S6mJqL65NNYrrhXRR50EZoAJibFGSwSLwYxiD0ymHIdsknccw48xpI4+vC9Dlsl7rds0MFkzAjrVKaxkn4oQrLmNqDNBdzgDzoAz4Aw4A87AujFQ3X3XLeAmBQqBeqFRKlTT8js+VQcQShNQ2vEEuYGxRjaMFbjpkZiIlC6E3Vq+KJc6QZaCLAdB4ZjTSiQSa6J5flnaY8lHK4qhtCddGqJrASEVYMMEUKSsX8Ue9ALT10OG0B8OzkEZWTOgO/TvQtnZeClE/0KUM04g6hwbnSNVHMDIrnFGEhnX5XZnwBlwBpwBZ8AZOH4Gtra4WkPeVJm1d13ABEqq2ir9/3C+Yd94da2VzfFnxEzUaMCUVQXCGz/kADBWoAfVJMoacFxFWtASd5WTsNBVerqbM+AMnBwM+CqcAWdgezEwM8Xo4LaEETVKSBH0e+IG+m29FtUXsDZuIOsEB1kdEpUPx49jfYYGjTcE0brMpIx7WHdQzzkR0K5kYEi9AnSAaQCFyDACrqIRs+AXfIOs5sFYsBrPIZ/6i0TdE8JaY7EFQAPYslSb8OQbC5jg4F3OgDPgDDgDzoAzsHUMcDffuslPbOYQchFT1RnNo1P9TXp08LKIGd05ZM0TqLVIUXSiqI11fK49FClp1ZhyOonT4NEh6KEDCezXfH7iN2gBShQDThnWQlJjZ8NmiBB0wtEzKduje9zqDDgDzoAz4Aw4AycTA7NSjI7MU0tDihY9DY1dlbYzvQNLdcg2lBgE5JYWXBRpwJraa5owFpQNsyO1zUT6ok8sQLWh5zj7kONxG8gaTBhOb9KCk1VarTeSuwkBVttFdLBa75F+yawhBFF+aWaonnt6e5GbAr1AdRYFpGFR68CTOKDPyHDQZ/KGM+AMbBcGfJ3OgDMwlQzkG/pUZraapPS/6CRx+Ew0hJDLlJExKHdG2kUGSx+xB1WsaE3TK2K0ZX2Se2SrHyx3AGSEBTkE1m/o6zETss+6CY0oY2gfa5+UVJzU6X3OgDPgDDgDzoAzMHamX3QAABAASURBVH0MzEwxGoLWVuW/WNLyJSWJPMpKFIshU5yq/8godWRGPinMXf2C2gVkG8Pza65iMYLc7tlzU+rjVW0Wqe9fTZXJaM+JPpuhWKaFU4V109BVpRhSxyDSyViRZApyJcX8Az0/zjNAwZK6AjUJBfQqz6jLUA+RFKOSFThXbfRjtO6GpBs0DKtSLX1zrdeYNCOzmYwioKnTBNnCjgB1qCylXjX5rmDI7jkUXQYzmd6UZp9JGfPupPxgAbwitxZ1Dp0OV6K+USfks7y83Oztdrlsm4YRer3kWjGnet46iDlY05IxT5erZKAmzThc5aipdbNV1NcJilmmNuGRibEpZF53TViCXf8mGcWQ5kCaDmdgShiYmWJ0DF/UE8M9I43mNqZ80uLGHEaOrUb13MxZNu6NHai7E5Wh5lMU5TapUgQtFqWcmgaIErup2+GmL4E7eUfSssROCBQCKyK5QqVI1ToQZxATJXVVpLK4gC2wpG6nE1rlXCGoxT7FiioBfKYdlKHHn6Kyffyjt2Lk6173uh//8R9/9KMfjXxcfjzhCU/g9bFjHpuZI/fIdrvNJfS2t71tTDpq/pmf+ZknPvGJj3/842k85jGP+amf+imGjMvTukLQixMfrsw9e/a8+c1vfsQjHsFcNEMI9773vf/X//pf//AP/5D0khfSaLVaOOOABaA7jskAvOEDaRQx6BDLHiFnGgsLC5Y/SwPoXBvrckkQbRPA9c9e/PRP/7S9ZR75yEf+xE/8BDrvnZH49Kc/zRDeF+RmEmWG1ku2jm3CQFl5TNNqKQjAajKq3Ho1IhagY4NQb5U6lVsF7RLBbsjNvuHZwrFgD2YZlEm6gZPH3thBhxNv80HJxwcfJYAPIEDMlU7skrtIKxQFS1yJRVfmU7EQWq2ku0ltuSKUocWyhKMiSyoD+pKkFeEIVHCak6KgFsUVQ0qx213prHRjt5hrR0nLHZ2ETqYjAWTKN3WUJoJYVSzr9IiD+1JuUyM8bIdYJAGVNeZRVWvwdbh32DIwBocBy1Q3v/Wtb1122WVXXHEF8vLq8ZGPfOSjYx6bsJgYo10wXMBMxyX02c9+dkw6HyXzD37wgx/60Ic+/OEPkz7NSy+9lCEMHAm6YuzFv+CCC777u7/72c9+9rXXXssbZG5ujlFwcv755//O7/zO/e9/f27GVBsxHx6vrKyQkuWGm2MyA/CGA6RRj6Ib81hmGlwk9TXAkTwXAwvEMkOLYi94j/B+521+zTXXoKOMe3/xXmDjWB1vgXqZtYLd4QxMCQNUJlOSyXAaq8uNAmV46CTLuGpjnN1iRemfqK6HUuqSKNDiLCDM/0QlpxF1CD5N+AACWObaRavQSpkT0OVCVuaKwy3ZF2SvyLdC5/NH7/rwVz79npuuet/nPvGuT13xN5ec9zeX/tN5N37kvTd/4sKbrrzkCzd8+si3vindb4aVvaF7KMjRIiwXIbZbxdxc0dLToyBhrj3XKlTn80vyg4/s/Coi2/OV7Z3ShR86dIjMKBfqPWLXQgg0RwLnDQWTFkVBAsyCYpfx7t27sY9E7WkKPhSULIHhI0ExQVhA72tf+9pf/uVfPnz4MPUEaLVaJlHoxfPWW2990IMedN5555k/kYmPjsTBMZkBCMSBS8sUuJ2wL3jOCrgA7LKcn5/nquOqmJXMydMuXdJmFeh2qSPRR4LtYxQbxxCAD02HMzCFDEzvXXYiWVEENF1oArOgANM54AOmD0nqS9Bnxhk0TX3NJF2qT2TT44R0wtdoBLIPEQz6CSKCS5Skn6GsLMpKTAclUoB+WY5+4I7Pv+q69/3xB9/8rLf/5Znn/e2rrv3Amz975Wv+9ZJ33PSxK/be+tF9t77tpsv/7tqL33Lzlede//7f+adXPf0f/98XvO8fzrnhve+569++KAfvlO5+WVnWPzqNIXU5H+1KypOIUKfqzMIHn76SRBMkdxzQn9EJP3kkDmDQhy8AoLLiAKrWsV9xBuP8WNi4LrNP6TuFGyq3Ir0wRPgJ0m427BeXzUjYYjZaMjXHTszCZUxK1DFYRsIKHXwAaTMEZ1PQh8FiLfJ11133nOc8h1GAyNgJxUDuu4CBNG323/3d3/3yl79sFOGJgsTBMZkBKGUv4ArgSdEGvSgzDdbChcFaWAXXCRcDikmUqURfUmwKba55kkdhg7CwItY1EnjiZg4oADeaKA5nYKoYmNJb7Ko5mlBerDrGMR2rgpUydNiX93bPOOrn7F7vGjU+bvgoIT4FYqfbCfwq3m4fLWR/IXcV6YY7v/Laj1541pvPffV7/vEjt3z6pgPfuHNHuvsec99oL3+jvXLo1PnD91jYs9jdM985fNrCwVPmvtVauWMhHrjnwrcW42cO38GQv3/f+We//dWvveJd13zzC7fLEUrbQyF0ixZ1WdRylPkCk26XT65ql9e4S1vsTn1Qb5BVaWbhyhmJjU43hGC3du6RJGDTkSH6SOBmPqTNWKsS8DTjsCQ49Tf25z//+UgiIxlrCtEYCyhDseNM1ze/+c2Xv/zlKFhwo4t3FrpjAgNUOfTCJxLqlpaWuLqsiWV2wbXBd7YjR46gsC67GJCzsiIuXTInW94s5I9EBxjHgV5bIBc/usMZmE4GZroYrSvRWlGSg1BFSf8Dhxq5h8oDZFX0kJXesjHhhWM5PdfLHnwKgKxulOBzx6ZAtlttpjkg3S/Iyj984Yoz/+ncl//LWz/69c/v3SEru+eX2hxsJmkV3C1AaBUrsXt4ZWk5drsprqwsxc5yq5DFdmu+oFPa7aLbTksLcldr6arbP/fqS8/7k3/++3/43KU3yl37pZOECYuVzgozAhrIEUiix6UjOo7LNDyIDQIiXKOFRDDs0rQEsT+DNVsU3VbTx8gQBYzpnBUzRYNtEJK7EWnbjQdlq2Bp6HUYAjmEEBYXF1FGor5BcrWj21iGjHTGaKv74he/eMUVV+BMYVoUBQNtOtigiY+VocTBh1FvectbiI+CGxIfpGMCA3wrgFWIogyFTAo4qIZDKJ1p2Ip27NjBKmz5XCGs1PTpl+RP5kjSZjtImORpooyEXfAMoZchSGBGFIczMD0McKOfnmQmZULlk7sLvb+hhahKiEM1Bxa6DdUgax2XtOoz9Fc22RgpZUJImcFyoqSF0xqnYRk1CFNDJBRtWh2RpVAcEPnS8v5/+ewnzjrv1e/5t49/vbXE2efBhXB4Tv9sdFkiP+KLSHeFG0enFYqiHexR1I/Ez/zd7vJK6nSp2rROnW+tLLQOLKT9O8LX4sH3/dsnXvHO11z4qQ/f2tmzX+JRK3BFCEDkQQQhCBi0H6udqVOnvH8o/f8giQ0NWJRU81RNIn79GLKYd7/Tqlp5RjwD5a5IkBl7sDuApLnTsOMonGCZBX3z0e12qWOY1+6UKFi4KFHGAX+Sp5e0cUaZDJyvvPJK4rdaLRaLwsLrgfTadCgGouF2zTXX4IOFpkkUxwQGYJVeylCKexQAb7MOrhYuM760sBBWhMJVBNBnApY2qyBb0qbJcqyJZRjWhRtd7CN7au8OmuJPZ2CaGMj3+mlKSLS6689qqEDgrQUoQ0OSPkhV4UgShS2sv3Cpio/cRxfIqvozSnUO4fpAGZdS4KfrXIFRgAIJMSSmS6prLajjeavr+FU/mS9KtysRdGI+iYxJyIh2km5QdUnkbpH33f7pF1705jdc95E7Q4dfmFZC0SmKDkmQl84sTB1iaklqBayM72Ydnrp1OiFIq8VnV4CcFBLohNgNsdOSOCcrrXT3/Mo7P3PF2f/y2ou+cvUBCUuiYzVJUuLFIPrQA1cRMsam7TU8iUXGRSKL0CmELICOj4EuIK0E6LHLIGqfPlFqaFtC6oElBWL1Oyh//RamCOyaQpRq+OkhB7VJsypCI6hqQSTr2p6qJzVWCJoaK7HEIt9NTNt02Wq1bM4QypSwTM6HgoAhIQTcWAIKzQnA4dZbb0WycApZPBk1IOsmiuGWW27hNswomiZRHFvLANcGCZhEWQ3qvbOtX82Qk8mnXj6L4vqnybsGfQJ4d+CGAwpyTWzj79hkBvgtwmasd9YUths7m2hNPs2siay70IF1ocwWuNtOY8J6H9NKYmxuIVEf0GsSpYnUaIx0aPSvQmX7i2bIckjUSkiTjKWBeqjWVqewzCChm38QbxWtztKShCDdKC1ZjtIJclDkdln+2w/+89s+9L6vxINH77mDX+RjIYBizjAwlaYa6BcJvcRk1COJVm+4phApfLtFXGrJod3FV9OB86+69P/70Ftvl4N3S2dZJHCZgMAASSsatqAa7ixjkzU+iNE/grqwz5B3tij0O0nTrpM220Il2temMeSDTeRYAhrGDazt+CRBHCuW928OA3z46peqEKyQnTApp0HWSzHKIR+6fZSjOCYzwOceDtwa63tbWNcHVRHxmILdREepNwt9AHiy4zXota3HviYQgQuAQpZRBEFhdoDucAa2nAEuTj6meOtxeXOt2pWJggVJeqbcfPPN11133fnnn/+yl73sJS95yU/+5E8+8pGP/PZv//ZHPepR+Ex4H9E7tTiOcmLK1kLJVWNyauY2wocqA+SOIR/2PneUQj/ChnzKvuN4SVpTtbqJ06TY7bYXFoRibb442u2Gllail935xbPf+Xc33fGVg0WnvWPh6NGj/ZNQLQGzoQDTj1/yZlhJ8Wgrfe6ur/2ft736ir03H5AVTkCPdFe09hUJ7YIvApSCO8J8m6Zs9INFgcmz4AAm+/T11tvKhtbo8/DGVDJQfzqjWAVDmrWCPgArpKg5HvjAB/L5zuVtn+kDbt4cYACuYBW6uDW2221K0uXlZajjjbMuIBQ7yO4sLi4yETqS5kAadZNJSQbgiZH3LJLEsK8JRGBFR/I/YCICIBRTozjWiwGPc9wMcDEzlmuSNwgKEstb3vKW5z//+Y973OMe85jHcK0CPs0e/vCHP+UpT3nhC1941llnXX755VdfffVdd921e/durnAGziJmuhhdW/1xAttjE0UuEQtSK9Y8IZmkNTefVjqt/Psmv69zErnSbu0VueRL1//tu//xzvnu3rnYWWwf7ayYzwlNt4rBYa7NEekd6ejB3cXfvvud7/nMx/ZxUNtqHeVX+5YkCuggnaMrgbp5ZSbPC3l7VzSwmChjzzxn+t1RLfHkeuXTmQU9+MEP5r1A7RJCwGIFCvZxoLT63u/9XkpSnCmqxrm5vWYArtCNWG5vFHDz8/PWxH7iIBQB2Q6+YLOJBMRiCvowrAt/usjHFC4AmmsCcSis7R8wEYcIhEKuKYg7OwMbxIB9rBEcxd4R3K1e97rXvfKVr/xoftDFdcsHGgrvHSTvTS5g3PhuZhaMs4gZv91yQNfHemoUFhQZIHf3nWVirJF7TWQffuMGIjGlrgG97A8UX6iMRa4TCMkSUgzFvMRieaXTDQXF6H6R111/yds+cZncc9ch6eyXlUPtFIvABVdNTBo/+v4xAAAQAElEQVTAWigg6yEKyGq/aDKTe3ALkclBbiMii2WKFYlLC9JZLPYe3X94Uc7/7JX/cP37DknsyDK1skBQlPbCXGepK+0ggYEniNjI2fRIJtmIMhScjMGQud/AQNCwhUhAHRdTZa2VyrC2V/feAgZC0AuOYpRPaj6vuVz5aA5BjSOzCUG77ne/+z3oQQ/iI5sPcWog5EhnNzYZgGFKUhgG2CENqlHWC3wrsMg20eSw5okPm45kSAi6s+hrAnGIwFoYRRnK/RvFJIrDGdhyBrga+aSyC5VkuEp539EEIQR6MZrkSkbnyxVN3qqM4n2BZUYxo8VoXD+6R1Qk7Hpf/MCZqLmV8w469HmvrdFJUVqFLFOCytx8+6ikAyJv+8QHPvT5G+5sd/asHOlIau1cjK3QTdEuvrVMUCa8yiEpSCpCebcuQrFj4e545Bty+MNfuO5t17/3oEhHooQkIUo3tRdb61GJrjK19XEbu3Gs6BgzHM+d7xghvXvtDNin7X/8j//xzDPPZDf5CCZGCGN3pyj0I+7pT396jJGPbHsH2SgGOiYwYFxxhzMF0ozMCUPW1MUP9CHozZV9pDpEnzCcDyV62UScUQC7eXz5EISxRLBqmKnRHbPAwHbJkQvbrnPefax5586dvDvMaBYkTT4MseNAEx3F3qRc4egzB/2knrmk+xNOoj+zmrSeKNRMplJkANPVSFfZyC+Myq8hct4H8sB+n0Almm91od+uk+axJyCYPhZz+negO+a7qbsS07KEN9xw6cVf+mRn13yaa7V3LqZWsXzoyGJoS+p2usv9GZISyBmQHshq5VN1DaSKWxhxJmpDucSPHjq8WBTx6FFKzh332NXaMXdoPl5887VvvvY9RyQdXj5MSivt0AnUpgOhLcbxyag17uShWgfDWdMpioCJlhA1MgeioHQkSOJtDHjPlxD9TweU/YMv+QIYNHp7CxigMOKjlg/fs846i5IUnSS4aJEjwWf0j/zIj5x99tnmg2SsjRrp78aaAahD5/YGY+iQBntY1gW89fhJkZgEZ0+JaW9DlJGgcKR4pYshloalhGVNYC4mYnZGUeCisEAsNB3OwJYzYJciVzhA53Ilpf3796OjGNrtNgoOSOwouKHQNHBVmzJbcmqL0WMlRoVxTKaP4UNFkkNMdCv3NWhJWup5UBYxy+MXjO9oDVRQB3VbrSNFeN9nr/7gZ647vKt9uLPMdHxec5Etzs+vLC3tXFjM5fJap6uWuYpxFHvd5ZXF+YUiprl2O6W4zMTLR1eKuH+++9GbP/mOq/6lO7+g/1nTkEh+ZR1r0VWkt/Uua+DyBJL1oeMZoBbhfcHH8T3vec+LL774O77jO9ApaMaN+OEf/uEPf/jD1kv5goI/H98ojskMcIfDAW5hDD2ldNlllyHXBZdffjnBrRxkX9hTNgWJcSTwP3jwIFOTD/4muRiwrAn8pmn+Ngs60SbMa24unYHNYaC+FLm20QHz1l/DeBvS5OLHbpJ3DZ5cw1zJdPGdDTmjOFbNN2PLokACOelQKXpyhg6yXesnagqQm6HvTJQdBXqQFmIoEshOKrAnIQgDDaWRS4EubQih6TJ1tbKQlrkeEbn8G59758cvW9k5102pFYpWNy202uxQJ3RDO1AmzksRNAfSMOShIWrCWZWy1xokA0zPMntScYKUKIBjv7/+6s4U0ukyrBsEt5ak+RAKSfxAv7SzfemXbrj0q9cfFTpxIfWQ4x6HYOpRo5gSFstV4JM0CYyGcgT2GmaqmyhmyTKvVyL7lpIWz0k0eOKdDFJ+4McrEgtSgZe++HMaGeDDt9vl0tXcHvjAB954441PfepTtZGf9SZSP5122mkvetGLrrjiil27duVOYawpGyftWuIzgSnQgSlIQLMGzSkHqyBbmLQ8uRHWzFuX2ZG4IdcEC8W908YiB2IORKPXto80cDZZb/eA84QmA+mtB6KYBeNkWMLDPk07iQ07nPQWW7VJKqR6vWaxJjo7aPo0yunLya52ywv2TKkvNrMga1a5kvHhmB9pOspsgVJn+hOmwgCWZ62Iliky5kEVUvY0/EtL46Xnpka2Vl9GPCcEmdA1ItAoUyQEv9TftrTnH6+45Mgp84fjSmjpvvCsa7CUq76Y5aggZiOSKceWI6/XioGYJ0qFaKXeSsK0XOV7jhw4co+5f7zi4i8e+cZKWeKtHHumsR5kC6y7Vqy5/nJgveVKw4bPu/4r2fYRrTziU5g7H+ejr3rVq/bu3fv617/+z/7szx796Ec//vGPf8lLXvKa17zmy1/+Mr/Oc6hg/k3ayt1vmk5M5yZBPkjCELwoCiSXHMBiEgtAN2C3IRjRpxB1nuRGqkjqNlNYIL1YDE3dLCeNtN1BsnZblDGABFjMjgPNk5gHVjoStmqWb2u39xpvTN4LZrFR6Fwz2K3p0hkYZoCCZ9g4QxaKiSZy5r0Kg65syedhdipmbcEnaKVVJAy4Rd5OaGZH4c0jovYsMQB15WUQWjDiOWheTRv2F6RYTp0DIu/4yMVfO3j3YUmtubnuSofhGpQ8JbaihCSdIoK+JAIdEc+MWsHFkM3mkyVBQF5R7dzzSdJNQafokJZIFrk389DpLu86ZfeepUPfWjl0/pWX3CFHo3QWlKb+UDZi9ZLENL4NGAiVRHutyyQOwHSTNIHpWTKkgi6WY9Fy93NvFqxUI+OWm9tHnAQr5eZnb1XubXxB4p63c+dODkGf9rSnveAFL/jIRz5yySWX/PEf//EznvEMjKzX7o4oNgoFNHWaJwILRUVCPkh9Q+RwptBLhpYzFnzQAXa8aNoQfGhOJ5q5kXkzSZrA1tK0n0w6u2bLgQdWCqzJ3gHTMeJGE8Us20eyahbL8lk7QAe86biwUSANYAc0sSMdzsBIBoqR1mk3apVxzBz7a5RjujcceGtZq1ZECxqz9aS9wXrt49LIMoT2B27++LVf/ULrHrva83P2+c5RKCBkEGG5FM3dQkA+s5TxjzS+a1KPrYXBOgWT5fUyL7BhZCUtSa3QOm3nJ2//4vv/7fLl/Ns9Q8zhROUGlIa2qGMlFmUDpj7WpN5/nAxw8+Ndyc6u6P8Vg6AQiBsedu5//OyLNCNudBmwANORzS6aJwJCWeSlpSXi8DaxJgpNesmH3FCwAHRA09zwAfggpw0kSUqWGzmjIwEKyQN0YG4YT0rYZcYaa7Bk9rFeLDqXnzXhxJRtJe280/iBLgiBBwAJXDyALnSzoGwr+GJXz8BsFqPj1kdVAfp6KZZAz6Q/PUvvTDTpf0+Ut0nSiiRE/HjnhBQzJCQMTXDO1s1DupKdm33HoTPfIYl3yNI/X31Z+rbdKyHpmWiMvIG7Qf8wk5hUhq1ECcrUwotI1KmZHdCtiGpUpf+JQ2AhwioM/d25FaKAmGoHBrDoXAfH7EEaRQxFaLcOHT48v9A+vHykc+rcJTdc9cWjXzsqna45rZtk0qgpkdUxYsaRq7aFICWyjl4I3dYQLDKUGnrdrs0IA9zqyDSEwLEoCu8UJPUBkpvi/Pw8DtZEAby36cIfoBiaullORFo0y4epgUVjakAO1sQOSBKjWeiqdbNMjyRPkrH0LE8rudABXbZqFHzMgn7ywbbV1sVKUZCsnaoLhSZ7aheh6cjtBs47jQoWDl0QAj/Argq6UOomPg5nYCQDs1WMUn/Uq6DUaDZr+xoU3icD3rxnmpbKgbnUXDVrPTYtWCl2kKsHP8YvSfHuj192sOgeasVliSupy0dbSFodEoeJKUABehD9782jrC+aSwgi9heiKUQmTUFAEKG24wOltTi/1FlZbsWjLbJdueiqyw5L6lIcy9Q9mouqkxtpZGm1gyvHy8DmjeNWR1XE1Wi7yRsWHYmRLvLAbgoSYDHgA+gFZlkXybzEoXRjLtNpAppMB1Cw26S4cefGiAOSLiQ6duRUgTzJh7RJ3vJEYiFhFCQ6vQAdC82TEiyQCwwSWCagiQRUXUi6WDUK0nSUbQWKctZrDPC7BHoNuyqgxXq5r9VdrjgDwwzMVjE6nH9Vj3KQBsp+jKBsrP4lv2cYCJqDKAitOWA34wlJitHPHP76FZ+7cWHX7k43HZJO3LWwwjloknZUUAt2CgEkMd8VMH7DcAE5H6gAWe0XceA0kc/WpkMhYaHDvFqJrrR0XkpSJp2PQpe0W0fnQnexrZ8vi60bbv/CjQdvWW6OX1+9bwlxIPMRU+Ef9OtBY1FJKKfZ1xAaxt5QenoN12aHAe5ztnf1tnKrw9jt6nc51oHdKjxzw7JBYFIiW+nGXEePHqVpU/M2QQe1ghsZYgFkCFAAduRUgZxJj9VZwuisjgxN0jSdJrr5YDn5wAIhgasLhdUhWSywIgxLraBvQ1CU16vmdwmY4XoAZuSNYNTZH7GY0eV6MHASxiimdU0UH3VqJAlomkRRHM+ZFvWKDrVnY4oQ+ZSRfMiHAsxDjwTRAp4ADZRKObt2Sc9fhPIHJ31JJrSlTzpA5YDaETki8pGbrju4EPYvH+VN22q3+XKJgr8uNWhRyCElJSkWZgy5TkVvoMynYRmnDnrqv+Np+LKKQsp/QY8Z78ihKFoGWS2vHOXDpd0uuqmzlLpHFuWS665aktQRfhHHvVovazPkxaJaB0qGriyHFD14TVEC80SzDMhAb96UAfu6NFkvcYxbFMesMMClSKrc9pCAWqGpY+FeyOZS4VFRWROLATvAuF4gGrMT/Mtf/vKVV17553/+52efffYv/dIv/fiP//hjHvOYx+bHE5/4xF/7tV/73//7f7/4xS++7LLLPv/5z1OzMhDY2PVKZh3jwCrpEZBsP/KRj/zVX/3VS1/60he96EVnnXXWy1/+8te97nUf/vCHv/a1r/GBgJvtCM4nK771rW9dffXVl1566Uc/+lGUyy+//Oabb15ZWYElwO6frAtfzbquu+66Cy644CUveQmXx5Oe9KSf/umf5soHXPaPf/zjf/M3f/OFL3zhX/zFX3DB3HLLLasJ6D7bk4FeZTBD6w8UNaRrRUyIVDO0MqL0ahecgJoLiSVKA+dn3fITJMRQJD5P1S8/U4qR6iroL+W4p/oh3Rw86nQhosNdkSQkoqU8VOemQxs8kw5YEa3E9Jn4DX4FMw44dyVRiX4t7f3EFz9zeK7ozre6KXIaupiKFDsUoN1Ahae/y7NYIDQVkrRAJEYNQhqIKrgB/Gskfkgv8xJ9kHlGzk4NJJiCLjZK7Ka0AlOBc9A4l5S0FGKniCtFjKkzn9KuUISlJXLUH+vb8TNf/+KXl28/IitdIdsIQUBIh+yQLFmYOwo1ZYrYlA3NX5kjQ9hjNhasXjjqSKkf9FY6Q01FqZEteS1BcjmrKaTEXBpHp2dbQZIu0F2uIsYQQRe7kiP4ECslhvAqohnK6MeErtED3HpiDIwfbbtmsi6GrGmSoRQKSIAFoFD8IWPkKuJ1NOpec2461RcJXdRht9122znnnEPp+R/+w3/43u/9DzFUNwAAEABJREFUXirPP/3TP6XivPDCCz/4wQ9+7GMfo2oBVDDvfOc7X/GKV1Cn/o//8T/+83/+z6eeeurjHvc4mp/5zGf4/mlTEBDFJBMBmkxkimVF0xzoGodhB0bhXE9EFUXTjBaWZg2mu/XWW//yL//yCU94AmddP/RDP0RV8YIXvICSgoID/Mmf/AkVBnXGd33Xd7Hq3/iN33jDG96wd+9eIjAWaTFNpzltIDFQZ2XZWtM4YS3vete7KL7ZUNa4uLh473vf+xGPeAR7R431qEc9CmYe+MAHQs73fd/3/cIv/ALXAIxxsREKWKhasZgYm5MOnBTSZW71KPy3EHapkBWwNGqFJknedNNNXOrww9vqwQ9+8JOe9CS+pWB597vfffHFF19xxRVc8x/60IeuuOKK17zmNTDJxcMFc//7358rn/cLVxfvHUIZWDsxTTc5bDH7sKyvdoYM99YWyx8JMNbONm/dpMuAG+AtTKoU2U9+8pMf+tCH8g2TVXANPO95z+NtfsEFF3zlK19pjkUHFgFJbgRBAdhrnWYNEmjaGVJ3mYIDJJs+LLnqAHYLgk4E0zGOBL3EpAsFiW4K+taCsmBrE1jr7GXCVV2x1uH4xx71lDIYStj9qapISqNQ2wkP88yS4glgyyVUfm2Icnz5omVR2ZmkmJtD72rNpnXqksjVN92w1C74QZy6j65W0j/ZtKVRdAKmoEnFRi9NgAW9QjVN1R5+7buOc/749BhoJKj2oG2CUikaMHYLsXmx8At9EbFJN8hKK5H5VTf+KyVmR9TaiZ2yWiOEekn5ygvIliiEyZqKiGBOZhB8q/QwHjf61kvQusTs19cYn+zBGge5+8YwwNXLB+hVV11FNcB280MhcgJw475oFZiVrXxkT0iNXuIzizmj21huJ8yC/c4776S45OZ03/ve98wzz+SetGfPHgLiCVCIgBwJHHbt2kVAjhv/7M/+jFLvB37gB6jwKIA4ymWISdxsLnJAwc7sTE0TB+43WEaCgTiQAKNqwMAP//APc2RFIfXIRz7yZ3/2Z3/sx36MioozLTwZQmRAQM6uKDS/53u+h+qTQ1zyxMjUFgpPFDxRGEgylBRUos985jMf8IAHPP3pT2c4/vQi8UROIUiMJVhiKCyEhFG+9KUvUTmxI5SelJh8VeCLBGeideGIG6MYDlg7OkMov37v936PMutHf/RH/+Zv/mbfvn3mRq8BT2jkXJA6Bs4p4Khr2QKaj370o/lOgsT+kz/5kyiUO69//esh3MZuieTq4oJhatJmpZYMCpZvfOMbnHFSgsMSJSb8YFwTjhw5cv7553N18TXmB3/wB9/0pjfdfffdUMQu8HOBhYJws7ApZhkpLTGudhJGJ0MoRY4E3yiwLywsMBGfBsS3mDRRaDIXQEe+8Y1v/MVf/EW+YfJ++cM//EOK7Le//e3XX3893zB521Jn/93f/R2Xxy//8i/f737348r//d///U9+8pMMZApCkQ9LIBQ6FnKjy3SMtkwuEow0SeDGG29k36lxuQC4MJgUhabhp37qpz7xiU/gORLEAQQBOPzrv/7rz/zMz8ADl9k4cLExHT5IFsVAkmRsia17KWu7rUtgI2ambgA5MvUNyKoJuwIEIxDJ20BJBOTEH7BJNQbqUD1dT+yESjTPqJXXksRPfv4z/RPTAjYaBZi+nrJkYELIzMyEfqGeBKIl6adu/uxRKSs+W9qkgRvWN3JRTWNT37AsPPCGM8A+2mV2+PBhu1ny0c/n6biJ7V7FrchqVrsxEGScP3aOhQjIRzygic5YFJqUoS9/+cupPH7913/9hhtuwAi4zQAUQG7444k+DocOHbIuJsKfQzVOle51r3tRzFHc0EWSFpBe1ki2gBxoslgcrBdlGMzOcPzpYggSZ/LhhkfpwE/M4JJLLvn4xz/OPfX9738/DjgTGbzlLW/5r//1v772ta/FyChCAew0gSk4YwTEZCLsACPFNIUFN+anPOUpbA1Gux+jTBvgkPzJyvhHocJ41rOeRfK/9Vu/9elPfxrOMbIoJD5IYwPFQBdrJwgMo2OEHO7rv/u7v0sdzxUCGxjxQRINN747MQuAf0BZw6khYBeQlKpUSCg0v/a1rzEdA7cKtiJYspKUZNhrrlKu+e/8zu+kOLOvHOa21iQJy1sSulA+97nPcc1Tz3H979+/nzepMUbJSC86bhPikxi90EtAdLaDPLGMBPvILpjDV7/6VfNhCoBOicxcfKWk7uSryDOe8QyOxtlEwtJrYCwToeNJNBTGEhM2/vqv//pHfuRH+F7BDtKFmy2BIbgRhCEozIJkmUgsAAUcOHCA64ErhAvj0ksv5Tj2yiuvRHIxEJB3qw3EcxgWhIkAvQcPHsSfy4yxI0FALjYDlxxTM4qFILcclE9bnsNmJtBX3tlGMn2toK8RVdVbDRtLaKF1KSVcmx+MKeNEbjn49buOHOTcsRq6Ga/H+gSJcsxKtJFmt4j7Vg5/4cCtHR0W26HF8rUy5SW76ZpReAn89K+Q1T7iah1P6MhTv43k3V/DdKtPzD3XnQE2i4/Ooij4iOdOYNezfRCPnIu7GvdU6j+U2iGEUOsDCqHwJyzxi6Kgyd0FHxSqNM6E+JGa+x8WZkcC8gEkhj8D8cQ4Djt27LAui4+/NVE4fXnQgx7EKSldBMRCF7MQGR0LTe5zzI4FfRxIg3shvbZkBmJhCE10FLpIkphf/OIX0elFPjU/rILEgic+AB3gjI6bwYI0dXpxQ3JmzE/b//RP/wSN5jBtEg7ZU1IlQ75RcBDFERHnkawR5rHXnNNkpYAu7CwEHaAQBAss1bUFo7BTDfCTNKUJJ6YMx4KEeXaNTWEIU5snXcCikQk6wBOJG3JLwLkd6ZEAaSPJgZNLDkGp1Lk+abLLSMDaLXn01YPhrBE+GctEgLNkfiL4T//pP735zW+ml7BEg14SQJmA2tMUGLaERw6BfBzM89///d/ZBdyYAjCKd+UrX/lK3t2s9I477qALkAP+9KIDciZzEkahuXv3bhRiEoG0sVDncRj5xCc+kR8caDKcLnwIYm8rZrFoWFg+PoCYlgxGdHNAAnrNzXSaI2Gz111MytTMOxLmRhcKnoxlXhSaW46qatjyRNaWQNTipxwSRX8jNlma9IWiKgz890S7tgc21rZZPcsnZSXIjRCT6B8aInN7lCD+KLPaCJPLL0TJL1oIHCCy66hJUkfkui985mArRto6ppl/Q2cWoA4DT+YADSNuIVLsgso6GKdcftnNcFA28gv++XVQYB+IXHpQSS/NF1f/2yfVQ+xvDSSw5nJR5laoSa2CuRiYkzNi8+qTxOtrV1vcMIbIPupi2avSTOgU8qM0ZJ9SL19iDlU26pc8iOG1wZXpZYCPbK5ku7vwhpqcKDvLZ/3OnTv5gLY7B2MnDMGfXj79+Yw2hULhpptueshDHsKxGTdmjNywcSMaOr18oKMQllEogLmQI8EhB2NxID6K+ZhCQIycEvGD72c+8xmLZpIp8GEK/NGR40AEPO3mh785owDsNgqjhf3617/OpNgpRDkWJSvjll50AL0EpMlARuGJpIkRizVN1k0iUPo/+clP/oM/+ANzo2vawK5xFMch33/7b//tyiuvZFEGlkaqcAJdWMif1aGbnS50JKALSZOLAYUmo6ALTwZyunnGGWfw8z1s0IRJJJtCNJzxRNKFnYHoXKJIfJCgVtA3GdTWpEQCpIr86Ec/yo/pL37xi8mWJqsDpA2Bx5cYw6nnCEV8Vg0VkIbkffG0pz2NH77ZF3wgFkyewgYSB+BpYVFGAvLNjhsnsuTPMs3yqU99ih8E2CzKYgtFenSRFRJPJsKOEZAzy8fOtw4kduKQMArAwm8OD33oQ/nKSv5mZzgfVuj0msRivViIRkpILESgC4kdCfCnFyOWkWAUPnUXOhY2i7EjgScBWQgKwBN/gL7ROGb84pgeU+ZAMTE5oxElRR/XFCgi7JOUDw3Y5yAUjQNB1EfEZDls3Av1lnaVL6qWT2pRjDkwgVZEPv/vtx2dEw4XS4dVvTB0VX7DTgNrHHY4DgurWZpPn7v9yytKDpVhV7kLWsgLixU9Cq2vsCDa7M3CRoBe27TmAiPlpmhk6xohRy5qpHHEYDfNIANsLp/svH+5B5A+H75IPsqRI2Efu+bMpzA+WKyJPgwic7/BhxsAbjT59fkRj3jE9ddfj7NNjUIa3KXoxdlywMgQMsHIRzzNkcCHsTYEBR8kYCA6lQ3VAHM9+tGPfs973kMCZGI3RRSaeBIBz3Ggl5QovvHHh4mwMIomktyQGFGwU2rAydlnn00lijMWJJngzBIAM2IBGJE2FsWGIwllYAjO6PSiMPa8886zgFimB5BDMtdeey2noX/xF3/BElgU2ZI5QKcXTlgvTRZlFozoSFDbWZ314o8d0IXESFiUV7/61c95znMosyCEgPibnS6aSOa1sNiBXVEodG0hyJOFsAoujMc85jHf/OY3yZ98sNBF5jSNRoxrBavjeia+DSQgYU1Hnn/++Rwq33jjjbhBDpZxIAhdDEfCIbUmKVkTy0jQiycD+aqAA6tAnnPOOfbdj7cMTXqRAE/bVsKaJzkDusgNCaACNxQ8WYW54Y/b//2///fnf/7nKVgxYsGHUfgwBB0jTRuLEdhiUehC0oUkLM6khBFlAlgavQRnILMzkOEjQS9zIfEkLJJReDJ8y1GXClueyXEkEGXwXI3qKMcJvTNREdyysRJcB9mIHZi1NzAXQGY0WfvkJhVXfh0pAtYqklVjasGo8yUJZStK2CeHvnl4/3I7dAPdkWcGCsgqhRrIqo7WVVRdA6vGLQycXOIJ8uAQWVH/1cbxYe7qiZin6LUrTe2sGJQWNFA2RE9G27Kve+RO2ZuEWjPYRHrcGyqngVcdrmEHzL0mCfcapuFvSpY4AA5EQTaIEsKiAg9LgCUryl6IJxuCgMqkrzEERpG4Nvw5EwywxXyYkqp9ntLkFo4FZST4wOWTurwqRKgMGIsFOQ58QBOKWwhuL3jBC5797GdzU6FGxJ97HqHoRcfBFNz49MfCXJ0Ov3nY9YZhBEibUUj6UJjLFFsCTepRLAcOHPjFX/zFt771rdgJzlwY2+02Q1DIATkS5AAhhw8ftinMh7A0kQwEJIwdT4z8qv6KV7yCJpFZHZIZaRpomjNGnEmAZOgiCMOR9BroxY4DQ5gInciWNvr0AHKokqlEqUdJ1RIjbRSWxlpQ6ts/izIfVmQKvaC2owP8iUBkCMENCV3YwRve8IbnPe95hH3f+95XM4YzDnjiQCiaxGcUW48E2LcQJMAF/6xnPYsDUb59kTbJkCGpopM5DqwIulDoWhOIgz9rJxoKAU2xUNi/+tWvPv7xj+eX7snx6WUs0bhoSYk84Z9QRBgJEsYfBybdv38/Ev/f+I3fOPPMM/HHzlsGCzqeNMmHbaWJEWeazMWk6GanybzENAsSZ3NgCFnxZXUYY+YAABAASURBVJJSnrlo4kYvwA3UUxAWmN3G0ksTIwpp4IliEmUcGEIXszAEhcSQI0EoC269DEFhLcgtx0wXowPsVVUFlcpAT90M1B/UJdpm/4BqWsrk10nC6phqikmeI/oYliTPGzUO54ff2r9nf3dpqUgpm0eMGWtKY3vGdDQvPlyqVaOeKCiBj8jKcktuv+ObLEwzi/oPtfLfxworZnEARaEG2fzHuPU27OR+zLx0Hcd0coeNZoCLmZs3s7B9gA9fKh4+TLGPBJ584OKGgsOO/CebEz6scSM+DtxCnvnMZ3Jwwr2HT3AKBboAOnGYkdlNIT4+dBkwAtNHSnoZy72HgSRGKCx4mkShFzs5PP3pT+fMEp1ksAOGIHFAjgTp4cMSzKeeBWcszIWCAzoKafN7OhJ/ZsdokhnNkybOeNIFSAlnFGbBwXpxAPgwFw4YGU498ZCHPKROm94pwete97pf/dVf5QdZsiVVFkJipM1yWBoLsZzpghO6UJCsiC4U3AAKdrPgBiFE4DpEAfQSHIkRST161llnEZa5bJTZGUgv/nVwLDTxAXRtFSDnsY997Otf/3oSgBMkIEkWTnroKKydLmtiWT2IwygWiAQMhBkkOsCOA9/E+GXAzkfpGgf86aIMhTcUwPBxIGEc2AKS53vI3XffzYEoW4ORLowo7CDDaRIZxSRGFBxIjCUTAU96aaJYEwXghgOKSXw++clPPu5xj7vrrrvowg4wAhQCYgQoTMEFY6OsCx8ic52QDKtDYh8JImDHE39G0eQjDgXjSFgoJiV/JsWfsSM9N994vMXo5mfanDFQPQAzUQIZcjP0nYmyK0APyUIMRYL67KRjsSctnBirtqS/LesflaaEBYca2tv3DElANmlAIlfNlP+7ldoTtMKFXNBXxRRFEokSvnDbrSscI861YohqwKbQoYIFZLXqsgZDgelZ4hYik4M8dR0q92aRl5M1FQzHoKgi2xDtazzNWEYWotconUoHDTfXOpyWb/vm7SvCmVAsWi1zocuU9ZQhCuBANLKEKMox8+i2shGYgO6yctybNiW2FeCJkW8j+CtoAIYY0EuYY9mwl749NJPLcQwYn0gcTLI76OsCC0VYFPtgJSwfrMgJwLnZy+c7TYIggSlIQBPg8LSnPe2Nb3wjOmA4QAFMap/7OAOm5naIvQa9tV6P4tPfjAzh7ovk3oOCsfZBJxqSXoACOLy54oorUAC9xKm7sIwECXCDMTeU2ofMiWDNWrHZcWOUDTFLUzYnrd3MmSa3NIuJBU/TX/SiF9W6WTZZskDyYVJWbQqSAosDPyzY4R/JwpGAXiTAYpmjcBmwQIxIWya0EBmL+SBxoxc7RguCbsFRMDLdS1/60i984QtEowkYhTQfhlhALISiiWIDUTYUNheT2ix1GqeffvpNN92EkTwxWjJNHSO9rNoi1A4YAXZgCqNQmmAIsCEocEIphgM6zgAdcE75yEc+8rbbbkMHxhXz1tlirJ3RDRbW9AFpzuyF2Sl2P/WpT6HbEHotZywoJIOCRDcFHQUQwYagA7ObhfSwADOiAEpqvtOag41t9prOLHThbEDHH2nN5pLN0pREwBmL+dM0PrEcExaZLTim5+Y4UCxtzkSbMguVSmMeNqbRMpUKBph+4jJpbbS6MEkrJ8qn1EmRqm3f4YMrKLGbJtU5a0jVrsiBXJLof4R+wDipqQSuYVJCxRA7obvvyIGO5P+AaqBUTNiboA2MAMraZtdx6wPrbe51U6/jD/jXdlfWlwE+E6HaQGQ+5ZEx/yCAMj3gIiFJy8fSq5sYOTLhJ3IU3Piw5lMbhbUAjKzRmtxFaPKTHJJihQg40GsKRnNDsSnwB9wtzAGFLvNHGQlm/7mf+7m9e/eKfngkBhJzpOfxGZmdlCxti2CpYmdqmwsLdTM6s6PjhmQIwI1CgbVjhCXsRHvCE57w8Ic/nF6MWwiyJSXyIXNwww03/NEf/dG4fHCmiyWzBMAomgwHO3futGXig4IPvfjgwBphBh/iQwJNs6PjjBELbijj/nul9G4VyJDMWQ6SHCxVvoNdeeWVZiFt7Eg8bV1IloYRBrCjACIg6cJIECgCWJAYGYsRSS9GFCRjAQoTYceIT+2PwizUo2eccQY+gCae+DBX/RsF9tXDpmMuUmLUzTffTEDmxW7BmZRvlcRHwYG5gOk0caMJ0E0yFn+iMZxe7CPBjBdddNHLXvYypkPHh+H4M7AOzqQ06SImEuCAxBMJuMaQ42DOBCETIhAWOQ7NIAzEDYvNjrK1mOliNPVqQaqoEDkRAyKUUxGildlsR8mkY0cFSbQyQqKLBsFN7IEPGNaxVP6oioGmmgae1JkAI7JV/lAdOJpbEbnrwN2hVeSs6K8QoiZTtmL5WqZaTWc+WVLYAcnrrZzza+5tVKKMNeTeMf42NQFriGk2qJRkBbShVIdYCEx379h754pQjJZd2r2GJ6PAmAF5LZIl6Qi1bklIz19Xmh1wI5tehxAWmAEF7tkKa2re/c7Y8UE6jp8B+8C18dDLxxyfwkUxpZ8zpEeq9duQJqUVP65xHokO+Ignf/OhCWpnVsfnPksD3AYYiAUHdFOMCnQcGEUTf0A0dDxR6ELSixwJZj948OD//J//k14bRUBAc13A1KRkyZA5TcKaxI7OpEirm5kX0ETSixtDcGDtGNFZDvb/83/+Dzo+FpauzQeZMCnbRz6kwU/Pv/ALv1D/V3voGgA+WGCb5dgoIrAKJFURXdiRAB9i0qQLHWbQsUMCQeCEhaMj0fFBwQE3fFCwoBjoMmWrJPkwNetFAk6O3/72t7M6Fk4TsASkwdxYGk0yZ7E2HAtuDGEgxsXFRTyx0Mti8TRJLxaaeBIBYEdix8hAmozCAohJkOuvv/5P//RPaeJDE4lOfPxRjgMWgVmaFS1Gq/b4VkkahMUBxWYhK9LGCDDSxJ8ylF78MZJq7UBzADgT/IUvfOFnP/tZuhiFxEgcRjERlxDAyAKt13S6mA4jTbt4UIZhcbAThEzqCCgjQVicLTI6w3FDYtxyTN1NYiMYgXQLmxXKMmutXlKjHMeovvgUQYCKNEngZHTPof1zrXY7FFpg9TkONNJAe5VNrrDK8zgjVMMnvZJ8KwpV6Z379nSFFiVh4pICutiBodmUshzoWWWzsahVjui5sfWgbo8PxV7XXkNKGrLMmuHFG/x4yUtecvbZZ3MLQXn5y1+OfMUrXvGRj3xk2niyi8EuA/ss5qOc2wOf+7/0S79EtmbkI54bD03zR8HHumwsdj7ZGWtGetFxA9iRAMWc7TaMJ2EZuGPHDrpQkLiNA73XXHPNG9/4RhR8mIIhKOsCEiMfYhKNzGmiAKZAp4sbpzWNBzztBomRLoagYMETnQwf97jH8RsoY4mAkd4tAQkApraEn/Oc59x66600x4El0IUzi2J32CnWYiuyVWAnIG62LmtaF3b8GU7TdPNBxw07TQMWwtYWlC0EyyQrywcJP89//vMxsgokiZEtDijQgsSIggWJP1QgcWbteMIVdtyo87CjsHZ6TUFSk2FBwRPJKNyQBDQ3jIBQREbBjUvuRS96EUfaRMaOJAcUhuCwJjCK4QyxsczILBhpkgbvepqmo2DHEx8kvZY2OqCJpAzFDQVZr4vmMIhJcHx+53d+h16Gsy5G2RRY0C0x9BqMMp31og87WC+SgAAF4AmfKGSOPhJMhwMgMjmYRMGy5aBs2PIcVp8AhQLo8y+Ew7nemWjSPxCE2yQhKkR0S1IMCqFckuYjcM6mf03IgP7zxZib5opuChIdoAwgDbRHNJkq/1TfEf2PjN594ACHfEWX0i2KpYosh8XG7KVJX3AILERYhUGNA88QBcRkDsiB/sEmzmDQOrId66yoPgFOyBC7cyHs15/p9W8CkoQCyulbK8anwSqAxNQMGfJDFxvK3ScZkJO0VJHNET09kSnTGXrmbaFRKW40KHcpRpnlT/7kT7iXgCksRtls3vV8yiPRATryj//4j7/4xS9y+sJHPLcQLHbjoYkOuDOZzgXIRz9NjIAmkiNMzgUvv/zyr3zlK7gRHMknPr/SfuADH/iDP/iDn//5n8cT0HXkyBEmRaHJ2HHAh1ko67nHAG5mDBnnvFZ7q9UiQ+LbQOID4gPmpYuCwLrgAQueLAcLOdNEMYv5Y2TfsaNgp3erQAI2NYmdnx+1xewDkkWxcNaL5IYNyTiwEIARC03wkIc85DGPecyjHvWoxz/+8Sh0YUQyHIW5kIxFYSA6CmPpZXZ0PDECdOTWgsTYU8uEDH/zN3+T82NSIkmMJAwV6FjYSpxRkHTRpAuJjgPrvc997vPkJz/5r//6r7ny77rrLqJhp5dDZU4EP/ShD/Gm+KEf+iGLgASMQuKJG84ERKIzL5GNPdLD5w//8A+RAGcSwAE3mmsFA5kFMBxJNCKgE5P3O0105kXBDiwNRqEjSY9e000yEGdqTZrjQEy68PnoRz/6ute9jgh8aGCxgCiAIHU+NOmCHAZipAnIBDkSOONJF8mgMBAdf/SRMAeLzKpxRicIypaj2PIM1jEB2B+INsDygMNAc2DscTT12I+Tv/yvl/qGU0cFOtRGidQVObKyVMRUdLS4VOv6Pdd9URNSY0lzUf+LTsudTl4XQn/+1h/SJwwb26XDBzq1DJUcc6BjjHHIa9CwmfwMzj0F7bDBDz7aAJ+5rJWpkHyIW1WHPs0g7Ztvvvlv//ZvSZLTHSQf3FaKsQSaOCDt+kFHwQGFxd73vvd9zWtec/fdd19wwQUvfelLORr8zu/8Tpy5KyBx+LZv+7YnPOEJL3vZy3DYs2fP3//93zOELqOIUOgjgQNBmIWDK35FJRN0jCOdj8NIcEaRIRLU8ZnFuigIKLwe+9jHcuRJEfagBz3I7qbmQCY2liXg/9SnPpUSjTjoAGVrwQaR4ZlnnknOZEjO4/LhXs7a8QEUB7jhzBLAs571rNe+9rVf/vKXiXbVVVfZ/5XiBz/4wUsvvRTnW265ha1/7GMfy0QMYSDXDDrOSJpEIzie6MB8UJiu1mluMpidGS1VlPe+972XXHIJCZMSErCtljM6CqtA4WJA4m/A+YlPfOI///M/Q8Jb3/rW3/qt3/qxH/sxLnXrhQFo/77v+z6uHN4UV1999W233caXvdNOOw0H+0wgsinkw4zYiYkR2mkajGq6oBE5kAOW1YC0bQlExt8kczEFdnu/m518yPD0008nZ6Zmuy+77DLqaX7h4TeT+9///qTHQFbHQIYQGaCMBJ6ALpLn+yTLRGcJBEEBKA94wAPOOussepkRyW/6fIHnKz3f6/hWj2KfFTgPg+FmtGR+4id+An9AhJGwLiSR2Qtbjo21OFsoZ7QYpWoBx+AtXyK4ARGZ4IwDMAcUYPo4iQOoe5t6bWwoKetZZtdAMco11JbQysbcPSzoA9k+9gyPeCD7ZEHY/FqKECgXSz2/4AyyOllQA4IhH44eQWkmK4kKoBOtAAAQAElEQVTS7cwF4f0WqRgpECWX1yQOpO+BAfSZVtFgRaByJEAK+dEwVp3CkezAeiU/YqjWMjCKSNlhGwkY2FDwKc8Hrn268UHP3QhyORhAThUgYWD3OafkaKdOkpsHPtw2WAUrqu0otihTTjnlFO5SVIrPeMYzdu7cidHAKBSTKMxFNFP4df7Zz342Q7gDQRQ+gK6R4J3FWBIA3KiQOEPySOfjM9bLYSIikBKpUlW8+c1vpnpgRs50uR+///3v58b8yU9+cv/+/TfeeONv//ZvU3DDUp0MOisiAsMJxU0dfavAKsicpVEk3X777ZQO8IZlXD4kTBf+JA/n6Pe617042uewkFrzKU95yvd8z/ewQOysF2dgTQoFdvPiiy/mLPxXfuVXcOCasS5mNIVk8KeLyKaggwn50LuhIBMWUif2vOc9r54OBgBdSIy2BCTNWpL5d3zHd3AOSkX+pCc9iZXiSUyAQi8SMpH1ehnLASplEJXrz/3cz/GZYKNqBWfAWOyMIj0Dxr/7u7/DgkIvBTQSfU2wxAjIKHSiAXQsTIfC5YqdXWYuDnff9a53cSLLdwy+WPL9inqanzXe8Y53fOlLX+JdwLcyhgAbCzPoI0GqgLmYiCvkPe95D24sAQvToWP/ru/6rj/6oz/iYjOJQhlKSUqxyBuKQ+X73e9+eI6D5UAvMXnbMgoQYSQI+7/zg8hMR2RG1REIsoWY0mI0cdymGGamSrgqLxoesacH6g/qErXANSi7mqOC9pb2tbxEAqt/1N+IJaraeFIu0cIF6AEhbdUo01Ku1ujUhVlKdZGk1vLZC1hNVHaQOygb+tLz1BYz8OuzaVnmKZg+N1QM+uf8taN+hqQ+FcVqZnyJvApSAnQg1ZVJk1aH9r7CJUhRvjNpSPlABWVj4KXcBQtW/P/svQmYZEWV933i3sysqt6bZpEWWWw2WWRpULamu9mGnQYEFEVA59XRcfQV5fN1l9HRGdQZR5/ReXTUUcd1ZEZBUBQQWRRxlMUddfBxeXSeQZGtl6rMG98v4mTeupmVmV1LVlVW1Un+dfLEiRMnTvzj5r2nIrubRko6Z4vrdppxvW18utsblGoCbYaPmjquYdTFNBjgqYPkBsfzjCJAm1j6EFyrenmg8ATiOUTO5Mn1jIIkeZ4WSIwKjDjzgOFZu++++95///08pXAmDm4404snEh9VkIzCASM6A1EYwuEEDzbKWfWkaywIiJHIyN/85jc8zBhLKJo9AaHYI2ZhCiIT88ILL+QUkDrj4osv5jGJA13YeYLiAPh27+CDD37Pe95DPjC2cuVKVocDx6I821DwUQthac4KuPwAU/PEJRmWQDKsBUtbQAILROLJdpx77rl8v0z1v3z5cvyJwH6hgGIQ/GmyXkoZuPrkJz/JhnLahB1PhgDGAnywEJk0ULAAlFkE/LBY8v/Qhz7061//mnxIkgxJCTtSka8Ff5aDEXn++ef/4Ac/OPbYYxmCRSWhWB06nkhCIdFxUOBANM4dv/jFL370ox/FmV6MqiCZlyEoJEOXjkJ+4QtfoIRVO016kRMCYzUgY0kMMBGSGeniI8mviH/7t3/Llf/c5z4XH7LCqFOgo6hkFBUqp8jXXXcdC2GshsWhE4jGKHrxhGrVaSowonDtkQw6AZkXHZJVYV7s+LQFwRlCF85Ehl5WBNDbQj2JSS8XrY6liX3Wkcx6Bq0JND3yKRGqEgo+FBwpdBz91HCAwsU5WnRl3tcgF49gTEJ5FPT4432WSeYdRZOnxgkVoa8JCDZxPpzkUZHUIULEIvAIkOIryyihQPyXNYWSM+jqEPiMswSzmoIkYuK4wuhGBSuXr6hWhyVBpT8sQerLDAllIS3xTrIkA3jU0wsFLeeq6o9ZxGUKP1qJel1sJlkmIZd65Ian+gcpcR4/KsX5NI5O4jjvMp804IR8FBn2AAn/+6iSeKllvlrieBTyvLgkie/YM4EiXxWf0ZCYBxJk1KySoACfVLMET1RFJq4KfP2VSRjskS6+vNRA8d8TJR9QkxpgkEaJvkFoEzsQJSGaaAawiIzgErqYA+ieYIiQxgsnlt9o2XtHBriN0qe3ORRtovQVuDJIDElWpIrCgQS6go8qChIfFJVcLegY1f+AAw7gS9vdd98dI3d/JOCxQSgUJM8JVZAKjCgaB090HmyUL2pR/zwUvbm/KqTBUxldPXGYOnRq4rAuvmDlQOizn/2s1pSaIV05mBrQREICygte8IKf/OQnrAKdIxwSI04eE+NsgTSY+tprr+VYFF2zJW2MilxXwmnqiSYkf/jDH4YHLUNxpgupbiisEamgAkBRBxQAFXfffTeyyB4JtHCCBeA/W9DZvfck9v73v59sseQLgYQuiV166aWf//znlyxZgj/AM+eEOGpBYkTSWwSMUTAx6WWXXQbP7Iv6oOCWz0sTYNFecqP4YxTAOBUQgZiAIEhmRPL7Fb99XXHFFUxKiUZXDnoBTZaDRCd/lnnmmWdy0nnIIYcQATvAiFTgpgpSZ0QSnBN0ztox5sg9Nb4GQdfrDQVPlo9si7yLrHBQf+YibFvgo6AXRadD6QfUC4J+SKVDDtQAoUcrBBfLAS8UKEAgnT6VKFpPBCX8BAdKi6A2/ahdTUVdLeOXcayrp5cPi9bYogfEDOK7JGnKKhLxqciSwSGcYuZhhIseLlRdoUyjSxHNqtalXkONRhiLHuPwDsaOiD4UYXQ2IdqLFue1Bi3aWnTyBKNGwiZJtVbbbZcncyUlktBLCUwxSnRQ9wxJjbaiMboHrcWOCe9oJLhI03oh09Mr+iqsWg1BtvgHU9efsGSXwfxo3Db+dIJw2bXpNNMcZICLhxsxkty5g/NEoXBBodkJOOvVhXLEEUfcfPPNPI87OXeyMxYQB6DgRlH73ve+F4XnCk8gMkFHIRkcUGjqkwbl+uuvR+ZN9CkCEjQCa+ErV04EmVQtnSR5Frt23nlnBnLWxYkgXaRNTJ67+KAgZwVMDUvU7jo7i4JwTQ8LvUgFhFMhadroVEhU2Hjirw4TkkTg+/1bbrnl9NNP14GTDqXDp0myXiJDC2eB9957LwrNIi00i6BL95QrBIro0isTZUJgItgmFMrll1++adOm7sNx01Q//vGPMyNNxnYf0raXIAxEEoGdRbIilVz5d955J2UlFsBwrhxkW7C/BMGNsRymUsJy2dPEmfhIBVOgqMQTsGqaDOcjjKTX0MIANUGLZW402V1NtK64TCtR9ltCzZBpb2eJAyj0NyIUTAW1e2/BsUml9mxqa/WclUR2WLqcVMkAFwq4uvQSFAn1KEWS2vMA1OEgb+ZKnYG8PVYh+bHGoiXM5DGEooy6zAkKTfGJyxLnBXB2GaRkSYCkHmQkWc3CmfTKpctS0hZhUc5J04smaDIVG5nzFMG+aELnqBvZguJKi3qLG03ndMqMiwFP71vj49NAl66Gi73POwbyEkGVG2+88eGHH0bvtFAehHTpUwflAx/4ADUHjyX0CcE5rvemS46TmBe/+MU80ujKn1IoJEN8FI3Pw4zZH3rooW9/+9t4qnHqkico0cjhtttuO/zwwwlIE7ld4EaGuG3dupU8zz77bPQcpEovH73cMsMKvMEY3wWTG2B2kslzRgfsqXZBggJ/KlHG4skS8GHghEBM/Bn+qU996qCDDiIImEQcgkw3yIrlcyXnE7HwXG9R4AfLTjvtBEWsiGYXZzw7gauCrpylj3zkI4sXL9Ym9rZgCHx+97vf/Z//+R8SBm3duhtZLA6MJRQKM7IEdGa//fbb2SkuY+ycjiO5cpBtwUBGaUrwwPH55z73OQ2FPxZ6UVQyKYpOSoFLEwcORwmCj6GFgf4vRrWqaEk7NNlaSo2gNX7YeFVzRZuj0lGdjLbGoTU9NqJ/jKBxqM6iqb3QxJ04CfDieSPnVBzF6E7LV4oIlynS8SN0Ci8NiQVQ6imwty1Dg71wUkhzDDLRVMd0dDJQhoKWXrIik9RTOAp6DnUrlSoVXyqLc+Idr0S8CBcW8OFdvcbKbKxJLbCkyiQk84N84FRC5UFMmX8M8FTg2uBS4TM4PDx8zTXXsEZ0ZFvooxfJwKuvvvrp8d+poUmQiYJZeJgBJuIxBqgFX/va1+ojkF7sCiLTZEaaPMzwpPmlL32phw8zpmaWK6+8UlcEFcwFLchOwJ/kyQqJD19xqoUm6ZEnRkCzexx8pg9M/eUvf5n4pAFoAvJEKuiiSRcKkuXw7fMll1xCE3rxYXORNCcKtgkaOW/jMG/ZsmU0CT7RINPtz9pZHZIDfuZi45BYkJ2AT/6HaFkRLMEbETqgvZmBEMJAZsFj5cqVnI9CNc220JSQDPzWt77V1mecRoIwEZMyO2AU+lVXXcWZKF1cxuzawMAAdhRkWxABZ6igFwV52GGH8f0+odCBKiq1ia7+NFE4TCUIuqGFAQqGFkt/NlvyzCTUWFk916BTCrl6s/5GRQRiw2U+/kFDLovYbgyMjRAqRtBWlAxUxJY0/BtuVGbaEWTDGPSWH6qzFotISRKu952XrZQah4qNyKF+Y8bg3Sj1qAlD8RdM8Sf8Cc58LhQW1VSJMhxE17rIg9fbjTfsITITNSxN70RROKnnwHrRkQGih6NIIUJSqjiXrl65Y0UcdbYGaspLTeOVbBGTj3q7+Kq3XSag3tC3rOUXErVGY0asRlPCwNaxYq+FzABXlj6TKMiuu+46qGi6YGgXgDOPQx7AFBk8PikceabSxD4hEBL/JL5QiAkwXnDBBTwCMaMDjOjkgw8TITEiSfib3/wmkmZPwKR77LHH2972Ng0OFTwpu8QnGXLDmdlZPidJJIlOtgAFo1rQZxEkSdXOF6ktOZA56bEKskWhl4RxxvO9730vCsvHCLAjJwoiEwQaGUiZov/UOUaafQV4YJd/97vf3XfffSTGqrEA9LaALg7vOcJnFMvBHzcIZMiEwCj4IRqjGE7z+c9/vtKF3gk6qaaK3smti525mDR3IAg7ftxxx+k/I8CK6CINPg6qINuCq4LM8eeXLlUIy2+SfE+CP3YkduJjR2GxTI2dJoC33/zmN7///e9xM7QwkLS051aTbQ5Fhgi7LvUX1Yl+G15v8xbceKsjONTV9m9NxVAsa0b9KHgT0QjqpvqoQ12LnYjRbr6eE6F6S0XK4p+0fIdSknLJ4hPgxEdI4YUzLSRAaUHzolo6J98kGR3MSlFC9enF1Zcs4sKfCJXRVyI1GdkyvO+ee3Pcy9Ik89Wad44hgO/2xTecXUPp8u4pYykZmxccjF3GdOia3KgOwTqbrWduMsBHj8S5SGq1Go9kvv7maIQmxragC0+6zjzzzB133BFFgX1C0FEaCp2xKvm+b926dWTlXPigYAfOOfXkMYYbFTCSRzJ2lJ6Ah+Vf/uVfaijCkgBzAbWMlfhjxFMf25wkoQOyJVV9QuMAeGwTDWW2cP/992/ZsoXZNT0yRCclmqqojiRz6glOMcm/DDOCHAAAEABJREFUmDZdeE4IUEc0nYtoHDkvXbqUmBMKMgPOZEiq/GKDwnRsK0qX9dL76le/Gk9G4cyKWCYK9gmB314IAijLCMXYtWvX8tHD0hY46H7Re8cddzCKSdEnAV0d0ZgXybXBQS/xCUVMloNCPYqinjTHgl6MjNIPIwP5IHBDOPXUU9EJSy/xkQA3pIKYAB2fn/zkJyiGFgaSlnbfN/PaZjRTdjeWjBR+QO0Nt1DZ5EbtKsimXoYo1IFRitEmlZk2xikZP9aTR03q/ZNX7LR8aHFCwSbiHSWY6NzeiXcZ0IGNqoxIINpizsWrPAQgaOxsCJxBozX6jrH5TJQJwKgDGrEcP2isF8U1KtHMhUqUDEMUGbUOlQZ3W7LLgDRGJQxidB1Zu2/qE5GWaV1WA5K/nCccqK80rnq0k44wP4nkNpQsFvwYW89EHSuhfxReJMeo1bSFwwAPDJ4NPD9Q+D6Xx6H+obFODPCUootH0THHHHPTTTfdcsstfGnIV5y3TfB1++23MxbJt3UMRYKvf/3rxNx///11ChdfXPkAC0kyLwqPPfQ//OEPjz76KM2egOWfe+65POOJRvHEzFjQu0CJygkhN/JkILlRozBQLSizCHJgg7RiID0y0dxUydeIwmWw8847c+YHvfgzECMSTxTkhMBc8AAbKETj+E3/H5sTCjIDzmTIen/0ox+RIctkvcV/JXdsAixn9erVXPBcrl/72te4hilk0bmGJ4R77rmHILfeeivDuexRkGvWrBk7Y25hanS27+677yZVoTFxsF7isDVEYMfR+UJgw4YNRNKLHwUSkDgAlLYgAvU0yTAKBR/9ILzwhS9kCgXBsTMLkpgY8deYdIG77rqLLkMLA1QFLZa50WRHgQj1R730YctBzJ46I75PXlDQdBrcpas+JCQUfkKzTSpeSpksk6GVg4sHY92WUe41UHPi41iVhHBeMCDRFXHhqgbZWHXQe/Kjc1G/MS8Mx5ihPiYlQLa1JCSJTtdgqfKk5TsvkYGENKs1cZlzEopW+kR8lFEkUSKKBBZ1ulpBDq0mEediXtL6cm5i9sL4mIZDAsyFrGkZ5iMDfIj08cAzgy/OtMByrv0lBAE8uZGAc0ROQU466SQOMk855RSeZxPC+vXrTzzxRB2IvnHjRoYT7eSTT/7oRz9KfMADj2cYCiBJ1fWZh86D7bvf/S5dPcF+++23995764xM4ZzLV9opPoU7acAbkoGAUfCJPxI7GaLTS/IoswL2lGQor5md9ADVA/mgYCRJ0qZJkjiwoTvssAPLx44RCxIdZaJgIDGZmomIABWXX375RIPMgD+5sV4KQQ4I0WFj8+bN3ec955xzuEq5XM844wyu4eOPPx59ojj66KO52jdu3MjAE044gTgnnHDCvffe22lq+NQuWOV3MJpkC9Q4UUkQtoZR/J5wRfyHnAjIHmGBAYADG4fE0hZ08W0AXYxSRZPZuHEjF5jqKvEhONGYkS4ULICptYpFNxQZyEuEonF2dS0IuudAxeM5BmtscBjClnuPUq8k8j8k6sOxI/YcMTKVB4hqLJnqo0TULXbgAIqWoMeuRpUVg4v3NbU6cUVC86DqPjwy7JLEV6vOJan4Zxx0SKnqE+dqPgt/J72UZKkfkSr16IhknpjMrtDoUeqMUUUwA4aARuaF/OmvQ40ZVSYQfnI0OxDEkavzVIG40ImC9I5v430tycgwk1o4uE2l6rNU0mRrduCe+5TF0ZY0FefwDyeRpIYmBEhEQGwEoT+khK+jwU6Jy1gDOgoyEWgkkRpdhAIYc/jwb8rW6v6SXwn1+bCDunNkjyaoWwQ30Gj18fucTs01XroKbsqq9I8kwSzLuDDILX8W0uyeoTrwQFIly8Jl3H1I217qoaJdo/HEUmOu0GQKMkRhiCrof/zjH5E9AQ/Rljj5LC32YjNNU9xSPu8NK3yiYgQoNIu9WGYYP//5zykXdFKlF52s0DVDiAUYwaZNm+hCoUsVJDqWSYCxOkoj7L777oceeqha+kdqbpyyq8IlTW555uhjAXUAO5cicorQUEXZNqA60IXCFcWZIgl3zxPnsWBUbkRnCVTDBMyNqqhFpVpa5NguouHDtUSljkKeeXoYaWIE6EjAp/uOO+5AMbQwkLS051iTakMm+Txot9JxhppkNcOvREzq0vDPxJdFDtxtTWVrLa3WKqUyhw2czWTiXZqEIi9NJfyTSrGUi7NRtVEdel+veokzLkyWH+aiLkx8hhRlOPFJKR2pVdNyiTsXn7FFA4PZSLW81a3d92DSlSQNKYXSP7yP54cg6oaSf4DjdBkW7UIWdZqKgr8apiizbuMpxoUd6OYyV/q4BU8rOOegvuHMj4MTzg6Zi2OnXXfdtQ/54SnCVQT+9Kc/IUEfJklKmhifAhKmwOJh9sADD2DvCfiGmoB8olPuOTEiUzBXVOew+PGPf8wRL4wpeygshmUitSxQO00UrliUnoDgOhcKAVX2MD4xewJN7Pvf/z6KnvD1JGzPgxQvRbaPa3VyUzCWZbLXrBesXr2a7wRaQk2lyaavWbOGzw5ByJmJALph/Awk43ftO89QaWlS1GuK2MQOoqqVTV0NRVUWqqvR3kZPeM+C4IdeBTqo6/QC2g1gl3DWyNEfpRs8Uq0oGh6hfsESmhzzUWgKjvU8SyJPlpVrVj1pwCdSHRkZ3jpUKXMeinOaclZaRckRisLQx5mp2jQIUpskBlSPktwUEqZkVkW9IcUXA0GwsBBQZ4zhwVb/yRxHQH64Wk1KJT7JpVIlG8m2bt6yJBncfflOeyVPdqzVsUjeHWMSmrz58Bba6BG57sVHA4fKfHKjzowgWjHFNEIj6kGJP6QKoioomXN5yEYoguRQx7pkFlBvhLf2bqFnHv/wxdy04uabb77ppptuvPFGZvnGN76BvPbaa1/60pf2M6V8pev4nmUiv0fNynLyJ/F2v1Edf3rPeMYzeIIChvDABiiwgZzT+N///V/yp0TQGwjr0mobi9q5j6GAFfGF0hPodDmBqhxzzDE9Cd7DIMqDBuS60qZmq8a+kiQGSIl9VIbRJwq+HNdrgIF77rkntSlKr0BWFLjIPGBRz42mdGEg6dI3R7qaK4wJJ908nAJlTAQquTG2rgYN6aRIrt77+ETxyadG4xRxkciGQ45MtowMuNRvHRkqV6gFmQufsddxwaLRZVpfcY5MQg0q4Ut5Ec2Kexa3g8G0nGSetEvDtfVPf0ZFfFlYkOQlpjReMADqrRA0Y4HaLKxIDROT5APyMVOMlsdpVULOrbY53fYeqqYXXCSVSiXfHb4QeOKJJ/qNNCggJf1U/va3v9Umlj4EnziyUj65e6B0/7smOI8fixcv1vgM4VFNcJR+ZoP0xgPKa5YDXTgXF6U7rhYcuFYPPPDAnAGcpwhiajQiMxcTIZ/85CdPMWzPh7PFw8PDhIUoEiZJPrNILP0GOCQllSigqNMcD3QI1wPr5Y7EFwKMGhkZQfYERGYKmCQaCvSicDEgDeNkYLRUGOeAvnGjTFAUMnKZl/CnCeOlkOWna1GhWfCsq0RQraWXZh158RSO4EKjPiTxElo6uih9sTFaj3JvooNOvuwWh92VZeSI1futqiwarLml5YHq5q2lTErismq1lITaTsIrpFGjzAt64y3q7QXFNGjf12INkdXEWoDqda7yIA2FD9hAuVwbGSlJ4keqg66yvLJ4KEuP2vOQxZImYUGJSwphGuFG32Mo4rhwqBnNGd9/Q0nQg50fH/6vTqEdfjTDogzWsT9sOrTVMbY70Fafpd5JJqDeWFhvcDytiB+9QCk3em7N+njrYfEUQvfiBxLyMBw0Fpu5vR+UJKnfonMFhuG2V7kRSrcJSUzlQSXNuQuWo9ceS6D+QMIbUpdGLwoOgIPRnFscpgOcw01H2KnEZPl33XUXkiqKOBwTUptONw9MNAmwcQrGkjBAmRwouFkv4DcQtp6qdHJxxo4iFGE1t5xGpoieJsbFQP1ONy7fvnfikp1UjpQ72xkXKtHtuDR3jxngqEBFqrUqFVtw9bJUyiuksuGIo4b/9NhA5so14biRao5KtLgQ1UertjB4un4yJ2Eip/GhBaguvpZJ5ssudVVJRmTApY/+z0NHP/3wHWRwUBzrwk8rvsyPjiISiEunX9HobZSD+gGmT1fauabEpQ3qo9r0mKkNA9A1reBGTHwmTuOLJvforVu3YukraJJ5Sn372MgTo34iW/2wqE5z6qBQ4wnNNikhTKfK1CPPbgQWwqI0B65AFKVOFXSWCWg++uijPeSTebnwCUtwEqCJ7M8/Mw0tJEmqgEoUSbbIeQlWynWuy2SBg4OD7AtKD8EUuvVcTlxgxMfSw/jzPtS8KkYbu0W5A7SFAlTvKqmNQEcXCi0Qu3EDUQ2VU37Op5aCpA4DBUPdNXxX7b3UhC+4j11zxOqVOwpf0yelEqVgVkup3WrBhYEtVzOXOMYCsniQWTB0UjnFBWN6qX1B3RwWRUBthUNLatPQCANJJKsOj5STlIq57JJ0uLbDouXHH3Q0Oac+wQV29ATX0QjD4g/W+M6a9L0odTmJl0QcExS7JCQj6tBkD40sn6JlVAf/MKb+Q1hQbyzENyiaLsS43IiVVu7FKDS5QXPrR+9b8JTq29xIDCahFkWBzjGM6lOXnAprEKpSFOZCzoOiRJfDtcdyincJ1dWOXLx4MYtVZzx7BWKyTUTT6Th+Ru837LXXXvkHU/ddc+6rPFtSgk8wiQxZIJWoRiMC6PmmEJzbneZGfGZU3eQ4GUjG6Tebbj4k2ahqYnVHPeGK3+fG7DDG93ELDZmN23+qjl58JS1xiOiE/5xUqwNSWiHlDYc8c9An2baRJJOSS0a2DZdKiXdZKFcLc3KtZ/HksmCrqxxnBq3AgPOhnEXCHQi98Yc11+FCm4DhrfhDECBCSZlE5jNUJzz/HCmPjJTTUlLzsk3OOPqEXWTFkJRkpBr+SlMYQuwxlWWwSXjFaEER1i8Jdpc56srECaAQp0AXkegWOl1MEUsznJuYvXl02xaztbVLSFTsNQEGeMA75/SmrHdkmn14MkpW+ar0kVy05F2zrpAVNAIy4fGmTaUXy9TB97ME4ZAMCZiIKZgIfa4DlgBrAayFAhHJ9ckaATqy53+ambmYiMganyb6j3/8Y5p9BbKiGOWDqdsNUSh9lWFLMpoeabfYx9lkU9gLdUahMOWJxqrVMnVJYnppIQEB+UxpzujThfkVt1io9MfKYi3SSIX0SmMLAqzUMOx0Sh8VjOdIrsaXyM4L5VeUKBGCRxO884CSR4ovlzVaKKDRCu8+d3Y+S0SLvNAx+hOGUzsG1Ccb7atrFFCJOCTFHFL4qVQSkVVSPm2vo560dJVzjg8JnxnKtPA/IwoxKTJ96kFYC5c7yGI96ilVA6jgAoKRE8vYJSFD8mRUVg5jvfM+VH4iYSVOakkAoYOTwxtkmcvCssOkvAOySJIsSfl3PjsAABAASURBVLOSCGnSHYziHOtxrrzTopXr9jhilQw6esv48JakrhSakjjnxMkoJL6wCDmQhSTiAK1MajWfVbOMw9X474kmYS1CSsJieQtSR7v6K7ZCb+hymYBooglYaQEsHLCWjmCqMNpVhdSCxk/GT0DINLzHnyRKE+NiIE25bD0bpt40Vek3ySeOlA466CDkdpNUBx2Cf8+P04g5FlzSSiPTZfGFj2aCMnUQHxCcUCisDok+bwB70KbLUZ3FahXCStHzf7QVNyx4IqkkUCYBgsAhG0QEplPoX+2fRLTpG0KeGpzFkjA6CkDpBHVjaTiwLuQMQFNiUhJmUpq6d5OYmggMZyAKAVF0RShTB7kRljikB1CATocyrdBVcCUzC2kg5yj69BEb65aOlLLHVJx0oyALaJQRBVNXNfo3qpmuntPQGRaZDIgsl9KFJ5y+qJomNTdcq1aGBodHRqioKBTzWWOTGi6UVhhZfhGUyBgjdEVaRqmM5oIglPprBJGMi0ChXg27eCeEwB/LCIkNDoTP24gvPVG96MSznyQrBiRlYCg6RYVs9+VZRHAK48K7xCI4aNTDtfBOQoGZTKLnTHy6HHMxM3I0q7BybAFFe2jbzwwzME3TcTFzQMI9ZMmSJUxBE9kJnJ7yjEmSRN14mGm10cm/h3Y+AjodMUkASc5IQxcG8m1SJecN6tg4+GQsxKL//Oc/37x5M3Z8sGzbtg2pj3Z6cZsQCII/XwHrFESm+cMf/hDZV9D0NFtdJjrolCScKJN8CiAHurB08e8UZ3J2JmUgkzI10ISxGNgF3RflhObc5SR/+s6xJXBdNmdMxQAKNioMUDCoSl3lPJ4KtbVKyq8A8cloSTLWP8vP5FrHT6Q9klVT8WuX7vlnT1tb8a4yMPDYE48PDgwkGYd5SS3JRtLMOy8OASTas9QLKPmsjpqUanRl9OrknC9yAjqSCECh6elwvGeJz3DDv5QRJytnkgKfQUtQsiTx4arIXDacVmtJNfU1jrkGBsqPb9viSuWlpcVH73bAUSufVg7jCBqceZsixmxoU7zGZywTyfAETd3jabhMwHg8zWdhMMCjtFKpcGntsssuSO7pyE5L5wtNunDYsGHDySeffOyxx27cuHH9jLzWrVt3zDHHMNXpp59+1FFHnXDCCWeffTbJGLowcNJJJ7G/FDFsGW66uVjQAc1c8gsJX6OrG7s8MBB+5WYgDtQ9yEmAUo+AzKL/jsTXvva1SQSZ7iGkd/TRR7NeJtJssaC3xcqVK7kCufjPOOMMLkKufz4FDMc43TjxxBP5rPEpYMZVq1aR3qT3hbHzDPklzbrYRMDDEUlzKpiVsb2pJGYldUiP82ZRjlN4qplxus6MWzkplcUvluSstRv2WrJTZUu2uDS0bWv4F+BYWEjXCQogn6COVlRqwxxPJV044KThfKigGdgCunIkEqpSmtTcoUQbjSnO84V5uCp8MFK31qhK0TkwGJDSkmrlScnS551w7mIplTi5JAxRpgthgXyuQD5DY9NzgynGwGQYyC8kHsD77ruvXmMq24ajvMCO89e//vUbbrgBecsttyBvneYXU4DbbrsNef311995550333zzIYccQjKGLgxwUMRmleL/pAM3ntnsOGAf2WVVsINyuXzNNdfgjM4vJ0gccMMHfaIgDmA6JHEYvnXr1rvuugul30CGu+22Gzd2EmO9SE0YZSxWr17NFci195//+Z+33377LbfccuONN95xxx3TfPmH8F/5yleYjo/AV7/61QMOOIBT58ltzdhFzQMLm8gq2D4uOaVFLRjnHELZMeeSriccqiVVQ9WiWpDYQdDyn7wwyy1RwQ1ENRapGcUZoCILUDsOQPW6ZDpQb0zlzYmkPqlIQpW5TCovO+2C3baWViYDXFiclwKCh+KSBCJ0GVmScWLKeWfNif7pUiQJAe/0T8QyrhlxeMOURU/xLsYJQWKchCPYugtf0MNA6rPEZyMljkiz1JVWucVPeqL0ktOevYMslcyXJSm71NVHTNMbmWpklHAmqo0gm1YUDI0fJUllw9b6HqKJqGzts/ZCYMA5V6vV/1jIcccdxx0cS5eFc1RG1cLt/vOf/7ze+nGmiZxW5FNoehzjTet08yY4Z3ishZKUepTbKftLEzLZR2WSpgLjZz7zGXwoy5AMUQfsQH3GL4kA8GcscYhG0fbQQw9h6TfAzJ577km2mifpoSDb4gc/+MEjjzyCM58CHKjaWRrKdINN4ePGLPmVTwJd8sRzQUEvM65qXTUbBDkYtTm35FwuRkVa/r55B+qpS/Ie6o9cn5wy9QiFeUmtlolPsm21QUn3dCuvuOBy9/tHl1ZLSeboDEVhdEcP740KDDulZJZkHIdGXVQGn8YPZeIo6uPpCxUnE2Yu41izgaDTV0BcZpyOkjfxpcUjlfIfRl50+sX7VnYLZWhSzkaymGJhUM/UOHtztDn6AWtehLX6iAF9yHH7PvTQQ0kLRUsW9LGglzs+8rrrruN2jycPY+RYz95amJHnscbkI0ARgE4CSEMXBrZs2bLffvvBXnGbdMcZhZ3dhEYUHB588EGO4PjCGoYp0XBgZ+nCAX0SYDhzabT3ve99k4gwM0POPvtsUs3nKuq5MVeuvfba/FLEU4nKe6dJYVOYC3DlI9k1WJ2mueZoWL1Kc1q4bvt4Id1Sm5vFaCyS2iyryU79pVBH6hsQdXVDxpbEE7LECxDKK1Cw11V9Kw4JehbGBkW7IROoPn6ZiJeBykBZpCzZ3oO7/N8znr3q0dpA/dRGQpWZZJSPVJ+kBhJKR8/UYQrqQR9PQ5EirDd8Za81KMspgoGuMQq/ENZRmBIHhLWnnrHB4h01qhfJqolUkyTNSkPD5VWPl150ynMOXbl/WvUlMhVJS4nEGUMePfsJyeTB4scMS+uZaPx797kXCtnmoNkMlwmo2zIJ211v2NuCZYCnWr72pUuX8k190ZJ35QoPQgXfFXLQlSQJD+M0TXOH6VMGBgYIzslQ/DhIXhBgNHRiYGho6KCDDmLL2CnlDUW3mCZ2Bhaf31dddZVa4BkFZ/VBnxCIyUCmYBRlrn61jd6HoF4/8MADSYycucY0Z5qd8MY3vhE3erdu3Qo/KMoVynRDp4NPPnHkqfs43ZPOrfhsIiw9+uijpA1FyDkH6ok5l3NIGOpB0MZVW1CCRF/EaF1CoxnUa82GptbowEK0Jo9JNdiBagjo+NZbShXxR68+6LITz9lhc7J42CWcfIpI+HOcvAXw1TlVI0gycd5TbgaroFNKBmBRUFECCa8MkUiIxUCH4vHPXJD0SDRKmoWSlF4ZpTRJaqUlW8srN5cvO/GCdasPH5TKotKgC/HE+2oYEAL09idGd1mnT1Qne2+TsGjzmwGearpAbiPoJ598MsUld3M1tpXlcplr7/e///3VV1/Nc5Gao61bMPbuh4k0GLOjMCkFATmjG7ozcPTRR+uGKl0qGcImIiuVChI+2XckJ6PXXHMN/mqHdnQcJgqCMxBJwcSWaY2LZaJxptsfNqjX+TVs7dq1MMBvOFi6TMqKfvWrX334wx/GZ3BwEGcWqFxhmVYoe/l0bBYf2GmdcW4FhxB2h5xR/vjHP7I16HMRlEJzJe1YozSShX1HMdVoissC6k0voyd2meSlVZOPuhZ7GVU00qXNKBkb3wuzhDZp8KYSJf7dId7HDSehfiyP7gLfgA+K27D7YVee+by9s6WlLVWRhIVWh2uVUtlxQuqTkk9xK7uEIjKt+bRWK2Xhr9XHOjWL1aTwxnqA/ulSiS/KTXzKmYBSzSeZJwgyqTliuhqL89m2kYFKuZrVat4lvjS0rbRbdcmfH3fuhicfMSQh0RoJJZKIcwlBM8bwNn44ceoMafqxUSXokWSaCnXDDlQPc0EBbc/K1IYCVC9IQuWom7PRK6HZwnQYiIoE2kQxzG8GeLyxQO7gKKeccgr1B02QXwD6zFOJHQcuEnrf+c53/vCHP0TBiAUJiIMEuYJOZKT6qKQJCIUE6qxuNFFwA+iAJrOojyo8mEdGRtDpNXRhAIZPPfVUqANKF6zCHkPoQuanetrE8uIXv/gXv/gFbug6BEWbKnPP3I5CfCRgs5BA3bhs3vSmN91xxx1YdDhK/4AFalaXXHIJS6AexQI6ZajOr3zlKx9//HF0PJVMxtLUUego1LVIULRrlxpzO03dBe1VyeWNvQjmogmfSKDzosxj5BSp8tSnPpXFKgPKhsqcClVweOCBB3SIkqm6SrWo1EtUqVad+LOOUFBMOom+H0j9Mc4c84Km+5DuveOcq9mN2kwRzZR5FUkWiXv6it2veNZl+y7ZZelwMuRLSwaGtj7yBLXjcK0q5VRK5W216kgtS8olfv/2WaanocgYRliPd1JLpOYEJXMZFa2TjPNUReoSnLlM8cwS59LEl1OXlJYsXrzlkccXlwaHsvKizelT0pWvuuDFx+9xxCJObb04Ea8TBIWSMG81rBN/53NF2YscHeqyqCNBVE0YAz1lgFsw925CcuGhnHnmmStXrtQ7NR+KJAk3Ri0vaOIGeGBXKhWa+G/cuPHBBx9UB7oAcfTJylh8iI8RT4x0oQPsSGYhFApNupC40QSf+MQnvv/976uRJnZAQHSgMfm8F+fFbhjLAAzvv//+e+65J11KILzBPM22gPM//OEPF1xwwcMPP4wDm6ISO89sJE1i6hbke5q7oagPDrgx0XXXXff2t79dd4pehvcbyApmzjrrLCRp0wSdksSHdT322GPr1q175JFHlAH8sevCWSlgOCf3REPHjgO1KT4AC7SoEQd0evlAYaf3LW95y49+9CPsbBNB6AU4oC8o6JKVpZyB1atXQwJEYUcBqqgz+0IXHCLvvPNOvqnHTjN3Iw46Fq5kJG46RKlGp7cfEO65/ZBH1xyoSEBnl3rt0uLQGEKvot6PPUcwJeIbLGAPFhGUFqg9ynq0okO0T0pQzYHG0MRJSCeVhGPIJ7vlrzvrhet23mfZcFLa5helg84n5UWLH/MjfxrZUisnfqC0uTq8eWRbWiqJiPMBlJghf5dlTihDgRReiTBBJi7DTjk7LFKrlEcqpUd9DYyU3LatI0OuUtrmlmxNj1q1z2vP/Yvdkx0XywAxPGO9pGgiXrIsKr0V+hnTmHyiQNCVcGRo5D+kA/KmsKhRSPFFpqC7pdhr+vxngFswVxe3ae7OrBbJERGXH6CJHVlEuVzmVj48PIwnd/M//elPmzZt4hwCf3VG4cmKA2HRNT6eGHEAakehF52HNEpxine9610vfOELKXPvu+8+BtKFxJ958adZqVSwoFChIg1dGFDSzj//fHyUNCzonQDD7CzMn3jiiTzO2RosCraeCGwETd1W9pQ4WJCMwhmg0MQB+Y1vfIO6VnWa6o/SPyB5EmZFnLodddRRXFEsE0unDPGnUsTh/vvvP/bYY3MysTOEpkbg+qfJwvGkC1qoTbEwEQ4YUTCqAwGxoCBPAAAQAElEQVTp4qPEZf+2t73t6KOP5gsHLADCccYTfUEBfgBLRsIAQNl1112VCiRNeuEWiQ6TcIVOFxL9Ax/4AJIuBSTDPF3ccNhiFDxxwIgDTfYO2Q+gOOmHNMaZQ0tJwaixljEFCl7jwthQLcPUQWVL1ySbmmse0WkYxwFkUpZkiZSfLItfcvyF5z/zxBUj6fKsXKkl1a0jSVKqVAZ9ktbEpaVyOCXNqnoC6p1Qg2oYlVSoIvkMQcMhIHHlRYOuXNo6vG3b8DC3S1Abrg1k5RWyaIfq4EXHnv7yEy/fQ3ZcJoNagEpITAjoNLRQHjbUumXyby6+8vHeN3JmktxqijHQOwa4oeu9nlszt+xXvepVxOYy5P6OAtCRni8ARPSWnXdh5AiTp/gXvvAFgtBLNJz5EOkoAqqCEWd8kOgo2IE+pNXtnnvuOeGEE17zmtcQ5I9//CMP+5/97Gdbt27lgYE/jxD8SZLhWFA0FE1DJwYgjc162ctepg7sC0wCbY6VMAz5EHvvvfcefPDB+msGbrCNxI4DEp29RuKMBWDEgsQI8OeXilNPPRUjj3+dUUs0evsHmhiXHylx4ZE2KwI020L96cLnV7/6FafOd999N8sHGKEaCeCZ6xYFe84JVNDECA8YVcfIHn39618/8sgjP/KRj5DA448/fvzxx8M/nnThiRF9QQGeWXjLkvfbbz8s8Ab5KEVgUX+4gjTuD+94xzv0f+KAP11sje4yNxx1ZgqAjgOhcGAsyqyjP4vR7dJCpaKFXItnbsSh2EUzx6g9Ec5E8yFqVzfVixJ7sckoL84XTZPViQyEw8ZQKvrwXqOVSSWcj6YrpHz6Hkf93XOu3Pi0Iwc3y5Jqumg4qYz4ctUnNS42qjafUZgm8X+25MJwak2S4YiUBNlglSLhNDRLpJqE7+6rzm3dNlKtZkOlwSWlofKwDGzxK/2ioS3uGXse/LqLXnbKU45aIZVyNfO1rFYrrBTVU5fyRWZJBCTMNQl479uNClR06MrdGQjypggFK5CxL6KBop0mKFpMX6AMcEdm5Vxs3MG5I+++++7Pe97zuEfrrZlegIMCB+7d3NaRauHmzhHaueeee+GFF/7ud7/DyFgkT1wk/jgTGZ0huc50WNQT5Zvf/OaLX/ziww8/nKeyTofz5s2bjznmmJ/+9KdkwjNbh+Ccj8KHpqE7A/DG1/QbN26EWDYF9kCnITjTheSJTrF1wAEHvPWtb+VbafZx27ZtRFDO2RHqLTzVgj92hiDZqQcffPDkk0++8sor2W7mwo7kGqCXIf0G1qIZnnbaafvuuy9r6ZKhLgSJD1Xjb37zm+OOO+6yyy775S9/iUXtGgF+tMnC6QLMwlyALqiAKIw33HDD+vXr+R1MI8An/nygTjrppO9+97s44IkFZWGC5UMjQFm7di3cokAFRCGBKjioTlOJ5aJdt27d9773PewKmFdFnQnF3YbfvflQYCdsn/A8yUqCNfQL2lQh01dtaOTmSmgKROi5YtMexNhYEpdI1TufJMPVRVltFxm84JA/+78XXLZ21Z67VgcG/7ht6IlsmSsP4CAJFxMno1kilKGAjChAQeqzJIt/WpSSlWo0As8anthFFrnSEikNPjEy+Mctu44MHLRs11dd+OeXPOO8PWWn5VIpVV0lHUiE8I6UQrawnUQSvMT4TDUZxJK7/UAvtfYdZjUGesoAN2XicRNHch+ngKD+WLJkCXZu0Ei9iaPjQC8SHaAwihoFBfz7v//7HnvssWHDhn/7t3974oknyuUyYwnIx0Yj4ExNgxFnhvNI+NGPfvTSl750r732YtQHP/hB7DjoFAynyXeXVFF8JUrTOcdYoiEBCg69xjyMp3zq32dneexCd+pwwI2NQ4I3velN1LJXXHEFvxVoFxtBBA2LG3sB8OShfuutt77oRS/aZ599eMzjxhZjV0+uASw0+w2shZRYGvibv/kbcu6eJwsZGhrigmQUnjDABc+S+RXu+uuvhwp4wEg0dHxUogCMTMcU1KCUQatWrdq0adNtt92GUd3owg3wzQDnylpLMSOWhQkYhjRd+4oVK57ylKdAEUalCwXQi+TWQRfOKDCGfOSRR4444gh+VWBf8OHXZiTE3nXXXZDPqfaJJ574nve8h1+hNZpeqPjMLqgxZjeBqcweq6JOASibwJhezgsDxCfiG53EAY1W4901lGl9ZxYQpuCN3XBC1kCqIknKmSS/TS5OBgfF7yzJ0UO7v/bE5115yoXnHXjUfpWVSx4dGdyWDVSlNjxCBNZAPeodqrBGKtH41+clbSzUu6yWhPNRPJyXZenA0NYs+f0ju20rn7v/Uf/f6Re/4aTL1w7ssbMMLpbyoAyU0lKtRinqaiPbXEiIWagUmUcCebyDRnBiTh362cjj8EnL9faKywJf7fvMagx0ZEBv33l3Kb6oKakR+cRxHQJ6uQJzT1wwcuPGiKK9SIDljjvuuPTSS6lleQxQwfBl2be+9S39Hycib7755je/+c3YqT55APNF8Ec/+tH8TIjhhNU4PNEJPjg4yBOFcyM9JdJeBuJJL48cnA1dGIAlLZuOPvpoDorwxNKdNzaaLcaTCwDJFvArwT/8wz8ccsghq1ev5tHO7yrsI19P33TTTf/1X/+F/Lu/+7tzzjmHguzEE0/82Mc+RnwisEcMZ3ZmRKFJZJR+A9nqL1Tk+axnPYsloHRKklqHri1btmi5iQ6IAD75yU9CAuvlhPUNb3gD1zmfBQpNQI3+mc985u1vfztXPkeeXMBnnnnm+973PgojhsMMwzGiwxs6kokeeugh/U1Mu+hdUFBadMmwwabAzEUXXYQFHaiCEQUHvTkgAXUnEt5w+/SnP3322WcTTbHjjjvyQeB6fuCBBxjIRc5v0bihQzty1kH5M+s5bDeBcSapZVHWLdwk+1pixnJPQ1HTBaXFIZgm8RMWkMdm0U6SUuq987VaRUoD4hZlslJKhyzf65JnnPXq8//P5Sedd+Qu++xaHVy1rbxia7psa7p4W7poOGCwmgyOpMiBamlopI5Fw5Ul2ypLt1aWba0sf7y0cnPlmU/a/6/Ofv5bLnnVJc/cdPDSPVZKealUOG0t+aRWDbfQNBVepXI5VJ9oCpIE6CpRxgtWhStSGYuSghKbRB2FXxOQEj5B4X3yP42A24mgbipxJTdkC/LeFrs15yoD3MRJXe/FSK62cLmL8DSl8qALYOS2joIDUh/DWGgCelWqgo4PuO+++zh14JF87LHH8kzle9vjjz/+lFNOoZThSUBhig9D8j9ap/Pm+fBg0F7sFEMMvPfee3nSMwoLkl5yQDF0YQCWeFqzKfBJ3U8TvYu/MlytVvHk9wG2QzeIIeicIX3iE59gT9lNthV5zDHHnHHGGa973euuvfba3/72t2wNbjgTAZ0gXC0aU+109RUgh6toYGCAhDXDf/mXf9lhhx06Jcmi1A0JlEyWCXQIASk9r776ag5Z+Y2Lr+CRFLicm77+9a/nE0Edr57siCpIQjGQIKSBHUmTxPiGAYb5KOGzoADPsAEtrBodnmlCyHOf+1w1YocoJMAOXShUlkg8+e0CN4zoXMbqiUV7kUAvS3o/97nP0cUsGPsBbR+9/ZBYSw5t8qQQohSkgKNaiyd1hSH1+gYLZQRAaYAxoNFq/87w8PfNM0HJi6Tg2pJG5j0nhXwFDkK3ExfeJvZDTBDG1AfzBrAhRbiqkrQsQpuv7ikKk4qknFyuluUn7HL4lesue+ezXv228/7y2ftvOH7V0/aurXzS5sGdtg6u2FJeuqW8ZEsJLN5aWr5lYNXWoZ22DK3Jdjxu1YEX7X/C68/487+76IpXHHvphp2esbOsWCRDg7LYZ2WRVByQUilJUqaX+ErEJaGL3pCJiJPw7qIiE3jxBT1b5hjvPPFdUoPD+D0knzt6mKUeje8mAUe8BfjEAylYWnUJ+5V1lvXgzW/4NxvC2nLL2N68y5S5zYBzjgU4F2SShGtv6dKlX/ziFzECbuU8HVGcCw4oXKPc6FEA/q5x4dLMkTuoRe/1KrGoQhx0oAoSexp/82NGwtJFfCTno9Sy99xzDzpuyDmG2UsXPpVJDryph2hqLhiLuvJM7ai9SjLboU2k6iq1FyPIh+iOq8QO1A1JcCQWFCRTIwFNdIA+K1AGyJmLXBPYfffd3/Wud6FToSJxIEmUPEkYQGc5XKLYATpAUahOTG0iGVJsYgHF4Thg0YHYNRmMjKIe5Xe5vB7FqG74z2MUOUeHcF3soYceymWMDkUQhQLgBAmoLJHKjxpVV0+1qCQg1y2R8edbl1/84hfo6oxldhHuv7ObwZRmp1hsqixj3YBxSkGbBxMNjNoajOXGuhKnHnWbgsaDT9Eag6lBKllaktIiKS2V0nJJV8uSfcs7XXDQKX+18Xlvu/DVV1/y2tc97y9fcf4LXn7u86+48P+Al2+67OXPesHrnvdXV1/yxr++8NV/tfGSCw76s8OWr9lddlwu5cVSGvLlklDmlp2rSFMdVsyAqXNEuxNKSpnIi2Kz2R3SxtjwqB+Ook0aRB7f2HD9tDizzHxsS1duN2V+MsB9+elPf/q//uu/sjyeiNy7UfQ+zkOaXpqcQ3AHpxe9hyAgFQABmY74yFKphPGxxx7jKO6aa67RXh48GHEzdGEA9ujluYuETI6l999/f3YTnU2EQMiEXix4ouPWK/D9PmGJRinAXMRHV0kTXY+m0NUNy8yD2Zk0XzgXFcxccsklf/7nf87pGnYoynPWhPFnFEDpeeYEJAEYY1OYggRoPvzww3yzzDcDWHAAZMXsCxAs/C1veQsLZ1NgBkWJQpkQYBJ/gnATQ1533XU0IRY56yg+d2c9mfEnQIkAgj+1hAvnkjRBsIz9qR+kCTVOS+nDEKAjUIDqE5YzN8Bx9OcyTx2YJpKkXgYkWSYDiyRZGhTZQcprZMfDh/Y4Ysleh1aeDFBorhG+g0mXieCG8xIpD0hSEk5B08SVvAgQ6suZW4noB6PzhGwH6NDvsnhu3bY3a2sdNTovOUatphkD4lz4DFx88cWXX345N2suUW76zgUjD2kliCc3XejOBTvK1JHEF48cQuUz8mx2LkzB+ShVApPy3TFPER7VuBm6MACd9DrnlFL0b33rWytWrGBDMdLEDr0oAB3ZK7BH7CDR2Cadi2Ju9erVGAF2SmTSQNFelJmHTk0aSgIXFVmR3oc+9KFNmzZBCDnDIcBIl/oX8xxrKfZOVGciLm9GkRKSBJBMzW9ir3rVq+hiOoxQqg70LiiwcG5Ka9asgQoAXZPmgbGQyU0MAq+//npYRekHzNFidBapo9DxTE8xg5x5MDdw4Qkl5ODC342X1HOkmQyIG/KlxeKWiFsqKeemy6QMUJZKukT4ct8NCW5pRZIkE1/1SZYQCXgfilEiz/CK9BOlcnRqCs3RxoQ0dgdMaIg5GwNNDHB3LpfLH/nIRy699FI6eFpzffIwQEfy0ujtTwAAEABJREFU2EYB6DwVUHoCQgFiJkmiMxKWh7FzfDpl0aJFt956K12cupEeXYbuDFA/4QBjUAqfYOnSpV/+8peXLVvGbjrn2EcknOMGz8ieQEMxO8HZKeJjee1rX3vwwQeTA9BZNDEctDkrktlJEn5IkgS45lX5xCc+wZcDLIEmXJEz2eKgYAjADtTSQ5l/+aBTMPUhhxzy+c9/niTJFsmkKD2ccQ6F4kLiVwUk28HWwAPX8ETzh1jGQiN3EsbedNNNW7ZsIRT6rGNOF6NjaieKGFAnlaIk0zPRWLW1OIfeuiNHjQGxxXAQ1Wah/shRM7WgNlBmjEeqRufEicIlaepcIpz5hj+8mjhJnQfh+JRy09U8QGF9zrvYlUp0di7+mVBiiWSZhID8yOy9WmnP9wslR6f0MhYR0cmhYXc+XAyNlr0bAy0McJvWZx4nB3xZTxkxNDSED/drngFI7DQBOhaUXoGKk5g8KgiLJCzJIA899NDvf//7Bx54oPaSHgp2QxcGKK3YKZhE8vwGkPnMZz7zxhtv5JASHbsOx5OiR/WpyzwUU2u0Aw444KqrrjryyCOdC3dY7M459heow2xJTYBkYEN1ciMZKsL77rvvBS94AU26oI5eFLpwBiiKoq6WSUsuaTaCLx+Yiyuc6cB55513++23r1y5Ep1k6GJG8qE56Ynm6EB+NyDzDRs2vPCFL9QaFLrya5iucQLqoBca9fweVj/3uc9hGefwaXWbsSKqV6vw9UD12oUmhUjdNg1vbYLXC9xpmKxdyFYb9abuGVVp+OMJ2u+dJJgTn2XRmLqkBJK0DFCAuJQuILxwhjkUEV8T5yKwgGicSeHJoD5fG7brPfZmDMwIA9ysmce5cHKG8va3v50j0lWrVqFn/NImwjOAXppALSg9webNm4nDg4GwCZ9QEZ7Qr3jFKzgT3W233XgG04UDyBV0QycGlEOe3PDJ8Q+7RqVIPXrDDTfsueeejMKCxIjsIfTMib1jm6hBb775Zi4qKjx2kJRIhqYChx7OO6FQJMCVrGsnDajAQsWDBTuhOITTv/WFhbSxAHwAioJRqvREMjvUkQzUwdXf//3fX3PNNfwqyIxMBJgF9nBTnebCgW4Ky//nf/7nZz/72SwclvJ9oTlOQB18AhR2Frbzv685zgjT55ZMX+hJRg5V5gSLEoYo6lMyvO2ZaLALh4QB6qqWqI+JED1jl3So0Rii/TMsXX0+vmkPmSWSOalmoc7M0qSWJlUn27zfIn6rCEChWRWhN0DqzlSw4sSl4lwM6IQCN2rTLuIfCijOwkYUm6qzOKB6QbpMQN2Qsay62v3NzkS782O9kQHu7xQuqNyvAQq3/rvvvvuYY45ZsmQJTZ4BatfHA5aewLnwIaRkIT4BSWPNmjW33HLLO9/5Tr5ZpqlZofBA0gRwM3RiAJYoaHjcwhWkUdPgiQXJN+bf+c53zj//fHx4GKsD9gam+s6khHDOMdGXvvSlHXfcEZ25qKKwK0gJRfcaZeahU0MIyycxMgRc0lg0GVbx13/91xC19957k3xux18dkEWd5lSg8TmuI+bxxx//wAMPvPKVr0THTmIoBIc0QJLkQ3NBgSWzZVyu7MtHP/pR/RPkGCdKAmQyChohlrFs/bXXXvvoo4+izzr6rxgdDyUUFsEtFiKjdUkwNf3U3ZpsE2xQDIHioNgMkzJ7bo/GvDWdCh9LLiZmcE7CV/ThESYuCbpQlzWqvNS5NJiFDUahGXqjA0oYmIiLY2ly4sOFjhKPY3ifabCoxpRFVhs2ezcGZooBLkUKF+74Lr64WTPzU5/61DvvvPPqq6/ed999G58+p1309gTMy+OBryl5TnBu98EPfvDnP//5xo0befwQn16yQgExr8ZHl7ahAwPsFJRCF/3FzYJhCsTPf/7z7373uzmK621xw4xcPOzay1/+8nvuuWfnnXfWW+v69euZl5ToIp9cQZ8VaJ7kBj+aEtcYTU0GhRNl9Kc//ek/+9nPrrrqKohiCJYiGFJsTkWHNDbiKU95Cgd13/jGN/baa688GntHkjQhTSVMoiwosGRlW3fh/e9/P78q6MZNiAflED5hlYG6y//xH/+BPutIZj2DniZAKQNiyNFKFIsi2kV1ldFCZQmiSrUWoY1GiUkv0RTaI1RybKhLnE+iKjP1irMKmfmwkPqsmloiUo4oiYCKSA6aQHsTkeBPCNFX5hJJUmzanF7pxDGBk7AO/XTxMaOBsQ7YZn1B1g3hjWaO0OansIO0AsZagnW7P5pGnoM2tzuqfxzInJyhMU8JS67PsEImgEnJgUcakiYSS1vkXbjhwANJFfS24KGFnVEAJU1TZBcQkF510yF6F8bYFuqjd3wcdDgKWb3kJS/56U9/+vGPf3yPPfagyeMZO9Ahyr/e3HMjCnZ1QNc0sACa2HUiFJrQRRnK16MPPvjg5ZdfrivFTi9AURR1tRQlQYpN8qSp06GMBf55wPxBpaPGOvfQogvP6c2VTlNMNE+WDPJoeXziqBF6r7jiiv/+7/9+1atehQUSdHdUR2oTO3oRxbC5HTf1J+xhhx3GV/Pvec979ErL/aGXVSNxBnkm6BpHI3QnPx+lQ9Q5n0KNRYl/Hp+p6aKpo0hGZ9Th2LWJT4vypje96fe///1rXvMainh68QcoCnXOr3xO99VOQFWQLXqxSS8RTjjhhM9+9rO//OUvzzzzTM1Tk6Q33zudVCV2oH9oEk+lGvIxdgFjNU+G4KYTofQEGpO1aDRdo0osTK06brkP9vGDCDgznD2Fk//3//7ffffdt2HDBoyAXg2rEgtgRuxI9CIIgh2L8vbwww+jzzqoTGY9h3Em0JJqJlqdtB+dl1pZ+/721nbOLnzjn7s7NOZFNsC+NtR2wxt9vXpv1KA6F5Lv6ptjs3QFnShFSbPoG5p0Y6rLRnAshrnBAPdfvftzY+U2xH2Hu0zhmpzpVZAAU5IAd0zyQeeBwa0TpS3wLNq5OZJ/0dKi8wRVC+vlsJBZaOqkKGNBQNyQdDEX/l2SwacTdAriPPe5z6VY/PKXv8xjgAWSD2FRyAcfFksEFDWyFuzouOHD7PRiAXShs33YqW4vu+yyb3/720R+wQtegBFPhjAQnwmBaOrPcIDOepkOpS0gh7m0i7RRmFQV9OnD5s2bYQA+SY9ZUJBYkG3RqzyVn3yNnFxywvSnP/0JuXr1aqYmH3pRIAHkOhaABTI1Tz53NDHCM27onCN+7GMf+973vscXzayIUFwP2GEYVCoVdhZPBXbAcJpIgA/pAfROyHuZFODGLKSE0ha94o3Fvu1tb+OUlAUeddRRmjkJUNuRNk1Wik4OnO6TJBZdFwpGdCWNJqCJEQtHoVdeeSVfyn/1q18999xzsRAHSS8+eKK0Bb3YdUYSUBIWL16MsS1ICUAU8VGYgg1Caes8OSPRAMnocM0QqatAAXTho3/kBn0SIBqrACyZL2puia8XvehFbDRGejUBFkhwZsSIxI6F/VIFI/4Qzjf+XPyvfOUrcZ51tFR4s55P9wQ6ZUstpQjDE+G0MiiFM07tValdUVJWgqgWnKnRFPWO+JY5D6LaEH70b940TDP0zkIKM7EEIBgpTBXC2WI7xF71ZAgohJFgb2r3RYMkQVMqcaXbsRS6nRdQMMwn9S/+4i/4YuvWW2/lu62vfOUrN910E3cnDmZu7fCagbXrvY97LrdF7no8xi644IIO6YS0v/a1r5H2N7/5TTJnFTyWGNgpT32cE/bQQw/9whe+8PX46hQcOwGvu+66I444gmcPN2LQKXJ3O4vCgRs6IMhJJ510/fXXP/bYY3zb+4pXvOKAAw7Ajg9dKCpZBXmqTto00XkewAyhli9fTjlLDaQ16Ic//OEjjzySCHThg6L+NCcEBjIpfELjjTfeePvtt99www0QCxVtsWbNGvJhCLOQHpIIyOnGcccdR1bsDmU9Crmxk+SM0hY9zJMFslJWzRrReaizF294wxs4lrv22msvuuiivffemy62jF4UoM4oamE4OlUXTbZ711135ZD1u/H1/Oc/n43DTlh8tFrCh5O/L33pSyyNrWHVSD6tKKwaoIDbbruNLeO3HYYzti3oYrMYDlc4z9j+ck2Sz4oVK1jgHXfcwUHppz71Kbhi7djJCgljumoyVAvGXMEIbzQ5/j/rrLP+8R//kWPpX/3qV+94xzuwwDBdUKeMMRB/gNIWhMLOECS5MRDlqquuguG2gG3uM1xpMAZ1/MpHqjqcgVMHodg4doRNZCsB2wq4FSOZGgWQG7N/8IMfnMqMZK7DUeBh48aNfGv/+OOPf/rTn+YXBq60gw8+GOqglHsvDjjDKp+gdevWXXrppe985zvhAX++nadJVcq9EZ9ZR6fybtYT224CvuFBadJQm9472ZucxjTysLGntQzCqGEzLzUaEWqJ6vSLcDQrCRI0zUYbsJ9IhepFiV2bKIXB2nIxrEz5ZQFmkgGOcyiM1q9fz2EMxQ13ovXr13N7otkWM5Ab92XARDyDuSei7LPPPm2TwUhRQv5kfvTRR9M85phjTjzxRG6jjGoLHjx6e+W5eMoppzCQUcceeyyyEwhItUEyBETy3NL0aI4fuhBNjAgohAKnn346X8h+5zvfwcgTiNr0da973Rvf+MYzzjiDdbERzM4ayZOn+Fvf+lZ6KY5/+9vfPvTQQzwS8Fy7di1pEAoJdCKWyRSTyBNyGMWkTA0hsKppoLfFLrvswqSMQjIQOTNgvVyopIQkVSQgbSxt0cM8dbHsF1Tnuq6aIukTn/jED37wg1//+tc8qt/ylrecf/75pMeDnAc/PqTNc50PHR80Chrdeiqqd7/73fvttx+7Rlg2DjdO4JRPSjRmYS5Wxxp1dehcvRQHXBgAhSufyxj7U5/6VJyZqy0IRVjcyIpQM7m/ZMXUZIWyatWq5zznOXBFBf/II49QbH3yk5987Wtfy1f5rIX0uOZPPfVUdC6/l73sZfzS9U//9E/UYXwj/Itf/IKi/yUveQlfCBANrgAKS4M6pqA2YgrIVDtdnYAboBdPhj/zmc+Ek7YgDWWMxNgFTmR1XxjbE5AGG8fC2US2koWzrYDrhOmYOtdpPu1pT5vEpKyRUfCDREeBKHR+KYI3FH43gH9+Ubn//vvp5Qqk4uSCRN+6dSvHz9xwOArlFyfywQgDjCJzvbbRZxfJ7E7f29njmWhzNRlO+5qLRerLHPXpcQD1xugbbiJJiJf35krdix1FU+lEgEz7i0o0LlTYuzp8SJNMI1zinYDwz+E7UUkzIil6SiGCQw8HygSUWXoFopumhn/QZMokbGjRNNZS6OVAFBQM80/lFsyNiTsOS+OWxJ1Fdextgdt0gzSYWj8UPFHIB2BpC5LHkyHcGZH4cw/Fv1OSONNLKBy4CzOKCAzE0ha4ERCJD87wg4InlgmBUfgzNQ8AdCIQioMH7uMYKVCQPAXPO+88Kk6KGB63HJMATv44DuF0hPaXB0sAABAASURBVO83X//613N4c9ppp1FasRDAKA2LJD3Cshx07NpEnxDIivR49jAKMtGZhZyJ3Bb0ArrwR0GqjjKtGBwcZDqyJUnSQ2E6LMzeFnQButQNqTrKhMBExGEIzEA1TYCORUGT3dxtt934EvPNb37z5z73OQ60fvKTn0ApA9kXvtak+uSRz2E2h+KHH364DuRiYCHEZOM0CHYsLBAFOxJwwWAkDjqeGpO1qBtNUMwHtyKITC/JYGQIuveegERoC6IBuvBHQaqOMlGwBB2bK9rky3FKvWc/+9lc21z8HA1y2XMAyUeAX8+oUynZ+R3spS99KZUZv0OyBKaGByQ6VMADOhKdmHQxBRZ6kW2ha2H5eOooBvJJR7YF/gB/ouGAZCAWlJ6AyEQDRGNfmIKsaAIsChYI8GRqtYxf5lQQVnWmgCjugVx4xGHtSIKrgs4seSZcIQzECHKFXvLhk5hb6J1FzGLxMYurntDUlDstX/MGy4RC9NKZmg0QEQlQGiCtIujMUbSj6wh6VRE0QEMlyuxglqefnUVPbVbuMgTgHoTk9sQNCB2Fm2Bb4DbDIB/QNhk16t2TOyMK91lKAfLvlCRdREPiwBCAwi1VQ42V9OKPBDjDDwqzICcEIlMBEIoHQHE4U2MkHyT5ExMLkvs7c+HMpPRiARiJw3As+KvEjicSC71AdZooEwUxSYAHDHGYiOFMSho02wIH7MgcRMj16VPIionyhaPQBCTTFmSCHZkD51wfv6ITwYxGownQAQqfJiSR2Wt8CKtNFByQADKR+CAVdKkzXdjZOEZhRMfCdrBYHDCqP0Z60fNrg6aCIdjRkW2BAwFnfn9ZAlkBFgJQND2uedaLhdWhYIQ6dJJkmTTxxA6wYMfCEpCAmFgggV6auYJOQCS9yLbQIOqGgyrcOpiuLfAHeOYgeIsl75qEwqSMIiCKQptYUJgLyQIByiSgcRgIVxoNHVCJQixg7ZDA1FiwowMUwBD2AomOJwrME5CdmnQ+hOo55nwxWj/rE4718lKGcgu0cuWk+8klw4GEFwdyIGjdftj4bt3T10eaoBBfl8ZeFpGK5Cja0Z0EKpD1MpRoCumPVyB/7A6OLzfnw68OKrczginAdpz6vJu7DBlyKfIrMhId6L2G281Y0DvdYHagUzMXOtBmW8ndk+Tx5H6KJ0rxbkuzCG6meZO7KjpDuKW2jYyR8iJ3w5kbNP5d4uPTCVQAdPH0RQKCI5ka2glLYuSfW5iUiZidLowKjCjMDlAYwlgUQuGMBDQVRV0t45H5KBRmYQoyJA2anYAbs5OnpscsmhXK9EHnYt+ZlwSYSIntlCR23KaeJ9MxF6EIqDpNQJNV82kiJRT2GgnoQgJ1oAmfSAURtIuAkIwRwvHEjiRbFoU/i6VJLxbio2BEZyzIe1HowhOgtEXehcKkTEcopqbZCbgxFylpfMIyKXJCYKzGJxpA1yBc8+SgOlMQE+qQZIXEztRIuhiCBWgThTjaSxcO2GlqNLpwwIhsCzyxMwSGyQ1/dPwJ1RY4Exmg4Mxw/NF7BZ2UaCSDpImiU7TMhZH9wmdCICCrYyyKDqSpgGqgXdqLnTWiY1TnXOJJL7lh0Z0iGW1imV1QmcxuAlOZnUoCTCjCWP+xlu4B1T9rbHNshuKp+6ie9oYqshHQNxSp15d0bhfS8tIBLcZpaDLP2KgJFTG1o3ZEJvUXDDUUZKS60O6VGrJy3rX+AQAJhIq+6h+T+pva+kZyh+W+Q0mHRM/vNbOSIJ8Lbm2AWzDQZLgzdkoGH4aQPA44Uw0g0TuBmylrpBc3BXPR7AQCapfmAEX4M6kaJypJlacvoZiaUEiNgIXEtElwurAzEbPThU4XdhS6NH9C4UATI0BH4qOW3B/jhMBAMtEpGIjORKSB3hbMiAOza540cdMcUKYP5Elw9p15yZYmxJIJxrYgMXqnnifTEQcwi+ooxfWSEr36hFY7EuCMJ3nmEgU7QAGQzEAIR1dnsmVRNEkeN8ZiIT4WgA9GwCgcsADmpYnSCQRhChhTB3T8mVqbYyWRcWBepqOXJpJJkeNAqwuhQIuVyMTPjTgAmqRKFxmio+CDhczRAZmQBkZ1xqJN/FEw4oCRsW3BQEIhYRhn9eniz9REBoTFmYE6C3qvQBpsn0ZjFppMQZO5SIwEMNLE2GW/cGgLohGEsfRqHJoAC10YUQCzoCtoqoIDdqQ2GYWOhSYKySDRZx3993jliFO6ZBUqh1bWXKEia+2LbUocl/mA2AxlB5WNgrGK2BU9iZejaZ/oDV5ZOHujhAoIbf3x4Q9uqjqdEgJaMJXZWkLRnEq08Yz1oezLpFbzVZGg+6ya+ExclsXZExy8wD/BoiWTpv1qaeLVBIaAJlO90TKQZujQiURIBgvAGPOIgoaEq5GCOXGx0YeCO2yeFTr3mrw580p+B+QWDDSZ3Dg2H3zyXnVWOdYzt7BGdNwU6OOBzqKSScczpOijA1ViZ+pcthjbBsc/t2v+jAIEKSL3KfoXHbarMxAfnQIFjJ0FYw5mLDrQzLumVdE8dQqy1WYxE+3KJYkVe2nmXRNViAN0VK7QzHWS4QmNpQU40IVRJQoWZI6WZm7XbPNRas+dUXBAYmdeVdDbQoPAWN7b3T+PrP40VZmcZC6gY3NFU8KoCnaQN1G0iYJDnnmeCUa6WsCQ3KGlK2/moXDGqBKlLfJZimG7D2kbp4uRaGwfDijMgkTPQQIY8+ZElWK0YhzsII/GLOgqUbQLiQWJRYGOBR0llyiziy5l3+wmNu7ZG9XEuAdowaHuXt+6SN2tUYdYj8YKNZOoj3bNpDYdldF0xBwHJ5yD1mdu8MmW1i2jw7NRteeahF+AxI29GKZ10t4vwyIaA8aAMWAMGANzkYG5X4w2sU71ANSEAlSfsqROAjFMrESjZmKSDEz0qtvePlJHNkBpC7rn1fBtV392H2m9xoAxYAwYA1NkwIYbA2MYmGhZMCbAAjOESpRaZnTVY4/TRvtMmzgDLXxurwyd+AQ2whgwBowBY8AYMAb6ioE5XYxSuADlk6oFjNE5zgRqbpIMBAUTbi78P5YKpSYBwaiPb/u/XHK5T66MDjGtAwPhT2F26JqImd0C2xnBvoDghC8I2oz82CTGgDFgDBgDxoAxsF0G5nQxut3VjXWoFyVjO7ZrCWei23Uyh6kzQHEPRuNMfstGY5hmDBgDxoAxMN8ZsPXNXQbmaDGayWi9ksW/ba1bUNBxAGoe/evY2p7QmWiIGc9EUXS4ODteqzPRw7dRemNQmiCqbQVbANp2jRqJAEIbXxA0+zEGjAFjwBgwBoyBfmJgjhajDQpHy82GZfvvzZXo9v2l+UzUWyU6Ds4m51IvHCc3eCGNsrUaA8aAMWAMGAPzh4E5V4wWSsnRSpQiRhE3BjuIajw0pUsbjAWqR4mbq/850cbZJ84g9kYRKtHRI7UwHAtw2/0723G4iRlngO3L0WFyl4WTdWSHfjMbA8aAMWAMGAMNBux92hmYc8XoWEaysaaGpUtXw6Xx3vrviUa7l5qMVqLR1CQmEL9pnDU6MTDDBeIMT9dp1WY3BowBY8AYMAYWMANzohil5suhe6VN1QuS2gLUDfioxnGmIjZxaIA6EzSfno76hEo0tqIoRKBNBKRhehlgB8GYOdgzMMbcyYAvqPeycaDesLcxDJjBGDAGjAFjwBiYcQbmRDE6FVYoIicznC/iOwzLxKqZDtT0yJzFXw96FMzCGAPGgDFgDBgD/cmAZdVgYF4Uo1SHivqqOlQz0YdDshx19+Jb9JHMq0+jh4BRpTe+m+gdAw1uWyO2+y2ieVdaR4xpN7mzd2CMjxmMAWPAGDAGjAFjYHYZmOvFaNbzc8rmM9FQlXbbIatvurHTtc+o60rPPOu05RgDxoAxYAwYA50YmGvFaKhgssZicqVhaHrnaA1EE6NAVJsFEcCorbkSldG/1cRwMOpY1BqzFG2m94oBPd5UuZ2YbGX930YYj/t4fLYzoXUbA8aAMWAMGAP9x8Ccy6ivi1GqPACnKlEU3olCJKMAUWNDjjE0OvSdgaqMlXklqj5UotQruAXpA1GkoV0YAXrRgkfwpMPQjQF4EidUjVkg0CWZU2/sSeLFeUTinavbfewuSnXvhSRqgLiaS5iZkHEyEa8gJWwSfGJHFMFiP8aAMWAMGAPGgDHQKwbqj9tehet5HEpLL0kWIVLPtpZkVVcDtWjIXFYAZQ7wlDIBSZYxupAWFafWFi0yk5p3mdciBEm5JBnOqZfUUyQ58QnTEdN5CqYM5xo2J1l0diJl0qvRKExm6hgGoD0RSQUua/yMJOIbnCU+bLMLxWi56ire4RjHeydwm0uUHLG/IfBvi9jPrxMgqio0BptYTZKqY58rjlkycVlMSNNi00WGpToiVQwSfsRe/cSA5WIMGAPGgDEw5xng4d1/a2g88qkKSE4lSg6qFnSKwqC4DNmMUM4ULXgqwijnRLLYVCno4mtYG6BKwbGeBL2AdgOMAmFUIplQv1KPIq1OaRC0nXeq+OARqMvgLZCeQSH7Bc+pzwKrwUGcx4fqPjbqIqu/46oIbTW2lRiBCAWmQnhFC3uHKvGMVjIX69R8aml6kZr3Eq8KLgrQ1GsNY8AYMAaMAWNggTAwXcvsy2K0sViSK4K6RTyHalLKpFILKNckzSSUJUKtkIMKA4QSJ3T56IAUytYASp8ihErUe5cjlCaECsOpTnwomHQOxgoHaOVMyt6XMkpez6krofCpSTYsWUiukby9j2XAh98DBAnopcpznkIwS30t8dXUVxPht4IRJ2A4cRybVl2w6HYgG4ijdCz8B0VCnKCjjEWTv4/+QSZZVsmqA7VaJauVMuby4thr4eoZRaMlmYTUxV7GgDFgDBgDxoAx0EsGKPZ6Ga7nsShAFcXIlJhUgdSFZE9v3oUdvUVqE3sDVC2oVBZI8R7FoxGKQoTqM+oYhVIpFKShwMkyahSKkbqkjglf6FIH448bQ2oi1KMeh2JCdBjaMADZifjE+SQJCB7eeQmA+cA6rIaS0WsXRu/hVsKfjhAk288vCSohHD1KvHGjYg0+Rf8QmQieKTxOzqskidT71PNrBpVo5qUqruZdLVSiwY2fACcurZtEwshgtJ95zoAtzxgwBowBY2CmGKAsmKmpxjmPE577+sRHDc9+Gh6bhJcLhqAItaFwjEbl4mNt4UWoQqLMfKxOQhP/gGjBAYSm9wxx1KHRHpyzDCkSo0XdNSSnZ0lwyxK1SKiMQm/IIhQ5wRB0vskNXUG1n/YMsKGhgAydZfHlJCu7rJy5Us2loOocG+rD3yXisqRQLAm/EdRpj+SrrjJsQdwXNyp91BuyvsveoUi4MJLgyWm2xy3qbDpg24F3Pvw6IVnNZTg3LriQa8xGQojQsh9jwBgwBowBY8AY6CUDSS+D9SIWdQCoRxrVgoFW5qQW1PATa01qFMEY2lKvFrDTzCVKE3AL9ahkEmvr6ZRhAAAQAElEQVQUh28AwXlrSMoPYRQWhQ/HbEIvc9USxibig0/iQ7nkvJYuIVb40TEm2zEAP4E4KBRI4wt64QXVMMxX9RSjoRbESegViJVwdBpGcIYadAmvoEs4VZVRGezNP05ijCglvNiyZoTdk6TmkixJws6K1qMkx9XBhRLA3AQKw/VNZWjbjzFgDBgDxoAxYAz0gAEetT2I0qsQXqgD6qjHxARiIxMZkVCMUrtgCIVLI30qiYAk4/ySru3AO0+sulPiXSJJiqyDb+CBTyh9cHGekih8oSwYqTwDOMALEHGOUilLSrWkLMI5Xir22g4DTti3qsg2SbalHn0k8TRrtaSWJdVaWvVsYij92SEg1ImQPIoscW3hk1GfNnrqPGC/miASTmRrHM1KKXOuJiDJJEnYay8CGqsJxakTAWIvY2BKDNhgY8AYMAaMgRYGkpZ2nzQLZYCMrQDKtfC3lwZqMlANiv5lplzSOwZJwULt6Ms1LK5cC6hko3q0pJWaq9SQSaVaGqgmORhVqiVpVioHJKUsqdSAK2ehfHFUMAFir84MZBK+BK+F2k4oAGWwGmgsZa5STcu1UikHDNfKZZCxES0oV2pYijKtVMtFlGuhGWWpIUuVaqVcqzTLcqk6kNYG0qzsMn6bAGxlIX1f0F0Wttfq0QIlphoDxoAxYAwYA1NnIJl6iA4RJmPmQU9CAKU+XjUnWr44cYlkS2rJki3Ziq2yfNgtHZbFIw0MJ4uHkyVdMTTsFg0ni0YSpHou3ubA0pE0x+JqGlFaMlJaMlxaMpIuQw6Xlg6jByweKQ1sccuywdIWT6laydJEOEJNfD1pe2vPAPzUnON4G6RJZaBWKW1JV2TLhjYPLN42tHjroiVbFy3aBhYPbls8MLx0cHhocHhg0XC5gErUWyTNTmAsXci2GFiybfHS4SVD24YGRwYqUkmFrUxdu/RJvp3ZbMaAMWAMGAPGgDEwJQaSKY2ehsHUdJQCTWm58H1pzfvMZ06yIUlOOeyoTUcev2ntuk2HrkOeu3bdeYevU4mCJYc2o1x/3uHrN61df/7aDecdcQLy/LUnnFvAOYdtAOce2iQ3HX78OWuP33TY+tB12IZzIzbhefjx5x15whmHrTvvqJPPfMaGZ+739Io40gbTQMl8CsnGAgq+yg5DO5525Cmbjjjt7ENPPX/tWecdesZ5h56+6bDTNyEPP23TYWecffhpZx1+xjlrUc46G1nHmVFvkTTb4vSz12JXiTIWZ5x52CnnHPFnpx1+0n477z0gZaFYLladXHAiZAyEX4gC5tN22FrmEwO2FmPAGDAG5ioD8SHbP8lTB0Q4TYk3JzUJSFxScklZkkUiZx1y3Hn7r7tg/3UX7rfu2Xsf/5w16y7ee51KlCKes0/sKkh623o+d5/jwcX7Nsnn7LPhOftsfPa+65+z3/qL911/8d4bnrdmw/P2Xv/cvTc+Z++NF605/oJ915+9/7rj1hyyRNJKJqFWIX9N3uQYBtjP1CcVXxqSgd1Kq8874PSL9j3ror1Of+6asy8JOOd5azZdvPc5F6/Z9Oy9z75oDdh04VM3XbRm00VPPW9SeNZFT+2OTRftc/a5e//ZuQeefPCKfQelVBKXkCWZR+mj1JbLi1KxlzFgDBgDxoAxYAz0jIE+K0ZZF8UcQIlABaie41HvpZolI9Vlkq4QWSoeCVZKslySlSLI5c1yWeiSggyeK4IxKNG/SYmeSbN0yyRdKm6pT5kojk2Xi1vm/XJJl4hbLDLgU6l5kqzLoNlPewayTLyXrCoyIoukvFQGhmqlpTK0OIvwg1iWS3lZwNAyGVgmQ0sEZVokwVfIwHKpMNGgT2SYzGJ6ZEn6TjIR9rVRkcYGdoMxYAwYA8aAMWAM9I6B/itGR5/8YZW0FGn4HtxJkriklHopZb5U9a7mXfjqnqrBCadY6N0lDkB9UIqgFhkL4QVFiTS6XENJwx8uFC81J454krpaIrVy1BlkaMcAhV2o26GzJHwlTqkHe4krCRuRnzsGJ0kFYAUwXJPw9+6nQXqunzTZ6lJfTpgwccJ/IBFxGTq5iL7YY7ZedZPGwIJiwBZrDBgDxsA0M8BTd5pnmGh4J1oEZBIPojw1QkBWq4kCh2pNnKMwlVA9uKDTxGu7EgcXXk0DXYwgbV85P7kSs5KESV3IgMHis+pIrTpSrWVir24MODp91cNXPHrMalUnLklKEvZRxMnoy4dWKgLRwDk3HVK4ZpihNCAUmgFh/mpWG/EjQZN8PxPBLZpMGAPGgDFgDBgDxkBvGeAp29uAU4vmROIRZ00aLx+LP885ZCopSKgKaiXHcdlwko04nznfcOGcshvo8+LDCZdknjojHn0xncKL9/Q2IxNfE+fx8CGfTBgmMYLnlWVZKi4V4bS2nCSDSVIWXMVeHRnwkvqk7GVQkpKXEmeikvCNPV+PU5aCzDXYziRw771krhtqiWScSBdkd/+m3oRd5VLwJaEQlUSE89qSuMSlLhEhg+I6sBSbphsDxoAxYAwYA8ZAbxjou0dsqA/aLo1jUeyOatFTL9REgKe2ofxzgugC5wRQbTjnpPHyIkUED3qb4RpWcQLopBJFEccrTZLESRrO+DQQAe1sVLb3ovoD0cu5UmBPBB6jgR1xcCtOJFyYqThXh0RlrHSCrRlO8lHbUcQxOg1VZ018lSvLhV9TRLCwo7xHh/AesuE97D5vBmPAGOgFAxbDGDAGjAFloP6U1UY/SOoDckolViNOQjkg8cWxKO8cWrk0Ec4gk4qUOInEWb26SMbliG4UP4oQPlo6Khpfu/HUJkoMGIIkSUk4SAtwIbXYYaI9AxDHPgKUiCRJUpEciQRKxUmAQDaIulqmQRKSOVIhpzTojlnZ0ZLwLkkS34SXE1JCiL2MAWPAGDAGjAFjoKcM8LTtabxeBOORrwjBVMtlMFEVBKQSJD0yna+W+C3N+sxYFfV2y5s1CwwoUciGDbWIhlnC7lIR0icS9fFJmfCLGRQ6Mup8LkCYlqbaTRoDxoAxYAwYA8bAdDAQnrjTEddiGgPGgDFgDBgDs8GAzWkMGANzjAErRufYhlm6xoAxYAwYA8aAMWAMzCcGrBidy7tpuRsDxoAxYAwYA8aAMTDHGbBidI5voKVvDBgDxoAxMDMM2CzGgDEwPQxYMTo9vFpUY8AYMAaMAWPAGDAGjIFxMGDF6DhIWngutmJjwBgwBowBY8AYMAZmhgErRmeGZ5vFGDAGjAFjwBhoz4BZjYEFzoAVowv8ArDlGwPGgDFgDBgDxoAxMJsMWDE6m+wvvLltxcaAMWAMGAPGgDFgDDQxYMVoEx3WMAaMAWPAGDAG5gsDtg5jYG4wYMXo3Ngny9IYMAaMAWPAGDAGjIF5yYAVo/NyWxfeomzFxoAxYAwYA8aAMTA3GbBidG7um2VtDBgDxoAxYAzMFgM2rzHQUwasGO0pnRbMGDAGjAFjwBgwBowBY2AiDFgxOhG2zHfhMWArNgaMAWPAGDAGjIFpZcCK0Wml14IbA8aAMWAMGAPGwHgZML+FyYAVowtz323VxoAxYAwYA8aAMWAM9AUDVoz2xTZYEguPAVuxMWAMGAPGgDFgDAQGrBgNLNiPMWAMGAPGgDFgDMxfBmxlfc2AFaN9vT2WnDFgDBgDxoAxYAwYA/ObAStG5/f+2uoWHgO2YmPAGDAGjAFjYE4xYMXonNouS9YYMAaMAWPAGDAG+ocBy6QXDFgx2gsWLYYxYAwYA8aAMWAMGAPGwKQYsGJ0UrTZIGNg4TFgKzYGjAFjwBgwBqaDAStGp4NVi2kMGAPGgDFgDBgDxsDkGVhQI60YXVDbbYs1BowBY8AYMAaMAWOgvxiwYrS/9sOyMQYWHgO2YmPAGDAGjIEFzYAVowt6+23xxoAxYAwYA8aAMbCQGOjHtVox2o+7YjkZA8aAMWAMGAPGgDGwQBiwYnSBbLQt0xhYeAzYio0BY8AYMAbmAgNWjM6FXbIcjQFjwBgwBowBY8AY6GcGppCbFaNTIM+GGgPGgDFgDBgDxoAxYAxMjQErRqfGn402BoyBhceArdgYMAaMAWOghwxYMdpDMi2UMWAMGAPGgDFgDBgDxsDEGOhejE4slnkbA8aAMWAMGAPGgDFgDBgDE2LAitEJ0WXOxoAxYAxMHwMW2RgwBoyBhciAFaMLcddtzcaAMWAMGAPGgDFgDPQJA7NUjPbJ6i0NY8AYMAaMAWPAGDAGjIFZZcCK0Vml3yY3BowBY2AGGLApjAFjwBjoYwasGO3jzbHUjAFjwBgwBowBY8AYmO8MzLdidL7vl63PGDAGjAFjwBgwBoyBecWAFaPzajttMcaAMWAMzCQDNpcxYAwYA1NnwIrRqXNoEYwBY8AYMAaMAWPAGDAGJsmAFaPjJM7cjAFjwBgwBowBY8AYMAZ6z4AVo73n1CIaA8aAMWAMTI0BG20MGAMLiAErRhfQZttSjQFjwBgwBowBY8AY6DcGrBid7R2x+Y0BY8AYMAaMAWPAGFjADFgxuoA335ZuDBgDxsBCY8DWawwYA/3HgBWj/bcnlpExYAwYA8aAMWAMGAMLhgErRuftVtvCjAFjwBgwBowBY8AY6H8GrBjt/z2yDI0BY8AYMAb6nQHLzxgwBibNgBWjk6bOBhoDxoAxYAwYA8aAMWAMTJUBK0anyuDCG28rNgaMAWPAGDAGjAFjoGcMWDHaMyotkDFgDBgDxoAx0GsGLJ4xMP8ZsGJ0/u+xrdAYMAaMAWPAGDAGjIG+ZcCK0b7dmoWXmK3YGDAGjAFjwBgwBhYeA1aMLrw9txUbA8aAMWAMGAPGgDHQNwxYMdo3W2GJGAPGgDFgDBgDxoAxsPAYsGJ04e35wluxrdgYMAaMAWPAGDAG+pYBK0b7dmssMWPAGDAGjAFjYO4xYBkbAxNlwIrRiTJm/saAMWAMGAPGgDFgDBgDPWPAitGeUWmBFh4DtmJjwBgwBowBY8AYmCoDVoxOlUEbbwwYA8aAMWAMGAPTz4DNMG8ZsGJ03m6tLcwYMAaMAWPAGDAGjIH+Z8CK0f7fI8tw4TFgKzYGjAFjwBgwBhYMA1aMLpittoUaA8aAMWAMGAPGwFgGzDLbDFgxOts7YPMbA8aAMWAMGAPGgDGwgBmwYnQBb74tfeExYCs2BowBY8AYMAb6jQErRvttRywfY8AYMAaMAWPAGJgPDNgaxsmAFaPjJMrcjAFjwBgwBowBY8AYMAZ6z4AVo73n1CIaAwuPAVuxMWAMGAPGgDEwSQasGJ0kcTbMGDAGjAFjwBgwBoyB2WBgvs1pxeh821FbjzFgDBgDxoAxYAwYA3OIAStG59BmWarGwMJjwFZsDBgDxoAxMN8ZsGJ0vu+wrc8YMAaMAWPAGDAGjIHxMDBLPlaMzhLxNq0xYAwYA8aAMWAMGAPGgIgVo3YVGAPGwEJkwNZsDBgDxoAx0CcMWDHaJxthaRgDxoAxYAwYA8aAMTA/vM75bwAAACFJREFUGei+KitGu/NjvcaAMWAMGAPGgDFgDBgD08jA/w8AAP//rn2bVgAAAAZJREFUAwA+rDe7ukCKyAAAAABJRU5ErkJggg=='
        />
      </defs>
    </svg>
  );
};

const RepeatIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path d='m17 2 4 4-4 4' />
      <path d='M3 11v-1a4 4 0 0 1 4-4h14' />
      <path d='m7 22-4-4 4-4' />
      <path d='M21 13v1a4 4 0 0 1-4 4H3' />
    </svg>
  );
};
const MessageCircleIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path d='M7.9 20A9 9 0 1 0 4 16.1L2 22Z' />
      <path d='M8 12h.01' />
      <path d='M12 12h.01' />
      <path d='M16 12h.01' />
    </svg>
  );
};
const ShuffleIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      { ' ' }
      <path d='M2 18h1.4c1.3 0 2.5-.6 3.3-1.7l6.1-8.6c.7-1.1 2-1.7 3.3-1.7H22' />
      <path d='m18 2 4 4-4 4' />
      <path d='M2 6h1.9c1.5 0 2.9.9 3.6 2.2' />
      <path d='M22 18h-5.9c-1.3 0-2.6-.7-3.3-1.8l-.5-.8' />
      <path d='m18 14 4 4-4 4' />
    </svg>
  );
};
const HireAssessmentIcons = (props: IconProps) => {
  return (
    <svg
        width='250'
        height='278'
        viewBox='0 0 250 278'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        className={props.className}
    >
      <path
          d='M65.5 1H1V277.5H65.5V171H249.5V106.5H65.5V1Z'
          fill='url(#paint0_linear_603_4551)'
      />
      <path d='M98.5 62V1H249.5V62H98.5Z' fill='url(#paint1_linear_603_4551)' />
      <path
          d='M249.5 214.5H98.5V277.5H249.5V214.5Z'
          fill='url(#paint2_linear_603_4551)'
      />
      <path d='M65.5 1H1V277.5H65.5V171H249.5V106.5H65.5V1Z' stroke='black' />
      <path d='M98.5 62V1H249.5V62H98.5Z' stroke='black' />
      <path d='M249.5 214.5H98.5V277.5H249.5V214.5Z' stroke='black' />
      <defs>
        <linearGradient
            id='paint0_linear_603_4551'
            x1='1'
            y1='1'
            x2='250'
            y2='278'
            gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#29AAE2' />
          <stop offset='1' stopColor='#3BB54A' />
        </linearGradient>
        <linearGradient
            id='paint1_linear_603_4551'
            x1='1'
            y1='1'
            x2='250'
            y2='278'
            gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#29AAE2' />
          <stop offset='1' stopColor='#3BB54A' />
        </linearGradient>
        <linearGradient
            id='paint2_linear_603_4551'
            x1='1'
            y1='1'
            x2='250'
            y2='278'
            gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#29AAE2' />
          <stop offset='1' stopColor='#3BB54A' />
        </linearGradient>
      </defs>
    </svg>
  );
};
const HighlightsIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth={2}
          d='M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z'
      />
    </svg>
  );
};
const QuestionIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth={2}
          d='M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z'
      />
    </svg>
  );
};
const XIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path d='M18 6 6 18' />
      <path d='m6 6 12 12' />
    </svg>
  );
};

const WebsiteIcons = (props: IconProps) => {
  return (
    <svg
        className={props.className}
        width='800px'
        height='800px'
        viewBox='0 0 128 128'
        xmlns='http://www.w3.org/2000/svg'
        aria-hidden='true'
        role='img'
        preserveAspectRatio='xMidYMid meet'
    >
      <radialGradient
          id='IconifyId17ecdb2904d178eab8954'
          cx='65.025'
          cy='5.037'
          r='105.925'
          gradientUnits='userSpaceOnUse'
      >
        <stop offset='.21' stopColor='#01b3f7'></stop>
        <stop offset='.457' stopColor='#01b3f7'></stop>
      </radialGradient>
      <path
          d='M113.28 28.59C98.3 7.63 73.88 5.55 64.05 5.4c-9.5-.14-29.7 3.02-44.46 18.19C8.64 34.84 3.32 48.85 3.52 65.04c.18 14.67 5.21 26.76 14.4 37.78c13.57 16.27 32.85 20.49 46.33 20.49c.38 0 .76 0 1.14-.01c13.14-.35 35.87-4.12 49.44-26.33c6-9.82 9.39-21.26 9.53-32.21c.23-17.66-6.84-30.25-11.08-36.17zm3.9 31.27l-11.5-.03c-.36-8.24-1.77-15.29-3.78-21.3l8.77.03c2.86 5.14 5.8 12.33 6.51 21.3zM10.82 67.6l11.99.03c.48 6.73 1.58 14.21 3.95 21.55h-9.75c-3.66-6.51-5.72-13.68-6.19-21.58zm57.04-55.86c3.54 1.33 13.82 6.04 21.36 18.76l-21.41-.06l.05-18.7zm-7.05.29v18.39l-22.01-.06c8.24-12.98 19.93-17.6 22.01-18.33zm0 26.39v21.31l-30.23-.07c.2-8.44 1.78-15.47 4.13-21.31l26.1.07zM22.52 59.63l-11.61-.03c.69-7.72 3.13-14.89 6.99-21.31l8.13.02c-2.09 6.01-3.45 13.07-3.51 21.32zm8.23 8.02l30.06.07v21.46H35c-2.16-5.87-3.71-12.97-4.25-21.53zm30.06 29.53v19.18c-4.06-1.3-14.65-5.84-22.15-19.18h22.15zm6.86 19.32l.14-19.32H90c-6.85 13.28-17.1 18.07-22.33 19.32zm.14-27.32V67.74l29.63.07c-.35 8.5-1.78 15.54-3.84 21.37H67.81zm0-29.44v-21.3l25.36.07c2.28 5.83 3.88 12.85 4.26 21.3l-29.62-.07zm37.48-29.19l-6.69-.02c-2.43-4.89-5.22-8.85-7.98-12.03c5.18 2.75 10.29 6.62 14.67 12.05zM37.5 18.97a55.794 55.794 0 0 0-7.99 11.35l-5.78-.02c.69-.79 1.4-1.57 2.13-2.33c3.7-3.78 7.66-6.73 11.64-9zM23.43 98.15c-.28-.32-.55-.65-.83-.97h7.33c2.14 4.47 4.88 8.74 8.38 12.6c-5.37-2.88-10.55-6.73-14.88-11.63zm67.06 12.18c3-3.65 6.72-8.09 8.78-13.15h6.52c-4.04 5.09-10.33 10.34-15.3 13.15zm20.47-21.15h-8.67c2.24-7.35 3.16-14.78 3.41-21.35l11.51.03c-.68 9.13-3.63 16.39-6.25 21.32z'
          fill='url(#IconifyId17ecdb2904d178eab8954)'
      ></path>
      <path fill='#188aff' d='M93.65 39.75l-25.85-.08l.01-2.5l24.93.12z'></path>
      <path
          fill='#188aff'
          d='M60.81 39.65l-26.58-.06l.95-2.47l25.63.03z'
      ></path>
      <path
          fill='#188aff'
          d='M60.81 68.96l-29.98-.05l-.19-2.51l30.17.06z'
      ></path>
      <path fill='#188aff' d='M97.39 69.03l-29.58-.06v-2.5l29.7.11z'></path>
      <path
          fill='#188aff'
          d='M117.09 69.08l-11.46.01l.11-2.52l11.58.03z'
      ></path>
      <path fill='#188aff' d='M111.3 39.72l-8.99.05l-.8-2.42l8.56.06z'></path>
      <path
          fill='#188aff'
          d='M60.81 98.41l-21.44-.01l-1.4-2.34l22.88-.14z'
      ></path>
      <path fill='#188aff' d='M89.37 98.34l-21.58.07l.02-2.5l22.85.07z'></path>
      <path
          fill='#188aff'
          d='M30.52 98.36l-6.79.12l-2.01-2.28l7.81-.01z'
      ></path>
      <path fill='#188aff' d='M22.89 68.86l-12-.01l-.18-2.51l12.04.06z'></path>
      <path
          fill='#188aff'
          d='M25.62 39.55l-8.44-.04l1.38-2.43l7.89-.02z'
      ></path>
      <path fill='#188aff' d='M104.73 98.46l-6.02-.05l1.06-2.36l6.9.04z'></path>
      <path
          d='M38.84 30.31l.01-.09c.2-.29 3.45-7.47 9.64-12.71c6.29-5.33 12.12-6.93 12.37-7l-.05 2.65c-.06.02-5.2 1.31-11.16 6.11c-7.02 5.65-10.76 10.98-10.81 11.04z'
          fill='#188aff'
      ></path>
      <path
          d='M89.23 30.51c-.03-.05-2.51-4.47-9.45-10.16c-5.51-4.51-11.86-7.34-11.93-7.37l.03-2.6c.3.12 6.88 2.97 12.52 8.03c6.36 5.7 8.66 11.69 8.78 11.91l.05.19z'
          fill='#188aff'
      ></path>
      <path
          d='M105.27 30.52c-.03-.04-3.38-3.13-7.04-6.05c-3.46-2.77-5.91-3.93-5.95-3.96l-2.54-3.11c.2.1 5.83 2.92 9.4 6.02c3.53 3.07 5.94 6.8 6.06 6.95l.07.15z'
          fill='#188aff'
      ></path>
      <path
          d='M23.74 30.3l.03-.1c.11-.13 2.1-3.23 5.56-6.46c4.21-3.92 8.89-5.73 9.05-5.82l-2.24 2.6c-.04.02-1.8.64-6.19 4.17c-3.5 2.82-6.18 5.58-6.21 5.61z'
          fill='#188aff'
      ></path>
      <path
          d='M64.11 124.55c-41.05 0-54.65-34.41-54.79-34.75l.12.24c.14.33 15.32 32.01 54.67 32.01h.13c21.16-.04 34.42-8.85 41.83-16.24c8.05-8.03 12.3-15.49 12.33-15.57l.05-.1c-.13.34-11.93 34.33-54.2 34.41h-.14z'
          fill='#188aff'
      ></path>
    </svg>
  );
};

const CandiBankEmptySearchIcons = (props: IconProps) => {
  return (
    <svg
        width='160'
        height='140'
        viewBox='0 0 160 140'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        className={props.className}
    >
      { /* Background circle */ }
      <circle cx='80' cy='72' r='56' fill='#F1F5F9' />

      { /* Person silhouette */ }
      <circle cx='80' cy='54' r='16' fill='#CBD5E1' />
      <path
          d='M50 100c0-16.569 13.431-30 30-30s30 13.431 30 30'
          stroke='#CBD5E1'
          strokeWidth='12'
          strokeLinecap='round'
          fill='none'
      />

      { /* Animated magnifying glass */ }
      <g style={{ transformOrigin: '112px 88px' }}>
        <style>{ `
                      @keyframes swingSearch {
                        0%   { transform: rotate(-12deg); }
                        50%  { transform: rotate(12deg); }
                        100% { transform: rotate(-12deg); }
                      }
                      .search-swing { animation: swingSearch 2.4s ease-in-out infinite; }
                      @keyframes pulseDot {
                        0%, 100% { opacity: 1; }
                        50%       { opacity: 0.3; }
                      }
                      .dot1 { animation: pulseDot 1.4s ease-in-out infinite 0s; }
                      .dot2 { animation: pulseDot 1.4s ease-in-out infinite 0.2s; }
                      .dot3 { animation: pulseDot 1.4s ease-in-out infinite 0.4s; }
                    ` }</style>
        <g className='search-swing'>
          <circle
              cx='112'
              cy='80'
              r='18'
              stroke='#6366F1'
              strokeWidth='5'
              fill='white'
          />
          <line
              x1='124.7'
              y1='92.7'
              x2='136'
              y2='104'
              stroke='#6366F1'
              strokeWidth='5'
              strokeLinecap='round'
          />
        </g>
      </g>

      { /* Animated dots below */ }
      <circle className='dot1' cx='71' cy='128' r='4' fill='#6366F1' />
      <circle className='dot2' cx='80' cy='128' r='4' fill='#6366F1' />
      <circle className='dot3' cx='89' cy='128' r='4' fill='#6366F1' />
    </svg>
  );
};
const LinkedInIcons = (props: IconProps) => {
  return (
    <svg
        width='800px'
        height='800px'
        viewBox='0 0 32 32'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        className={props.className}
    >
      <rect x='2' y='2' width='28' height='28' rx='14' fill='#1275B1' />
      <path
          d='M12.6186 9.69215C12.6186 10.6267 11.8085 11.3843 10.8093 11.3843C9.81004 11.3843 9 10.6267 9 9.69215C9 8.7576 9.81004 8 10.8093 8C11.8085 8 12.6186 8.7576 12.6186 9.69215Z'
          fill='white'
      />
      <path d='M9.24742 12.6281H12.3402V22H9.24742V12.6281Z' fill='white' />
      <path
          d='M17.3196 12.6281H14.2268V22H17.3196C17.3196 22 17.3196 19.0496 17.3196 17.2049C17.3196 16.0976 17.6977 14.9855 19.2062 14.9855C20.911 14.9855 20.9008 16.4345 20.8928 17.5571C20.8824 19.0244 20.9072 20.5219 20.9072 22H24V17.0537C23.9738 13.8954 23.1508 12.4401 20.4433 12.4401C18.8354 12.4401 17.8387 13.1701 17.3196 13.8305V12.6281Z'
          fill='white'
      />
    </svg>
  );
};
const GitHubIcons = (props: IconProps) => {
  return (
    <svg
        width='800px'
        height='800px'
        viewBox='0 0 20 20'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        className={props.className}
    >
      <g
          id='Page-1'
          stroke='none'
          strokeWidth='1'
          fill='none'
          fillRule='evenodd'
      >
        <g
            id='Dribbble-Light-Preview'
            transform='translate(-140.000000, -7559.000000)'
            fill='#000000'
        >
          <g id='icons' transform='translate(56.000000, 160.000000)'>
            <path
                d='M94,7399 C99.523,7399 104,7403.59 104,7409.253 C104,7413.782 101.138,7417.624 97.167,7418.981 C96.66,7419.082 96.48,7418.762 96.48,7418.489 C96.48,7418.151 96.492,7417.047 96.492,7415.675 C96.492,7414.719 96.172,7414.095 95.813,7413.777 C98.04,7413.523 100.38,7412.656 100.38,7408.718 C100.38,7407.598 99.992,7406.684 99.35,7405.966 C99.454,7405.707 99.797,7404.664 99.252,7403.252 C99.252,7403.252 98.414,7402.977 96.505,7404.303 C95.706,7404.076 94.85,7403.962 94,7403.958 C93.15,7403.962 92.295,7404.076 91.497,7404.303 C89.586,7402.977 88.746,7403.252 88.746,7403.252 C88.203,7404.664 88.546,7405.707 88.649,7405.966 C88.01,7406.684 87.619,7407.598 87.619,7408.718 C87.619,7412.646 89.954,7413.526 92.175,7413.785 C91.889,7414.041 91.63,7414.493 91.54,7415.156 C90.97,7415.418 89.522,7415.871 88.63,7414.304 C88.63,7414.304 88.101,7413.319 87.097,7413.247 C87.097,7413.247 86.122,7413.234 87.029,7413.87 C87.029,7413.87 87.684,7414.185 88.139,7415.37 C88.139,7415.37 88.726,7417.2 91.508,7416.58 C91.513,7417.437 91.522,7418.245 91.522,7418.489 C91.522,7418.76 91.338,7419.077 90.839,7418.982 C86.865,7417.627 84,7413.783 84,7409.253 C84,7403.59 88.478,7399 94,7399'
                id='github-[#142]'
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
};

const NewUserIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path d='M2 21a8 8 0 0 1 13.292-6' />
      <circle cx='10' cy='8' r='5' />
      <path d='M19 16v6' />
      <path d='M22 19h-6' />
    </svg>
  );
};

// Toolbar Icons
const ToolbarChevronDownIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path d='M19 9l-7 7-7-7' />
    </svg>
  );
};

const ToolbarCheckCircleIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path d='M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z' />
    </svg>
  );
};

const ToolbarClearIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path d='M6 18L18 6M6 6l12 12' />
    </svg>
  );
};

const ToolbarMailIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path d='M3 8l7.89 3.26a2 2 0 001.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z' />
    </svg>
  );
};

const ToolbarExportIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path d='M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z' />
    </svg>
  );
};

const ToolbarSearchIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path d='M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z' />
    </svg>
  );
};

const ToolbarListIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path d='M4 6h16M4 10h16M4 14h16M4 18h16' />
    </svg>
  );
};

const SquareCheckIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <rect width='18' height='18' x='3' y='3' rx='2' />
      <path d='m9 12 2 2 4-4' />
    </svg>
  );
};

const FolderIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path d='M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z' />
    </svg>
  );
};

const FolderPlusIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path d='M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z' />
      <path d='M12 10v6' />
      <path d='M9 13h6' />
    </svg>
  );
};

const TrashIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path d='M3 6h18' />
      <path d='M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6' />
      <path d='M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2' />
    </svg>
  );
};

const PencilIcons = (props: IconProps) => {
  return (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={props.className}
    >
      <path d='M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z' />
    </svg>
  );
};

export {
  MicIcons,
  TestNoteIcons,
  LinkedinIcons,
  FacebookIcons,
  OfficeIcons,
  LightningIcons,
  HomeIcons,
  UploadIcons,
  HireAssessmentIcons,
  NotebookIcons,
  TargetIcons,
  TrendingUpIcons,
  MoonIcons,
  ThreeDIcons,
  SquigglyGridIcons,
  BriefcaseBusinessIcon,
  UsersIcons,
  CircleCheckIcons,
  StarIcons,
  ClipBoardIcons,
  HireTalentIcons,
  CalendarClockIcons,
  AddCircleIcons,
  SubtractCircleIcons,
  FilterIcons,
  SearchIcons,
  ArrowUpIcons,
  ChevronDownIcons,
  PaperClipIcons,
  LinkIcons,
  ImageIcons,
  BoldIcons,
  ItalicIcons,
  UnderlineIcons,
  StrikethroughIcons,
  NumberListIcons,
  ListIcons,
  BellIcons,
  SettingsIcons,
  RefreshListIcons,
  MorevertIcons,
  FileQuestionIcons,
  DashboardIcons,
  ChartIcons,
  FilePlusIcons,
  AlignLeftIcons,
  MegaPhoneIcons,
  SparklesIcons,
  BadgeCheckIcons,
  SlidersHorizontalIcons,
  FileDownIcons,
  ShieldAlertIcons,
  ListCheckIcons,
  GanttChartIcons,
  BuildingIcons,
  PiramidIcons,
  TableIcons,
  LayoutGridIcons,
  ShieldIcons,
  HandShakeIcons,
  UserCheckIcons,
  EyeIcons,
  EyeOffIcons,
  ComponentsIcons,
  CommandIcons,
  UserSquareIcons,
  LayersIcons,
  UserMinusIcons,
  EmailIcons,
  MapPinIcons,
  VideoIcons,
  UserPenIcons,
  SunIcons,
  TagIcons,
  ClockIcons,
  InfoIcons,
  ShuffleIcons,
  MessageCircleIcons,
  RepeatIcons,
  CircleXIcons,
  HighlightsIcons,
  QuestionIcons,
  XIcons,
  PhoneIcons,
  WebsiteIcons,
  LinkedInIcons,
  GitHubIcons,
  NewUserIcons,
  BarMenuIcons,
  ToolbarChevronDownIcons,
  ToolbarCheckCircleIcons,
  ToolbarClearIcons,
  ToolbarMailIcons,
  ToolbarExportIcons,
  ToolbarSearchIcons,
  ToolbarListIcons,
  MagicIcons,
  SquareCheckIcons,
  CandiBankEmptySearchIcons,
  BrainIcon,
  FolderIcons,
  FolderPlusIcons,
  TrashIcons,
  PencilIcons,
};
